/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: string; output: string; }
  /** A calendar date in YYYY-MM-DD format. */
  Date: { input: string; output: string; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: string; output: string; }
  /** Represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: string; output: string; }
};

/** Money moved between two accounts (cash deposited at the bank, withdrawal). Its two operations are created and kept in sync automatically. */
export type AccountTransfer = {
  __typename?: 'AccountTransfer';
  amount: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `BankStatementLine`. */
  bankStatementLinesByMatchedTransferId: BankStatementLineConnection;
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperationsByTransferId: FinancialOperationConnection;
  /** Reads a single `FinancialAccount` that is related to this `AccountTransfer`. */
  fromAccount: Maybe<FinancialAccount>;
  fromAccountId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  needsReview: Scalars['Boolean']['output'];
  /** Reads a single `Photo` that is related to this `AccountTransfer`. */
  receiptPhoto: Maybe<Photo>;
  receiptPhotoId: Maybe<Scalars['UUID']['output']>;
  reviewNote: Maybe<Scalars['String']['output']>;
  /** Set automatically when needsReview changes. */
  reviewRequestedAt: Maybe<Scalars['Datetime']['output']>;
  /** Set automatically when needsReview changes. */
  reviewRequestedBy: Maybe<Scalars['String']['output']>;
  /** Set automatically when needsReview changes. */
  reviewedAt: Maybe<Scalars['Datetime']['output']>;
  /** Set automatically when needsReview changes. */
  reviewedBy: Maybe<Scalars['String']['output']>;
  /** Reads a single `FinancialAccount` that is related to this `AccountTransfer`. */
  toAccount: Maybe<FinancialAccount>;
  toAccountId: Scalars['UUID']['output'];
};


/** Money moved between two accounts (cash deposited at the bank, withdrawal). Its two operations are created and kept in sync automatically. */
export type AccountTransferBankStatementLinesByMatchedTransferIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementLineCondition>;
  filter?: InputMaybe<BankStatementLineFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementLineOrderBy>>;
};


/** Money moved between two accounts (cash deposited at the bank, withdrawal). Its two operations are created and kept in sync automatically. */
export type AccountTransferFinancialOperationsByTransferIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};

/**
 * A condition to be used against `AccountTransfer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountTransferCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fromAccountId` field. */
  fromAccountId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `needsReview` field. */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `receiptPhotoId` field. */
  receiptPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reviewedAt` field. */
  reviewedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `toAccountId` field. */
  toAccountId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `AccountTransfer` values. */
export type AccountTransferConnection = {
  __typename?: 'AccountTransferConnection';
  /** A list of edges which contains the `AccountTransfer` and cursor to aid in pagination. */
  edges: Array<Maybe<AccountTransferEdge>>;
  /** A list of `AccountTransfer` objects. */
  nodes: Array<Maybe<AccountTransfer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountTransfer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AccountTransfer` edge in the connection. */
export type AccountTransferEdge = {
  __typename?: 'AccountTransferEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountTransfer` at the end of the edge. */
  node: Maybe<AccountTransfer>;
};

/** A filter to be used against `AccountTransfer` object types. All fields are combined with a logical ‘and.’ */
export type AccountTransferFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountTransferFilter>>;
  /** Filter by the object’s `bankStatementLinesByMatchedTransferId` relation. */
  bankStatementLinesByMatchedTransferId?: InputMaybe<AccountTransferToManyBankStatementLineFilter>;
  /** Some related `bankStatementLinesByMatchedTransferId` exist. */
  bankStatementLinesByMatchedTransferIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `financialOperationsByTransferId` relation. */
  financialOperationsByTransferId?: InputMaybe<AccountTransferToManyFinancialOperationFilter>;
  /** Some related `financialOperationsByTransferId` exist. */
  financialOperationsByTransferIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fromAccount` relation. */
  fromAccount?: InputMaybe<FinancialAccountFilter>;
  /** Filter by the object’s `fromAccountId` field. */
  fromAccountId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `needsReview` field. */
  needsReview?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountTransferFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountTransferFilter>>;
  /** Filter by the object’s `receiptPhoto` relation. */
  receiptPhoto?: InputMaybe<PhotoFilter>;
  /** A related `receiptPhoto` exists. */
  receiptPhotoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `receiptPhotoId` field. */
  receiptPhotoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewedAt` field. */
  reviewedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toAccount` relation. */
  toAccount?: InputMaybe<FinancialAccountFilter>;
  /** Filter by the object’s `toAccountId` field. */
  toAccountId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `AccountTransfer` */
export type AccountTransferInput = {
  amount: Scalars['BigFloat']['input'];
  date: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  fromAccountId: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  receiptPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  toAccountId: Scalars['UUID']['input'];
};

/** Methods to use when ordering `AccountTransfer`. */
export type AccountTransferOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'FROM_ACCOUNT_ID_ASC'
  | 'FROM_ACCOUNT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NEEDS_REVIEW_ASC'
  | 'NEEDS_REVIEW_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECEIPT_PHOTO_ID_ASC'
  | 'RECEIPT_PHOTO_ID_DESC'
  | 'REVIEWED_AT_ASC'
  | 'REVIEWED_AT_DESC'
  | 'REVIEWED_BY_ASC'
  | 'REVIEWED_BY_DESC'
  | 'REVIEW_NOTE_ASC'
  | 'REVIEW_NOTE_DESC'
  | 'REVIEW_REQUESTED_AT_ASC'
  | 'REVIEW_REQUESTED_AT_DESC'
  | 'REVIEW_REQUESTED_BY_ASC'
  | 'REVIEW_REQUESTED_BY_DESC'
  | 'TO_ACCOUNT_ID_ASC'
  | 'TO_ACCOUNT_ID_DESC';

/** Represents an update to a `AccountTransfer`. Fields that are set will be updated. */
export type AccountTransferPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fromAccountId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  receiptPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  toAccountId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against many `BankStatementLine` object types. All fields are combined with a logical ‘and.’ */
export type AccountTransferToManyBankStatementLineFilter = {
  /** Every related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BankStatementLineFilter>;
  /** No related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BankStatementLineFilter>;
  /** Some related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BankStatementLineFilter>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type AccountTransferToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

export type AppBulkPaymentResult = {
  __typename?: 'AppBulkPaymentResult';
  billIds: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  errors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  failedCount: Maybe<Scalars['Int']['output']>;
  paymentIds: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  processedCount: Maybe<Scalars['Int']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

/** All input for the `appBulkSavePayments` mutation. */
export type AppBulkSavePaymentsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payments: Scalars['JSON']['input'];
};

/** The output of our `appBulkSavePayments` mutation. */
export type AppBulkSavePaymentsPayload = {
  __typename?: 'AppBulkSavePaymentsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<AppBulkPaymentResult>;
};

/** All input for the `appChangeMemberStatus` mutation. */
export type AppChangeMemberStatusInput = {
  changedOn?: InputMaybe<Scalars['Date']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
  status: MemberStatus;
};

/** The output of our `appChangeMemberStatus` mutation. */
export type AppChangeMemberStatusPayload = {
  __typename?: 'AppChangeMemberStatusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge: Maybe<MemberEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Member>;
};


/** The output of our `appChangeMemberStatus` mutation. */
export type AppChangeMemberStatusPayloadMemberEdgeArgs = {
  orderBy?: Array<MemberOrderBy>;
};

/** All input for the `appChangeMeterStatus` mutation. */
export type AppChangeMeterStatusInput = {
  changedOn?: InputMaybe<Scalars['Date']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  meterId: Scalars['UUID']['input'];
  reading?: InputMaybe<Scalars['Int']['input']>;
  reason: Scalars['String']['input'];
  replacedBy?: InputMaybe<Scalars['UUID']['input']>;
  status: MeterStatus;
};

/** The output of our `appChangeMeterStatus` mutation. */
export type AppChangeMeterStatusPayload = {
  __typename?: 'AppChangeMeterStatusPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** An edge for our `Meter`. May be used by Relay 1. */
  meterEdge: Maybe<MeterEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Meter>;
};


/** The output of our `appChangeMeterStatus` mutation. */
export type AppChangeMeterStatusPayloadMeterEdgeArgs = {
  orderBy?: Array<MeterOrderBy>;
};

/** All input for the `appCloseBankStatement` mutation. */
export type AppCloseBankStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  statementId: Scalars['UUID']['input'];
};

/** The output of our `appCloseBankStatement` mutation. */
export type AppCloseBankStatementPayload = {
  __typename?: 'AppCloseBankStatementPayload';
  /** An edge for our `BankStatement`. May be used by Relay 1. */
  bankStatementEdge: Maybe<BankStatementEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BankStatement>;
};


/** The output of our `appCloseBankStatement` mutation. */
export type AppCloseBankStatementPayloadBankStatementEdgeArgs = {
  orderBy?: Array<BankStatementOrderBy>;
};

/** All input for the `appCreateOperationFromLine` mutation. */
export type AppCreateOperationFromLineInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lineId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
};

/** The output of our `appCreateOperationFromLine` mutation. */
export type AppCreateOperationFromLinePayload = {
  __typename?: 'AppCreateOperationFromLinePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** An edge for our `FinancialOperation`. May be used by Relay 1. */
  financialOperationEdge: Maybe<FinancialOperationEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<FinancialOperation>;
};


/** The output of our `appCreateOperationFromLine` mutation. */
export type AppCreateOperationFromLinePayloadFinancialOperationEdgeArgs = {
  orderBy?: Array<FinancialOperationOrderBy>;
};

/** All input for the `appCreateTransferFromLine` mutation. */
export type AppCreateTransferFromLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  lineId: Scalars['UUID']['input'];
  otherAccountId: Scalars['UUID']['input'];
};

/** The output of our `appCreateTransferFromLine` mutation. */
export type AppCreateTransferFromLinePayload = {
  __typename?: 'AppCreateTransferFromLinePayload';
  /** An edge for our `AccountTransfer`. May be used by Relay 1. */
  accountTransferEdge: Maybe<AccountTransferEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<AccountTransfer>;
};


/** The output of our `appCreateTransferFromLine` mutation. */
export type AppCreateTransferFromLinePayloadAccountTransferEdgeArgs = {
  orderBy?: Array<AccountTransferOrderBy>;
};

/** All input for the `appDeleteBillingConfiguration` mutation. */
export type AppDeleteBillingConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['Int']['input'];
};

/** The output of our `appDeleteBillingConfiguration` mutation. */
export type AppDeleteBillingConfigurationPayload = {
  __typename?: 'AppDeleteBillingConfigurationPayload';
  /** An edge for our `BillingConfiguration`. May be used by Relay 1. */
  billingConfigurationEdge: Maybe<BillingConfigurationEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BillingConfiguration>;
};


/** The output of our `appDeleteBillingConfiguration` mutation. */
export type AppDeleteBillingConfigurationPayloadBillingConfigurationEdgeArgs = {
  orderBy?: Array<BillingConfigurationOrderBy>;
};

/** All input for the `appFlagForReview` mutation. */
export type AppFlagForReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  kind: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

/** The output of our `appFlagForReview` mutation. */
export type AppFlagForReviewPayload = {
  __typename?: 'AppFlagForReviewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Scalars['Boolean']['output']>;
};

/** All input for the `appGrantMemberCredit` mutation. */
export type AppGrantMemberCreditInput = {
  amount: Scalars['BigFloat']['input'];
  billId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};

/** The output of our `appGrantMemberCredit` mutation. */
export type AppGrantMemberCreditPayload = {
  __typename?: 'AppGrantMemberCreditPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge: Maybe<MemberEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Member>;
};


/** The output of our `appGrantMemberCredit` mutation. */
export type AppGrantMemberCreditPayloadMemberEdgeArgs = {
  orderBy?: Array<MemberOrderBy>;
};

/** All input for the `appIgnoreStatementLine` mutation. */
export type AppIgnoreStatementLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ignored: Scalars['Boolean']['input'];
  lineId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `appIgnoreStatementLine` mutation. */
export type AppIgnoreStatementLinePayload = {
  __typename?: 'AppIgnoreStatementLinePayload';
  /** An edge for our `BankStatementLine`. May be used by Relay 1. */
  bankStatementLineEdge: Maybe<BankStatementLineEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BankStatementLine>;
};


/** The output of our `appIgnoreStatementLine` mutation. */
export type AppIgnoreStatementLinePayloadBankStatementLineEdgeArgs = {
  orderBy?: Array<BankStatementLineOrderBy>;
};

/** All input for the `appImportBankStatement` mutation. */
export type AppImportBankStatementInput = {
  accountId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  closingBalance: Scalars['BigFloat']['input'];
  documentPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  lines: Scalars['JSON']['input'];
  openingBalance: Scalars['BigFloat']['input'];
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
};

/** The output of our `appImportBankStatement` mutation. */
export type AppImportBankStatementPayload = {
  __typename?: 'AppImportBankStatementPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BankStatementImport>;
};

/** All input for the `appMatchStatementLine` mutation. */
export type AppMatchStatementLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineId: Scalars['UUID']['input'];
  operationId?: InputMaybe<Scalars['UUID']['input']>;
  transferId?: InputMaybe<Scalars['UUID']['input']>;
};

/** The output of our `appMatchStatementLine` mutation. */
export type AppMatchStatementLinePayload = {
  __typename?: 'AppMatchStatementLinePayload';
  /** An edge for our `BankStatementLine`. May be used by Relay 1. */
  bankStatementLineEdge: Maybe<BankStatementLineEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BankStatementLine>;
};


/** The output of our `appMatchStatementLine` mutation. */
export type AppMatchStatementLinePayloadBankStatementLineEdgeArgs = {
  orderBy?: Array<BankStatementLineOrderBy>;
};

/** All input for the `appRecordReminder` mutation. */
export type AppRecordReminderInput = {
  channel: NotifyChannel;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['UUID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `appRecordReminder` mutation. */
export type AppRecordReminderPayload = {
  __typename?: 'AppRecordReminderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<NotificationEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Notification>;
};


/** The output of our `appRecordReminder` mutation. */
export type AppRecordReminderPayloadNotificationEdgeArgs = {
  orderBy?: Array<NotificationOrderBy>;
};

/** All input for the `appRenameBillingConfiguration` mutation. */
export type AppRenameBillingConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  configId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** The output of our `appRenameBillingConfiguration` mutation. */
export type AppRenameBillingConfigurationPayload = {
  __typename?: 'AppRenameBillingConfigurationPayload';
  /** An edge for our `BillingConfiguration`. May be used by Relay 1. */
  billingConfigurationEdge: Maybe<BillingConfigurationEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BillingConfiguration>;
};


/** The output of our `appRenameBillingConfiguration` mutation. */
export type AppRenameBillingConfigurationPayloadBillingConfigurationEdgeArgs = {
  orderBy?: Array<BillingConfigurationOrderBy>;
};

/** All input for the `appReopenBankStatement` mutation. */
export type AppReopenBankStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  statementId: Scalars['UUID']['input'];
};

/** The output of our `appReopenBankStatement` mutation. */
export type AppReopenBankStatementPayload = {
  __typename?: 'AppReopenBankStatementPayload';
  /** An edge for our `BankStatement`. May be used by Relay 1. */
  bankStatementEdge: Maybe<BankStatementEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BankStatement>;
};


/** The output of our `appReopenBankStatement` mutation. */
export type AppReopenBankStatementPayloadBankStatementEdgeArgs = {
  orderBy?: Array<BankStatementOrderBy>;
};

/** All input for the `appSaveBillingConfiguration` mutation. */
export type AppSaveBillingConfigurationInput = {
  billingMethod: BillingMethodType;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom: Scalars['Date']['input'];
  fees?: InputMaybe<Array<InputMaybe<BillingFeeInput>>>;
  name: Scalars['String']['input'];
  shartUnitPrice?: InputMaybe<Scalars['BigFloat']['input']>;
  tiers: Array<InputMaybe<BillingTierInput>>;
};

/** The output of our `appSaveBillingConfiguration` mutation. */
export type AppSaveBillingConfigurationPayload = {
  __typename?: 'AppSaveBillingConfigurationPayload';
  /** An edge for our `BillingConfiguration`. May be used by Relay 1. */
  billingConfigurationEdge: Maybe<BillingConfigurationEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BillingConfiguration>;
};


/** The output of our `appSaveBillingConfiguration` mutation. */
export type AppSaveBillingConfigurationPayloadBillingConfigurationEdgeArgs = {
  orderBy?: Array<BillingConfigurationOrderBy>;
};

/** All input for the `appSaveConsumptionBill` mutation. */
export type AppSaveConsumptionBillInput = {
  billId?: InputMaybe<Scalars['UUID']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  meterId: Scalars['UUID']['input'];
  period: Scalars['Date']['input'];
  photoId?: InputMaybe<Scalars['UUID']['input']>;
  reading: Scalars['Int']['input'];
};

/** The output of our `appSaveConsumptionBill` mutation. */
export type AppSaveConsumptionBillPayload = {
  __typename?: 'AppSaveConsumptionBillPayload';
  /** An edge for our `Bill`. May be used by Relay 1. */
  billEdge: Maybe<BillEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Bill>;
};


/** The output of our `appSaveConsumptionBill` mutation. */
export type AppSaveConsumptionBillPayloadBillEdgeArgs = {
  orderBy?: Array<BillOrderBy>;
};

/** All input for the `appSavePayment` mutation. */
export type AppSavePaymentInput = {
  amount: Scalars['BigFloat']['input'];
  billId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `appSavePayment` mutation. */
export type AppSavePaymentPayload = {
  __typename?: 'AppSavePaymentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge: Maybe<PaymentEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Payment>;
};


/** The output of our `appSavePayment` mutation. */
export type AppSavePaymentPayloadPaymentEdgeArgs = {
  orderBy?: Array<PaymentOrderBy>;
};

/** All input for the `appSendInvoiceWhatsapp` mutation. */
export type AppSendInvoiceWhatsappInput = {
  billId: Scalars['UUID']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `appSendInvoiceWhatsapp` mutation. */
export type AppSendInvoiceWhatsappPayload = {
  __typename?: 'AppSendInvoiceWhatsappPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<WhatsappMessage>;
  /** An edge for our `WhatsappMessage`. May be used by Relay 1. */
  whatsappMessageEdge: Maybe<WhatsappMessageEdge>;
};


/** The output of our `appSendInvoiceWhatsapp` mutation. */
export type AppSendInvoiceWhatsappPayloadWhatsappMessageEdgeArgs = {
  orderBy?: Array<WhatsappMessageOrderBy>;
};

/** All input for the `appSendMonthInvoices` mutation. */
export type AppSendMonthInvoicesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['Date']['input'];
};

/** The output of our `appSendMonthInvoices` mutation. */
export type AppSendMonthInvoicesPayload = {
  __typename?: 'AppSendMonthInvoicesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<WhatsappSendResult>;
};

/** All input for the `appSetReview` mutation. */
export type AppSetReviewInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<InputMaybe<Scalars['UUID']['input']>>;
  kind: Scalars['String']['input'];
  needsReview: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `appSetReview` mutation. */
export type AppSetReviewPayload = {
  __typename?: 'AppSetReviewPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Scalars['Int']['output']>;
};

/** All input for the `appUnmatchStatementLine` mutation. */
export type AppUnmatchStatementLineInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineId: Scalars['UUID']['input'];
};

/** The output of our `appUnmatchStatementLine` mutation. */
export type AppUnmatchStatementLinePayload = {
  __typename?: 'AppUnmatchStatementLinePayload';
  /** An edge for our `BankStatementLine`. May be used by Relay 1. */
  bankStatementLineEdge: Maybe<BankStatementLineEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<BankStatementLine>;
};


/** The output of our `appUnmatchStatementLine` mutation. */
export type AppUnmatchStatementLinePayloadBankStatementLineEdgeArgs = {
  orderBy?: Array<BankStatementLineOrderBy>;
};

/** All input for the `appUpdateFinancialOperations` mutation. */
export type AppUpdateFinancialOperationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<InputMaybe<Scalars['UUID']['input']>>;
  patch: Scalars['JSON']['input'];
};

/** The output of our `appUpdateFinancialOperations` mutation. */
export type AppUpdateFinancialOperationsPayload = {
  __typename?: 'AppUpdateFinancialOperationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  result: Maybe<Scalars['Int']['output']>;
};

/** The association's documents: founding texts, legal papers, minutes, reports, correspondence, agreements, contracts, technical files. Files in associationDocumentFiles. */
export type AssociationDocument = {
  __typename?: 'AssociationDocument';
  /** Reads and enables pagination through a set of `AssociationDocumentFile`. */
  associationDocumentFilesByDocumentId: AssociationDocumentFileConnection;
  /** Reads and enables pagination through a set of `AssociationDocument`. */
  associationDocumentsByRepliedById: AssociationDocumentConnection;
  /** Reads a single `Counterparty` that is related to this `AssociationDocument`. */
  counterparty: Maybe<Counterparty>;
  /** Sender or recipient (correspondence), partner (agreement), supplier (contract)… */
  counterpartyId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  documentDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  /** Statutes and internal rules: true for the version in force (the latest). */
  isCurrent: Scalars['Boolean']['output'];
  notes: Maybe<Scalars['String']['output']>;
  /** Reads a single `Project` that is related to this `AssociationDocument`. */
  project: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  /** Correspondence: numbered «N/YYYY» per direction and year when left empty; otherwise free (an existing number). */
  reference: Maybe<Scalars['String']['output']>;
  /** Reads a single `AssociationDocument` that is related to this `AssociationDocument`. */
  repliedBy: Maybe<AssociationDocument>;
  /** The document that answered this one. */
  repliedById: Maybe<Scalars['UUID']['output']>;
  /** A reply is expected by this date: listed in the weekly report until repliedById is set. */
  replyDueOn: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  type: AssociationDocumentType;
};


/** The association's documents: founding texts, legal papers, minutes, reports, correspondence, agreements, contracts, technical files. Files in associationDocumentFiles. */
export type AssociationDocumentAssociationDocumentFilesByDocumentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentFileCondition>;
  filter?: InputMaybe<AssociationDocumentFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentFileOrderBy>>;
};


/** The association's documents: founding texts, legal papers, minutes, reports, correspondence, agreements, contracts, technical files. Files in associationDocumentFiles. */
export type AssociationDocumentAssociationDocumentsByRepliedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentCondition>;
  filter?: InputMaybe<AssociationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentOrderBy>>;
};

/**
 * A condition to be used against `AssociationDocument` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AssociationDocumentCondition = {
  /** Checks for equality with the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentDate` field. */
  documentDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `repliedById` field. */
  repliedById?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `replyDueOn` field. */
  replyDueOn?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<AssociationDocumentType>;
};

/** A connection to a list of `AssociationDocument` values. */
export type AssociationDocumentConnection = {
  __typename?: 'AssociationDocumentConnection';
  /** A list of edges which contains the `AssociationDocument` and cursor to aid in pagination. */
  edges: Array<Maybe<AssociationDocumentEdge>>;
  /** A list of `AssociationDocument` objects. */
  nodes: Array<Maybe<AssociationDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssociationDocument` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssociationDocument` edge in the connection. */
export type AssociationDocumentEdge = {
  __typename?: 'AssociationDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `AssociationDocument` at the end of the edge. */
  node: Maybe<AssociationDocument>;
};

/** The files of a document, in order (position): one PDF, or a photo per page. */
export type AssociationDocumentFile = {
  __typename?: 'AssociationDocumentFile';
  /** Reads a single `AssociationDocument` that is related to this `AssociationDocumentFile`. */
  document: Maybe<AssociationDocument>;
  documentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Photo` that is related to this `AssociationDocumentFile`. */
  photo: Maybe<Photo>;
  photoId: Scalars['UUID']['output'];
  position: Scalars['Int']['output'];
};

/**
 * A condition to be used against `AssociationDocumentFile` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AssociationDocumentFileCondition = {
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `photoId` field. */
  photoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `position` field. */
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of `AssociationDocumentFile` values. */
export type AssociationDocumentFileConnection = {
  __typename?: 'AssociationDocumentFileConnection';
  /** A list of edges which contains the `AssociationDocumentFile` and cursor to aid in pagination. */
  edges: Array<Maybe<AssociationDocumentFileEdge>>;
  /** A list of `AssociationDocumentFile` objects. */
  nodes: Array<Maybe<AssociationDocumentFile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AssociationDocumentFile` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AssociationDocumentFile` edge in the connection. */
export type AssociationDocumentFileEdge = {
  __typename?: 'AssociationDocumentFileEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `AssociationDocumentFile` at the end of the edge. */
  node: Maybe<AssociationDocumentFile>;
};

/** A filter to be used against `AssociationDocumentFile` object types. All fields are combined with a logical ‘and.’ */
export type AssociationDocumentFileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssociationDocumentFileFilter>>;
  /** Filter by the object’s `document` relation. */
  document?: InputMaybe<AssociationDocumentFilter>;
  /** Filter by the object’s `documentId` field. */
  documentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssociationDocumentFileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssociationDocumentFileFilter>>;
  /** Filter by the object’s `photo` relation. */
  photo?: InputMaybe<PhotoFilter>;
  /** Filter by the object’s `photoId` field. */
  photoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `position` field. */
  position?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `AssociationDocumentFile` */
export type AssociationDocumentFileInput = {
  documentId: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  photoId: Scalars['UUID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Methods to use when ordering `AssociationDocumentFile`. */
export type AssociationDocumentFileOrderBy =
  | 'DOCUMENT_ID_ASC'
  | 'DOCUMENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PHOTO_ID_ASC'
  | 'PHOTO_ID_DESC'
  | 'POSITION_ASC'
  | 'POSITION_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** Represents an update to a `AssociationDocumentFile`. Fields that are set will be updated. */
export type AssociationDocumentFilePatch = {
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  photoId?: InputMaybe<Scalars['UUID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `AssociationDocument` object types. All fields are combined with a logical ‘and.’ */
export type AssociationDocumentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssociationDocumentFilter>>;
  /** Filter by the object’s `associationDocumentFilesByDocumentId` relation. */
  associationDocumentFilesByDocumentId?: InputMaybe<AssociationDocumentToManyAssociationDocumentFileFilter>;
  /** Some related `associationDocumentFilesByDocumentId` exist. */
  associationDocumentFilesByDocumentIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `associationDocumentsByRepliedById` relation. */
  associationDocumentsByRepliedById?: InputMaybe<AssociationDocumentToManyAssociationDocumentFilter>;
  /** Some related `associationDocumentsByRepliedById` exist. */
  associationDocumentsByRepliedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `counterparty` relation. */
  counterparty?: InputMaybe<CounterpartyFilter>;
  /** A related `counterparty` exists. */
  counterpartyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentDate` field. */
  documentDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isCurrent` field. */
  isCurrent?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssociationDocumentFilter>;
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssociationDocumentFilter>>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reference` field. */
  reference?: InputMaybe<StringFilter>;
  /** Filter by the object’s `repliedBy` relation. */
  repliedBy?: InputMaybe<AssociationDocumentFilter>;
  /** A related `repliedBy` exists. */
  repliedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `repliedById` field. */
  repliedById?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `replyDueOn` field. */
  replyDueOn?: InputMaybe<DateFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<AssociationDocumentTypeFilter>;
};

/** An input for mutations affecting `AssociationDocument` */
export type AssociationDocumentInput = {
  /** Sender or recipient (correspondence), partner (agreement), supplier (contract)… */
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  documentDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Correspondence: numbered «N/YYYY» per direction and year when left empty; otherwise free (an existing number). */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** The document that answered this one. */
  repliedById?: InputMaybe<Scalars['UUID']['input']>;
  /** A reply is expected by this date: listed in the weekly report until repliedById is set. */
  replyDueOn?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
  type: AssociationDocumentType;
};

/** Methods to use when ordering `AssociationDocument`. */
export type AssociationDocumentOrderBy =
  | 'COUNTERPARTY_ID_ASC'
  | 'COUNTERPARTY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ASC'
  | 'CREATED_BY_DESC'
  | 'DOCUMENT_DATE_ASC'
  | 'DOCUMENT_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NOTES_ASC'
  | 'NOTES_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'REFERENCE_ASC'
  | 'REFERENCE_DESC'
  | 'REPLIED_BY_ID_ASC'
  | 'REPLIED_BY_ID_DESC'
  | 'REPLY_DUE_ON_ASC'
  | 'REPLY_DUE_ON_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC';

/** Represents an update to a `AssociationDocument`. Fields that are set will be updated. */
export type AssociationDocumentPatch = {
  /** Sender or recipient (correspondence), partner (agreement), supplier (contract)… */
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  documentDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Correspondence: numbered «N/YYYY» per direction and year when left empty; otherwise free (an existing number). */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** The document that answered this one. */
  repliedById?: InputMaybe<Scalars['UUID']['input']>;
  /** A reply is expected by this date: listed in the weekly report until repliedById is set. */
  replyDueOn?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AssociationDocumentType>;
};

/** A filter to be used against many `AssociationDocumentFile` object types. All fields are combined with a logical ‘and.’ */
export type AssociationDocumentToManyAssociationDocumentFileFilter = {
  /** Every related `AssociationDocumentFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssociationDocumentFileFilter>;
  /** No related `AssociationDocumentFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssociationDocumentFileFilter>;
  /** Some related `AssociationDocumentFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssociationDocumentFileFilter>;
};

/** A filter to be used against many `AssociationDocument` object types. All fields are combined with a logical ‘and.’ */
export type AssociationDocumentToManyAssociationDocumentFilter = {
  /** Every related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssociationDocumentFilter>;
  /** No related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssociationDocumentFilter>;
  /** Some related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssociationDocumentFilter>;
};

export type AssociationDocumentType =
  | 'AGREEMENT'
  | 'BOARD_MINUTES'
  | 'CONTRACT'
  | 'CORRESPONDENCE_IN'
  | 'CORRESPONDENCE_OUT'
  | 'FINANCIAL_REPORT'
  | 'GA_MINUTES'
  | 'INTERNAL_RULES'
  | 'LEGAL'
  | 'MORAL_REPORT'
  | 'OTHER'
  | 'PERMIT'
  | 'STATUTES'
  | 'TECHNICAL';

/** A filter to be used against AssociationDocumentType fields. All fields are combined with a logical ‘and.’ */
export type AssociationDocumentTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AssociationDocumentType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AssociationDocumentType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AssociationDocumentType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AssociationDocumentType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AssociationDocumentType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AssociationDocumentType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AssociationDocumentType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AssociationDocumentType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AssociationDocumentType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AssociationDocumentType>>;
};

export type BankMatchSuggestion = {
  __typename?: 'BankMatchSuggestion';
  /** Signed for this account, like the line. */
  amount: Scalars['BigFloat']['output'];
  date: Maybe<Scalars['Date']['output']>;
  daysApart: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** operation or transfer. */
  kind: Scalars['String']['output'];
};

/** A connection to a list of `BankMatchSuggestion` values. */
export type BankMatchSuggestionConnection = {
  __typename?: 'BankMatchSuggestionConnection';
  /** A list of edges which contains the `BankMatchSuggestion` and cursor to aid in pagination. */
  edges: Array<Maybe<BankMatchSuggestionEdge>>;
  /** A list of `BankMatchSuggestion` objects. */
  nodes: Array<Maybe<BankMatchSuggestion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BankMatchSuggestion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BankMatchSuggestion` edge in the connection. */
export type BankMatchSuggestionEdge = {
  __typename?: 'BankMatchSuggestionEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `BankMatchSuggestion` at the end of the edge. */
  node: Maybe<BankMatchSuggestion>;
};

/** A filter to be used against `BankMatchSuggestion` object types. All fields are combined with a logical ‘and.’ */
export type BankMatchSuggestionFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BankMatchSuggestionFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `daysApart` field. */
  daysApart?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BankMatchSuggestionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BankMatchSuggestionFilter>>;
};

/** A bank statement: import with appImportBankStatement, match its lines, close with appCloseBankStatement. Delete an open one to import it again. */
export type BankStatement = {
  __typename?: 'BankStatement';
  /** Reads a single `FinancialAccount` that is related to this `BankStatement`. */
  account: Maybe<FinancialAccount>;
  accountId: Scalars['UUID']['output'];
  closingBalance: Scalars['BigFloat']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  /** Statement closing balance minus the account's balance at the period end: 0 when the records agree with the bank. */
  difference: Scalars['BigFloat']['output'];
  /** Reads a single `Photo` that is related to this `BankStatement`. */
  documentPhoto: Maybe<Photo>;
  documentPhotoId: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `BankStatementLine`. */
  lines: BankStatementLineConnection;
  matchedCount: Scalars['Int']['output'];
  openingBalance: Scalars['BigFloat']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  status: BankStatementStatus;
  /** Lines neither matched nor ignored. */
  unmatchedCount: Scalars['Int']['output'];
};


/** A bank statement: import with appImportBankStatement, match its lines, close with appCloseBankStatement. Delete an open one to import it again. */
export type BankStatementLinesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementLineCondition>;
  filter?: InputMaybe<BankStatementLineFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementLineOrderBy>>;
};

/**
 * A condition to be used against `BankStatement` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BankStatementCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `closingBalance` field. */
  closingBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentPhotoId` field. */
  documentPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `openingBalance` field. */
  openingBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `periodEnd` field. */
  periodEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `periodStart` field. */
  periodStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<BankStatementStatus>;
};

/** A connection to a list of `BankStatement` values. */
export type BankStatementConnection = {
  __typename?: 'BankStatementConnection';
  /** A list of edges which contains the `BankStatement` and cursor to aid in pagination. */
  edges: Array<Maybe<BankStatementEdge>>;
  /** A list of `BankStatement` objects. */
  nodes: Array<Maybe<BankStatement>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BankStatement` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BankStatement` edge in the connection. */
export type BankStatementEdge = {
  __typename?: 'BankStatementEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `BankStatement` at the end of the edge. */
  node: Maybe<BankStatement>;
};

/** A filter to be used against `BankStatement` object types. All fields are combined with a logical ‘and.’ */
export type BankStatementFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<FinancialAccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BankStatementFilter>>;
  /** Filter by the object’s `closingBalance` field. */
  closingBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `difference` field. */
  difference?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `documentPhoto` relation. */
  documentPhoto?: InputMaybe<PhotoFilter>;
  /** A related `documentPhoto` exists. */
  documentPhotoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPhotoId` field. */
  documentPhotoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lines` relation. */
  lines?: InputMaybe<BankStatementToManyBankStatementLineFilter>;
  /** Some related `lines` exist. */
  linesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `matchedCount` field. */
  matchedCount?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BankStatementFilter>;
  /** Filter by the object’s `openingBalance` field. */
  openingBalance?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BankStatementFilter>>;
  /** Filter by the object’s `periodEnd` field. */
  periodEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `periodStart` field. */
  periodStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<BankStatementStatusFilter>;
  /** Filter by the object’s `unmatchedCount` field. */
  unmatchedCount?: InputMaybe<IntFilter>;
};

/** Result of appImportBankStatement: statementId null on a dry run. */
export type BankStatementImport = {
  __typename?: 'BankStatementImport';
  /** Positions (from 1) of lines already imported for this account (same date, amount and label). */
  duplicateLines: Array<Maybe<Scalars['Int']['output']>>;
  lineCount: Scalars['Int']['output'];
  statementId: Maybe<Scalars['UUID']['output']>;
  /** Sum of the lines (signed). */
  total: Scalars['BigFloat']['output'];
};

/** A statement line: amount signed (+ into the bank, − out). Matched to one operation or one transfer, or ignored with a reason, through the app* functions. */
export type BankStatementLine = {
  __typename?: 'BankStatementLine';
  amount: Scalars['BigFloat']['output'];
  balance: Maybe<Scalars['BigFloat']['output']>;
  date: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  ignoreReason: Maybe<Scalars['String']['output']>;
  ignored: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  lineNo: Scalars['Int']['output'];
  /** Reads a single `FinancialOperation` that is related to this `BankStatementLine`. */
  matchedOperation: Maybe<FinancialOperation>;
  matchedOperationId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `AccountTransfer` that is related to this `BankStatementLine`. */
  matchedTransfer: Maybe<AccountTransfer>;
  matchedTransferId: Maybe<Scalars['UUID']['output']>;
  reference: Maybe<Scalars['String']['output']>;
  /** Reads a single `BankStatement` that is related to this `BankStatementLine`. */
  statement: Maybe<BankStatement>;
  statementId: Scalars['UUID']['output'];
  /** Up to 10 unmatched operations or transfers of the statement's account with the same signed amount, within 7 days, closest first. Empty once the line is matched or ignored. */
  suggestedMatches: BankMatchSuggestionConnection;
};


/** A statement line: amount signed (+ into the bank, − out). Matched to one operation or one transfer, or ignored with a reason, through the app* functions. */
export type BankStatementLineSuggestedMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<BankMatchSuggestionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `BankStatementLine` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BankStatementLineCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `ignoreReason` field. */
  ignoreReason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ignored` field. */
  ignored?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `lineNo` field. */
  lineNo?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `matchedOperationId` field. */
  matchedOperationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `matchedTransferId` field. */
  matchedTransferId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reference` field. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `statementId` field. */
  statementId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A connection to a list of `BankStatementLine` values. */
export type BankStatementLineConnection = {
  __typename?: 'BankStatementLineConnection';
  /** A list of edges which contains the `BankStatementLine` and cursor to aid in pagination. */
  edges: Array<Maybe<BankStatementLineEdge>>;
  /** A list of `BankStatementLine` objects. */
  nodes: Array<Maybe<BankStatementLine>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BankStatementLine` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BankStatementLine` edge in the connection. */
export type BankStatementLineEdge = {
  __typename?: 'BankStatementLineEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `BankStatementLine` at the end of the edge. */
  node: Maybe<BankStatementLine>;
};

/** A filter to be used against `BankStatementLine` object types. All fields are combined with a logical ‘and.’ */
export type BankStatementLineFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BankStatementLineFilter>>;
  /** Filter by the object’s `balance` field. */
  balance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `ignoreReason` field. */
  ignoreReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ignored` field. */
  ignored?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `lineNo` field. */
  lineNo?: InputMaybe<IntFilter>;
  /** Filter by the object’s `matchedOperation` relation. */
  matchedOperation?: InputMaybe<FinancialOperationFilter>;
  /** A related `matchedOperation` exists. */
  matchedOperationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `matchedOperationId` field. */
  matchedOperationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `matchedTransfer` relation. */
  matchedTransfer?: InputMaybe<AccountTransferFilter>;
  /** A related `matchedTransfer` exists. */
  matchedTransferExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `matchedTransferId` field. */
  matchedTransferId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BankStatementLineFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BankStatementLineFilter>>;
  /** Filter by the object’s `reference` field. */
  reference?: InputMaybe<StringFilter>;
  /** Filter by the object’s `statement` relation. */
  statement?: InputMaybe<BankStatementFilter>;
  /** Filter by the object’s `statementId` field. */
  statementId?: InputMaybe<UuidFilter>;
};

/** Methods to use when ordering `BankStatementLine`. */
export type BankStatementLineOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'BALANCE_ASC'
  | 'BALANCE_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IGNORED_ASC'
  | 'IGNORED_DESC'
  | 'IGNORE_REASON_ASC'
  | 'IGNORE_REASON_DESC'
  | 'LABEL_ASC'
  | 'LABEL_DESC'
  | 'LINE_NO_ASC'
  | 'LINE_NO_DESC'
  | 'MATCHED_OPERATION_ID_ASC'
  | 'MATCHED_OPERATION_ID_DESC'
  | 'MATCHED_TRANSFER_ID_ASC'
  | 'MATCHED_TRANSFER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REFERENCE_ASC'
  | 'REFERENCE_DESC'
  | 'STATEMENT_ID_ASC'
  | 'STATEMENT_ID_DESC';

/** Methods to use when ordering `BankStatement`. */
export type BankStatementOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'CLOSING_BALANCE_ASC'
  | 'CLOSING_BALANCE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ASC'
  | 'CREATED_BY_DESC'
  | 'DOCUMENT_PHOTO_ID_ASC'
  | 'DOCUMENT_PHOTO_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPENING_BALANCE_ASC'
  | 'OPENING_BALANCE_DESC'
  | 'PERIOD_END_ASC'
  | 'PERIOD_END_DESC'
  | 'PERIOD_START_ASC'
  | 'PERIOD_START_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type BankStatementStatus =
  | 'matched'
  | 'open';

/** A filter to be used against BankStatementStatus fields. All fields are combined with a logical ‘and.’ */
export type BankStatementStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BankStatementStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BankStatementStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BankStatementStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BankStatementStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BankStatementStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BankStatementStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BankStatementStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BankStatementStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BankStatementStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BankStatementStatus>>;
};

/** A filter to be used against many `BankStatementLine` object types. All fields are combined with a logical ‘and.’ */
export type BankStatementToManyBankStatementLineFilter = {
  /** Every related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BankStatementLineFilter>;
  /** No related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BankStatementLineFilter>;
  /** Some related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BankStatementLineFilter>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** Write through appSaveConsumptionBill (create or update). */
export type Bill = {
  __typename?: 'Bill';
  billMonth: Scalars['Date']['output'];
  billStatus: BillStatus;
  billTotal: Scalars['BigFloat']['output'];
  /** Reads a single `BillingConfiguration` that is related to this `Bill`. */
  billingConfiguration: Maybe<BillingConfiguration>;
  billingConfigurationId: Scalars['Int']['output'];
  breakdown: Maybe<Scalars['JSON']['output']>;
  consumption: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Member credit used on this bill (deducted from the price): billTotal = price − creditApplied. */
  creditApplied: Scalars['BigFloat']['output'];
  currentReading: Scalars['Int']['output'];
  dueDate: Maybe<Scalars['Date']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * Signed link to this bill's PDF. Anyone with the link can open it until it
   * expires (DOCUMENT_LINK_TTL_DAYS), so share it only with the member.
   */
  invoiceLink: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `Bill`. */
  member: Maybe<Member>;
  /** Reads and enables pagination through a set of `MemberCredit`. */
  memberCredits: MemberCreditConnection;
  memberId: Scalars['UUID']['output'];
  /** Reads a single `Meter` that is related to this `Bill`. */
  meter: Maybe<Meter>;
  meterId: Scalars['UUID']['output'];
  paidAmount: Maybe<Scalars['BigFloat']['output']>;
  /** Reads and enables pagination through a set of `Payment`. */
  payments: PaymentConnection;
  previousReading: Scalars['Int']['output'];
  /** Reads a single `Photo` that is related to this `Bill`. */
  readingPhoto: Maybe<Photo>;
  /** Photo of the meter, required when the consumption is unusual (readingCheck). */
  readingPhotoId: Maybe<Scalars['UUID']['output']>;
  /**
   * Signed link to this bill's receipt (إيصال الأداء, A5). Can be printed before
   * anything is paid: until the bill is settled it states that it is only
   * valid once paid and stamped by the association. Once paid, it lists the
   * payments.
   */
  receiptLink: Scalars['String']['output'];
  remainingAmount: Maybe<Scalars['BigFloat']['output']>;
  shartMembers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shartUnitPrice: Scalars['BigFloat']['output'];
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `WhatsappMessage`. */
  whatsappMessages: WhatsappMessageConnection;
};


/** Write through appSaveConsumptionBill (create or update). */
export type BillMemberCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCreditCondition>;
  filter?: InputMaybe<MemberCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberCreditOrderBy>>;
};


/** Write through appSaveConsumptionBill (create or update). */
export type BillPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PaymentCondition>;
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PaymentOrderBy>>;
};


/** Write through appSaveConsumptionBill (create or update). */
export type BillWhatsappMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WhatsappMessageCondition>;
  filter?: InputMaybe<WhatsappMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhatsappMessageOrderBy>>;
};

/** A condition to be used against `Bill` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BillCondition = {
  /** Checks for equality with the object’s `billMonth` field. */
  billMonth?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `billStatus` field. */
  billStatus?: InputMaybe<BillStatus>;
  /** Checks for equality with the object’s `billTotal` field. */
  billTotal?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `billingConfigurationId` field. */
  billingConfigurationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `creditApplied` field. */
  creditApplied?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `currentReading` field. */
  currentReading?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dueDate` field. */
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `meterId` field. */
  meterId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `previousReading` field. */
  previousReading?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `readingPhotoId` field. */
  readingPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `shartUnitPrice` field. */
  shartUnitPrice?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `Bill` values. */
export type BillConnection = {
  __typename?: 'BillConnection';
  /** A list of edges which contains the `Bill` and cursor to aid in pagination. */
  edges: Array<Maybe<BillEdge>>;
  /** A list of `Bill` objects. */
  nodes: Array<Maybe<Bill>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Bill` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Bill` edge in the connection. */
export type BillEdge = {
  __typename?: 'BillEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Bill` at the end of the edge. */
  node: Maybe<Bill>;
};

/** A filter to be used against `Bill` object types. All fields are combined with a logical ‘and.’ */
export type BillFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BillFilter>>;
  /** Filter by the object’s `billMonth` field. */
  billMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `billStatus` field. */
  billStatus?: InputMaybe<BillStatusFilter>;
  /** Filter by the object’s `billTotal` field. */
  billTotal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `billingConfiguration` relation. */
  billingConfiguration?: InputMaybe<BillingConfigurationFilter>;
  /** Filter by the object’s `billingConfigurationId` field. */
  billingConfigurationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `breakdown` field. */
  breakdown?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `consumption` field. */
  consumption?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creditApplied` field. */
  creditApplied?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `currentReading` field. */
  currentReading?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dueDate` field. */
  dueDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberCredits` relation. */
  memberCredits?: InputMaybe<BillToManyMemberCreditFilter>;
  /** Some related `memberCredits` exist. */
  memberCreditsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `meter` relation. */
  meter?: InputMaybe<MeterFilter>;
  /** Filter by the object’s `meterId` field. */
  meterId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BillFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BillFilter>>;
  /** Filter by the object’s `paidAmount` field. */
  paidAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `payments` relation. */
  payments?: InputMaybe<BillToManyPaymentFilter>;
  /** Some related `payments` exist. */
  paymentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `previousReading` field. */
  previousReading?: InputMaybe<IntFilter>;
  /** Filter by the object’s `readingPhoto` relation. */
  readingPhoto?: InputMaybe<PhotoFilter>;
  /** A related `readingPhoto` exists. */
  readingPhotoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `readingPhotoId` field. */
  readingPhotoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `remainingAmount` field. */
  remainingAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `shartMembers` field. */
  shartMembers?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `shartUnitPrice` field. */
  shartUnitPrice?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `whatsappMessages` relation. */
  whatsappMessages?: InputMaybe<BillToManyWhatsappMessageFilter>;
  /** Some related `whatsappMessages` exist. */
  whatsappMessagesExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Methods to use when ordering `Bill`. */
export type BillOrderBy =
  | 'BILLING_CONFIGURATION_ID_ASC'
  | 'BILLING_CONFIGURATION_ID_DESC'
  | 'BILL_MONTH_ASC'
  | 'BILL_MONTH_DESC'
  | 'BILL_TOTAL_ASC'
  | 'BILL_TOTAL_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREDIT_APPLIED_ASC'
  | 'CREDIT_APPLIED_DESC'
  | 'CURRENT_READING_ASC'
  | 'CURRENT_READING_DESC'
  | 'DUE_DATE_ASC'
  | 'DUE_DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'METER_ID_ASC'
  | 'METER_ID_DESC'
  | 'NATURAL'
  | 'PREVIOUS_READING_ASC'
  | 'PREVIOUS_READING_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'READING_PHOTO_ID_ASC'
  | 'READING_PHOTO_ID_DESC'
  | 'SHART_UNIT_PRICE_ASC'
  | 'SHART_UNIT_PRICE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type BillStatus =
  | 'OVERDUE'
  | 'PAID'
  | 'PENDING';

/** A filter to be used against BillStatus fields. All fields are combined with a logical ‘and.’ */
export type BillStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BillStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BillStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BillStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BillStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BillStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BillStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BillStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BillStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BillStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BillStatus>>;
};

/** A filter to be used against many `MemberCredit` object types. All fields are combined with a logical ‘and.’ */
export type BillToManyMemberCreditFilter = {
  /** Every related `MemberCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberCreditFilter>;
  /** No related `MemberCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberCreditFilter>;
  /** Some related `MemberCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberCreditFilter>;
};

/** A filter to be used against many `Payment` object types. All fields are combined with a logical ‘and.’ */
export type BillToManyPaymentFilter = {
  /** Every related `Payment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PaymentFilter>;
  /** No related `Payment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PaymentFilter>;
  /** Some related `Payment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PaymentFilter>;
};

/** A filter to be used against many `WhatsappMessage` object types. All fields are combined with a logical ‘and.’ */
export type BillToManyWhatsappMessageFilter = {
  /** Every related `WhatsappMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WhatsappMessageFilter>;
  /** No related `WhatsappMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WhatsappMessageFilter>;
  /** Some related `WhatsappMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WhatsappMessageFilter>;
};

/** Price configurations. Each applies from effectiveFrom to effectiveTo (inclusive, null = open); a bill uses the one covering its month. Created with appSaveBillingConfiguration, renamed with appRenameBillingConfiguration, deleted (if unused) with appDeleteBillingConfiguration. */
export type BillingConfiguration = {
  __typename?: 'BillingConfiguration';
  /** FIXED: every m³ at the single tier's rate. PROGRESSIVE: each tier's m³ at that tier's rate. */
  billingMethod: BillingMethodType;
  /** Reads and enables pagination through a set of `Bill`. */
  bills: BillConnection;
  /** Reads and enables pagination through a set of `ConsumptionTier`. */
  consumptionTiers: ConsumptionTierConnection;
  /** When it was saved. */
  createdAt: Maybe<Scalars['Datetime']['output']>;
  /** Keycloak username of who saved it. */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Optional notes (e.g. the meeting that decided the prices). */
  description: Maybe<Scalars['String']['output']>;
  /** First day it applies (1st of a month). Bills of a month use the configuration covering that month. */
  effectiveFrom: Scalars['Date']['output'];
  /** Last day it applies (inclusive); null = until a newer configuration starts. Set automatically when the next configuration is saved. */
  effectiveTo: Maybe<Scalars['Date']['output']>;
  /** Reads and enables pagination through a set of `FeeConfiguration`. */
  feeConfigurations: FeeConfigurationConnection;
  /** Configuration number. */
  id: Scalars['Int']['output'];
  /** True when bills use it: its prices, method and start date are then locked. */
  inUse: Maybe<Scalars['Boolean']['output']>;
  /** Name shown to the committee, e.g. «يونيو 2025». */
  name: Scalars['String']['output'];
  /** What bills cost under this configuration, one line per consumption (max 100). Shart excluded. */
  preview: Array<BillingPreviewLine>;
  /** Shart price per person and month (dirhams), copied to each new bill. Set when saving the configuration; locked once bills use it. */
  shartUnitPrice: Scalars['BigFloat']['output'];
  /** SCHEDULED, CURRENT or PAST relative to today. Replaces isActive (bills pick their configuration by dates, not by a flag). */
  status: BillingConfigurationStatus;
  /** Last change (rename, or effectiveTo set when the next configuration was saved). */
  updatedAt: Maybe<Scalars['Datetime']['output']>;
  /** Keycloak username of the last change. */
  updatedBy: Maybe<Scalars['String']['output']>;
};


/** Price configurations. Each applies from effectiveFrom to effectiveTo (inclusive, null = open); a bill uses the one covering its month. Created with appSaveBillingConfiguration, renamed with appRenameBillingConfiguration, deleted (if unused) with appDeleteBillingConfiguration. */
export type BillingConfigurationBillsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillCondition>;
  filter?: InputMaybe<BillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOrderBy>>;
};


/** Price configurations. Each applies from effectiveFrom to effectiveTo (inclusive, null = open); a bill uses the one covering its month. Created with appSaveBillingConfiguration, renamed with appRenameBillingConfiguration, deleted (if unused) with appDeleteBillingConfiguration. */
export type BillingConfigurationConsumptionTiersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConsumptionTierCondition>;
  filter?: InputMaybe<ConsumptionTierFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumptionTierOrderBy>>;
};


/** Price configurations. Each applies from effectiveFrom to effectiveTo (inclusive, null = open); a bill uses the one covering its month. Created with appSaveBillingConfiguration, renamed with appRenameBillingConfiguration, deleted (if unused) with appDeleteBillingConfiguration. */
export type BillingConfigurationFeeConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeeConfigurationCondition>;
  filter?: InputMaybe<FeeConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeeConfigurationOrderBy>>;
};


/** Price configurations. Each applies from effectiveFrom to effectiveTo (inclusive, null = open); a bill uses the one covering its month. Created with appSaveBillingConfiguration, renamed with appRenameBillingConfiguration, deleted (if unused) with appDeleteBillingConfiguration. */
export type BillingConfigurationPreviewArgs = {
  consumptions: Array<InputMaybe<Scalars['Int']['input']>>;
};

/**
 * A condition to be used against `BillingConfiguration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BillingConfigurationCondition = {
  /** Checks for equality with the object’s `billingMethod` field. */
  billingMethod?: InputMaybe<BillingMethodType>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `effectiveFrom` field. */
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `effectiveTo` field. */
  effectiveTo?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `shartUnitPrice` field. */
  shartUnitPrice?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `BillingConfiguration` values. */
export type BillingConfigurationConnection = {
  __typename?: 'BillingConfigurationConnection';
  /** A list of edges which contains the `BillingConfiguration` and cursor to aid in pagination. */
  edges: Array<Maybe<BillingConfigurationEdge>>;
  /** A list of `BillingConfiguration` objects. */
  nodes: Array<Maybe<BillingConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BillingConfiguration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BillingConfiguration` edge in the connection. */
export type BillingConfigurationEdge = {
  __typename?: 'BillingConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `BillingConfiguration` at the end of the edge. */
  node: Maybe<BillingConfiguration>;
};

/** A filter to be used against `BillingConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type BillingConfigurationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BillingConfigurationFilter>>;
  /** Filter by the object’s `billingMethod` field. */
  billingMethod?: InputMaybe<BillingMethodTypeFilter>;
  /** Filter by the object’s `bills` relation. */
  bills?: InputMaybe<BillingConfigurationToManyBillFilter>;
  /** Some related `bills` exist. */
  billsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `consumptionTiers` relation. */
  consumptionTiers?: InputMaybe<BillingConfigurationToManyConsumptionTierFilter>;
  /** Some related `consumptionTiers` exist. */
  consumptionTiersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `effectiveFrom` field. */
  effectiveFrom?: InputMaybe<DateFilter>;
  /** Filter by the object’s `effectiveTo` field. */
  effectiveTo?: InputMaybe<DateFilter>;
  /** Filter by the object’s `feeConfigurations` relation. */
  feeConfigurations?: InputMaybe<BillingConfigurationToManyFeeConfigurationFilter>;
  /** Some related `feeConfigurations` exist. */
  feeConfigurationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `inUse` field. */
  inUse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BillingConfigurationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BillingConfigurationFilter>>;
  /** Filter by the object’s `shartUnitPrice` field. */
  shartUnitPrice?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<BillingConfigurationStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
};

/** Methods to use when ordering `BillingConfiguration`. */
export type BillingConfigurationOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ASC'
  | 'CREATED_BY_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'EFFECTIVE_FROM_ASC'
  | 'EFFECTIVE_FROM_DESC'
  | 'EFFECTIVE_TO_ASC'
  | 'EFFECTIVE_TO_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SHART_UNIT_PRICE_ASC'
  | 'SHART_UNIT_PRICE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'UPDATED_BY_ASC'
  | 'UPDATED_BY_DESC';

/** SCHEDULED: starts after today. CURRENT: applies today. PAST: ended before today. */
export type BillingConfigurationStatus =
  | 'CURRENT'
  | 'PAST'
  | 'SCHEDULED';

/** A filter to be used against BillingConfigurationStatus fields. All fields are combined with a logical ‘and.’ */
export type BillingConfigurationStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BillingConfigurationStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BillingConfigurationStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BillingConfigurationStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BillingConfigurationStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BillingConfigurationStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BillingConfigurationStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BillingConfigurationStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BillingConfigurationStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BillingConfigurationStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BillingConfigurationStatus>>;
};

/** A filter to be used against many `Bill` object types. All fields are combined with a logical ‘and.’ */
export type BillingConfigurationToManyBillFilter = {
  /** Every related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BillFilter>;
  /** No related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BillFilter>;
  /** Some related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BillFilter>;
};

/** A filter to be used against many `ConsumptionTier` object types. All fields are combined with a logical ‘and.’ */
export type BillingConfigurationToManyConsumptionTierFilter = {
  /** Every related `ConsumptionTier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConsumptionTierFilter>;
  /** No related `ConsumptionTier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConsumptionTierFilter>;
  /** Some related `ConsumptionTier` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConsumptionTierFilter>;
};

/** A filter to be used against many `FeeConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type BillingConfigurationToManyFeeConfigurationFilter = {
  /** Every related `FeeConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FeeConfigurationFilter>;
  /** No related `FeeConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FeeConfigurationFilter>;
  /** Some related `FeeConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FeeConfigurationFilter>;
};

/** An input for mutations affecting `BillingFee` */
export type BillingFeeInput = {
  /** Dirhams for FIXED (≥ 0), percent for PERCENTAGE (0–100). Pass as a string, e.g. "5.00". */
  amount: Scalars['BigFloat']['input'];
  /** Optional explanation. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** FIXED: amount in dirhams. PERCENTAGE: percent (0–100) of the consumption price. */
  feeType: FeeType;
  /** Name shown on invoices; unique within the configuration. */
  name: Scalars['String']['input'];
  /** True: applies only to bills with zero consumption (e.g. a meter freeze fee). Null = false. */
  onlyWhenNoConsumption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingMethodType =
  | 'FIXED'
  | 'PROGRESSIVE';

/** A filter to be used against BillingMethodType fields. All fields are combined with a logical ‘and.’ */
export type BillingMethodTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BillingMethodType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BillingMethodType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BillingMethodType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BillingMethodType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BillingMethodType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BillingMethodType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BillingMethodType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BillingMethodType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BillingMethodType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BillingMethodType>>;
};

/** What a bill would cost for one consumption (shart excluded). */
export type BillingPreviewLine = {
  __typename?: 'BillingPreviewLine';
  /** Same JSON as Bill.breakdown: tiers with consumptionInTier and tierPrice, fees with calculatedAmount and applied. */
  breakdown: Scalars['JSON']['output'];
  /** Consumption (m³). */
  consumption: Scalars['Int']['output'];
  /** Price of the consumption (tiers). */
  consumptionPrice: Scalars['BigFloat']['output'];
  /** consumptionPrice + totalFees (no shart: it depends on each bill). */
  total: Scalars['BigFloat']['output'];
  /** Fees that apply. */
  totalFees: Scalars['BigFloat']['output'];
};

/** An input for mutations affecting `BillingTier` */
export type BillingTierInput = {
  /** Label shown on invoices, e.g. «الاستهلاك المنزلي». */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Price per m³ in dirhams (≥ 0). Pass as a string, e.g. "4.00". */
  rate: Scalars['BigFloat']['input'];
  /** Last unit (m³) of the tier, inclusive. Null for the last tier (no upper limit), and only for it. */
  tierEnd?: InputMaybe<Scalars['Int']['input']>;
  /** First unit (m³) of the tier, inclusive. The first tier starts at 1. */
  tierStart: Scalars['Int']['input'];
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CategoryAppliesTo =
  | 'both'
  | 'credit'
  | 'debit';

/** A filter to be used against CategoryAppliesTo fields. All fields are combined with a logical ‘and.’ */
export type CategoryAppliesToFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CategoryAppliesTo>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CategoryAppliesTo>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CategoryAppliesTo>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CategoryAppliesTo>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CategoryAppliesTo>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CategoryAppliesTo>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CategoryAppliesTo>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CategoryAppliesTo>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CategoryAppliesTo>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CategoryAppliesTo>>;
};

export type CommitteeRole =
  | 'ADVISOR'
  | 'PRESIDENT'
  | 'SECRETARY'
  | 'TREASURER'
  | 'VICE_PRESIDENT'
  | 'VICE_SECRETARY'
  | 'VICE_TREASURER';

/** A filter to be used against CommitteeRole fields. All fields are combined with a logical ‘and.’ */
export type CommitteeRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CommitteeRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CommitteeRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CommitteeRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CommitteeRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CommitteeRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CommitteeRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CommitteeRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CommitteeRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CommitteeRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CommitteeRole>>;
};

/** Consumption tiers of a configuration (contiguous from 1, last one open). Written by appSaveBillingConfiguration only. */
export type ConsumptionTier = {
  __typename?: 'ConsumptionTier';
  /** Reads a single `BillingConfiguration` that is related to this `ConsumptionTier`. */
  billingConfiguration: Maybe<BillingConfiguration>;
  /** Configuration it belongs to. */
  billingConfigurationId: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['Datetime']['output']>;
  /** Label shown on invoices. */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Price per m³ (dirhams). */
  rate: Scalars['BigFloat']['output'];
  /** Last m³ of the tier, inclusive; null = no upper limit. */
  tierEnd: Maybe<Scalars['Int']['output']>;
  /** First m³ of the tier, inclusive. (Configurations saved before 045 may start at 0; FIXED ignores bounds.) */
  tierStart: Scalars['Int']['output'];
  updatedAt: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `ConsumptionTier` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ConsumptionTierCondition = {
  /** Checks for equality with the object’s `billingConfigurationId` field. */
  billingConfigurationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rate` field. */
  rate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `tierEnd` field. */
  tierEnd?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tierStart` field. */
  tierStart?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `ConsumptionTier` values. */
export type ConsumptionTierConnection = {
  __typename?: 'ConsumptionTierConnection';
  /** A list of edges which contains the `ConsumptionTier` and cursor to aid in pagination. */
  edges: Array<Maybe<ConsumptionTierEdge>>;
  /** A list of `ConsumptionTier` objects. */
  nodes: Array<Maybe<ConsumptionTier>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ConsumptionTier` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ConsumptionTier` edge in the connection. */
export type ConsumptionTierEdge = {
  __typename?: 'ConsumptionTierEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ConsumptionTier` at the end of the edge. */
  node: Maybe<ConsumptionTier>;
};

/** A filter to be used against `ConsumptionTier` object types. All fields are combined with a logical ‘and.’ */
export type ConsumptionTierFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ConsumptionTierFilter>>;
  /** Filter by the object’s `billingConfiguration` relation. */
  billingConfiguration?: InputMaybe<BillingConfigurationFilter>;
  /** A related `billingConfiguration` exists. */
  billingConfigurationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `billingConfigurationId` field. */
  billingConfigurationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ConsumptionTierFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ConsumptionTierFilter>>;
  /** Filter by the object’s `rate` field. */
  rate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `tierEnd` field. */
  tierEnd?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tierStart` field. */
  tierStart?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Methods to use when ordering `ConsumptionTier`. */
export type ConsumptionTierOrderBy =
  | 'BILLING_CONFIGURATION_ID_ASC'
  | 'BILLING_CONFIGURATION_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RATE_ASC'
  | 'RATE_DESC'
  | 'TIER_END_ASC'
  | 'TIER_END_DESC'
  | 'TIER_START_ASC'
  | 'TIER_START_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Who the money comes from or goes to: supplier, worker, donor, lender, member, institution. */
export type Counterparty = {
  __typename?: 'Counterparty';
  /** Reads and enables pagination through a set of `AssociationDocument`. */
  associationDocuments: AssociationDocumentConnection;
  /** Reads and enables pagination through a set of `Debt`. */
  debts: DebtConnection;
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperations: FinancialOperationConnection;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `InKindContribution`. */
  inKindContributions: InKindContributionConnection;
  kind: CounterpartyKind;
  name: Scalars['String']['output'];
  note: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
};


/** Who the money comes from or goes to: supplier, worker, donor, lender, member, institution. */
export type CounterpartyAssociationDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentCondition>;
  filter?: InputMaybe<AssociationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentOrderBy>>;
};


/** Who the money comes from or goes to: supplier, worker, donor, lender, member, institution. */
export type CounterpartyDebtsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DebtCondition>;
  filter?: InputMaybe<DebtFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DebtOrderBy>>;
};


/** Who the money comes from or goes to: supplier, worker, donor, lender, member, institution. */
export type CounterpartyFinancialOperationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};


/** Who the money comes from or goes to: supplier, worker, donor, lender, member, institution. */
export type CounterpartyInKindContributionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InKindContributionCondition>;
  filter?: InputMaybe<InKindContributionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InKindContributionOrderBy>>;
};

/**
 * A condition to be used against `Counterparty` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CounterpartyCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<CounterpartyKind>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Counterparty` values. */
export type CounterpartyConnection = {
  __typename?: 'CounterpartyConnection';
  /** A list of edges which contains the `Counterparty` and cursor to aid in pagination. */
  edges: Array<Maybe<CounterpartyEdge>>;
  /** A list of `Counterparty` objects. */
  nodes: Array<Maybe<Counterparty>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Counterparty` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Counterparty` edge in the connection. */
export type CounterpartyEdge = {
  __typename?: 'CounterpartyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Counterparty` at the end of the edge. */
  node: Maybe<Counterparty>;
};

/** A filter to be used against `Counterparty` object types. All fields are combined with a logical ‘and.’ */
export type CounterpartyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CounterpartyFilter>>;
  /** Filter by the object’s `associationDocuments` relation. */
  associationDocuments?: InputMaybe<CounterpartyToManyAssociationDocumentFilter>;
  /** Some related `associationDocuments` exist. */
  associationDocumentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `debts` relation. */
  debts?: InputMaybe<CounterpartyToManyDebtFilter>;
  /** Some related `debts` exist. */
  debtsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `financialOperations` relation. */
  financialOperations?: InputMaybe<CounterpartyToManyFinancialOperationFilter>;
  /** Some related `financialOperations` exist. */
  financialOperationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inKindContributions` relation. */
  inKindContributions?: InputMaybe<CounterpartyToManyInKindContributionFilter>;
  /** Some related `inKindContributions` exist. */
  inKindContributionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<CounterpartyKindFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CounterpartyFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CounterpartyFilter>>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Counterparty` */
export type CounterpartyInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<CounterpartyKind>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CounterpartyKind =
  | 'donor'
  | 'institution'
  | 'lender'
  | 'member'
  | 'other'
  | 'supplier'
  | 'worker';

/** A filter to be used against CounterpartyKind fields. All fields are combined with a logical ‘and.’ */
export type CounterpartyKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CounterpartyKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CounterpartyKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CounterpartyKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CounterpartyKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CounterpartyKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CounterpartyKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CounterpartyKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CounterpartyKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CounterpartyKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CounterpartyKind>>;
};

/** Methods to use when ordering `Counterparty`. */
export type CounterpartyOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'PHONE_ASC'
  | 'PHONE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** Represents an update to a `Counterparty`. Fields that are set will be updated. */
export type CounterpartyPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<CounterpartyKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `AssociationDocument` object types. All fields are combined with a logical ‘and.’ */
export type CounterpartyToManyAssociationDocumentFilter = {
  /** Every related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssociationDocumentFilter>;
  /** No related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssociationDocumentFilter>;
  /** Some related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssociationDocumentFilter>;
};

/** A filter to be used against many `Debt` object types. All fields are combined with a logical ‘and.’ */
export type CounterpartyToManyDebtFilter = {
  /** Every related `Debt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DebtFilter>;
  /** No related `Debt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DebtFilter>;
  /** Some related `Debt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DebtFilter>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type CounterpartyToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

/** A filter to be used against many `InKindContribution` object types. All fields are combined with a logical ‘and.’ */
export type CounterpartyToManyInKindContributionFilter = {
  /** Every related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InKindContributionFilter>;
  /** No related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InKindContributionFilter>;
  /** Some related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InKindContributionFilter>;
};

/** All input for the create `AccountTransfer` mutation. */
export type CreateAccountTransferInput = {
  /** The `AccountTransfer` to be created by this mutation. */
  accountTransfer: AccountTransferInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AccountTransfer` mutation. */
export type CreateAccountTransferPayload = {
  __typename?: 'CreateAccountTransferPayload';
  /** The `AccountTransfer` that was created by this mutation. */
  accountTransfer: Maybe<AccountTransfer>;
  /** An edge for our `AccountTransfer`. May be used by Relay 1. */
  accountTransferEdge: Maybe<AccountTransferEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `AccountTransfer` mutation. */
export type CreateAccountTransferPayloadAccountTransferEdgeArgs = {
  orderBy?: Array<AccountTransferOrderBy>;
};

/** All input for the create `AssociationDocumentFile` mutation. */
export type CreateAssociationDocumentFileInput = {
  /** The `AssociationDocumentFile` to be created by this mutation. */
  associationDocumentFile: AssociationDocumentFileInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AssociationDocumentFile` mutation. */
export type CreateAssociationDocumentFilePayload = {
  __typename?: 'CreateAssociationDocumentFilePayload';
  /** The `AssociationDocumentFile` that was created by this mutation. */
  associationDocumentFile: Maybe<AssociationDocumentFile>;
  /** An edge for our `AssociationDocumentFile`. May be used by Relay 1. */
  associationDocumentFileEdge: Maybe<AssociationDocumentFileEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `AssociationDocumentFile` mutation. */
export type CreateAssociationDocumentFilePayloadAssociationDocumentFileEdgeArgs = {
  orderBy?: Array<AssociationDocumentFileOrderBy>;
};

/** All input for the create `AssociationDocument` mutation. */
export type CreateAssociationDocumentInput = {
  /** The `AssociationDocument` to be created by this mutation. */
  associationDocument: AssociationDocumentInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AssociationDocument` mutation. */
export type CreateAssociationDocumentPayload = {
  __typename?: 'CreateAssociationDocumentPayload';
  /** The `AssociationDocument` that was created by this mutation. */
  associationDocument: Maybe<AssociationDocument>;
  /** An edge for our `AssociationDocument`. May be used by Relay 1. */
  associationDocumentEdge: Maybe<AssociationDocumentEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `AssociationDocument` mutation. */
export type CreateAssociationDocumentPayloadAssociationDocumentEdgeArgs = {
  orderBy?: Array<AssociationDocumentOrderBy>;
};

/** All input for the create `Counterparty` mutation. */
export type CreateCounterpartyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Counterparty` to be created by this mutation. */
  counterparty: CounterpartyInput;
};

/** The output of our create `Counterparty` mutation. */
export type CreateCounterpartyPayload = {
  __typename?: 'CreateCounterpartyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Counterparty` that was created by this mutation. */
  counterparty: Maybe<Counterparty>;
  /** An edge for our `Counterparty`. May be used by Relay 1. */
  counterpartyEdge: Maybe<CounterpartyEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `Counterparty` mutation. */
export type CreateCounterpartyPayloadCounterpartyEdgeArgs = {
  orderBy?: Array<CounterpartyOrderBy>;
};

/** All input for the create `Debt` mutation. */
export type CreateDebtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Debt` to be created by this mutation. */
  debt: DebtInput;
};

/** The output of our create `Debt` mutation. */
export type CreateDebtPayload = {
  __typename?: 'CreateDebtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Debt` that was created by this mutation. */
  debt: Maybe<Debt>;
  /** An edge for our `Debt`. May be used by Relay 1. */
  debtEdge: Maybe<DebtEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `Debt` mutation. */
export type CreateDebtPayloadDebtEdgeArgs = {
  orderBy?: Array<DebtOrderBy>;
};

/** All input for the create `FinancialAccount` mutation. */
export type CreateFinancialAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FinancialAccount` to be created by this mutation. */
  financialAccount: FinancialAccountInput;
};

/** The output of our create `FinancialAccount` mutation. */
export type CreateFinancialAccountPayload = {
  __typename?: 'CreateFinancialAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `FinancialAccount` that was created by this mutation. */
  financialAccount: Maybe<FinancialAccount>;
  /** An edge for our `FinancialAccount`. May be used by Relay 1. */
  financialAccountEdge: Maybe<FinancialAccountEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `FinancialAccount` mutation. */
export type CreateFinancialAccountPayloadFinancialAccountEdgeArgs = {
  orderBy?: Array<FinancialAccountOrderBy>;
};

/** All input for the create `FinancialOperation` mutation. */
export type CreateFinancialOperationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `FinancialOperation` to be created by this mutation. */
  financialOperation: FinancialOperationInput;
};

/** The output of our create `FinancialOperation` mutation. */
export type CreateFinancialOperationPayload = {
  __typename?: 'CreateFinancialOperationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `FinancialOperation` that was created by this mutation. */
  financialOperation: Maybe<FinancialOperation>;
  /** An edge for our `FinancialOperation`. May be used by Relay 1. */
  financialOperationEdge: Maybe<FinancialOperationEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `FinancialOperation` mutation. */
export type CreateFinancialOperationPayloadFinancialOperationEdgeArgs = {
  orderBy?: Array<FinancialOperationOrderBy>;
};

/** All input for the create `InKindContribution` mutation. */
export type CreateInKindContributionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InKindContribution` to be created by this mutation. */
  inKindContribution: InKindContributionInput;
};

/** The output of our create `InKindContribution` mutation. */
export type CreateInKindContributionPayload = {
  __typename?: 'CreateInKindContributionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `InKindContribution` that was created by this mutation. */
  inKindContribution: Maybe<InKindContribution>;
  /** An edge for our `InKindContribution`. May be used by Relay 1. */
  inKindContributionEdge: Maybe<InKindContributionEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `InKindContribution` mutation. */
export type CreateInKindContributionPayloadInKindContributionEdgeArgs = {
  orderBy?: Array<InKindContributionOrderBy>;
};

/** All input for the create `Member` mutation. */
export type CreateMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Member` to be created by this mutation. */
  member: MemberInput;
};

/** The output of our create `Member` mutation. */
export type CreateMemberPayload = {
  __typename?: 'CreateMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Member` that was created by this mutation. */
  member: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge: Maybe<MemberEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `Member` mutation. */
export type CreateMemberPayloadMemberEdgeArgs = {
  orderBy?: Array<MemberOrderBy>;
};

/** All input for the create `Meter` mutation. */
export type CreateMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Meter` to be created by this mutation. */
  meter: MeterInput;
};

/** The output of our create `Meter` mutation. */
export type CreateMeterPayload = {
  __typename?: 'CreateMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Meter` that was created by this mutation. */
  meter: Maybe<Meter>;
  /** An edge for our `Meter`. May be used by Relay 1. */
  meterEdge: Maybe<MeterEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `Meter` mutation. */
export type CreateMeterPayloadMeterEdgeArgs = {
  orderBy?: Array<MeterOrderBy>;
};

/** All input for the create `OperationCategory` mutation. */
export type CreateOperationCategoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `OperationCategory` to be created by this mutation. */
  operationCategory: OperationCategoryInput;
};

/** The output of our create `OperationCategory` mutation. */
export type CreateOperationCategoryPayload = {
  __typename?: 'CreateOperationCategoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `OperationCategory` that was created by this mutation. */
  operationCategory: Maybe<OperationCategory>;
  /** An edge for our `OperationCategory`. May be used by Relay 1. */
  operationCategoryEdge: Maybe<OperationCategoryEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `OperationCategory` mutation. */
export type CreateOperationCategoryPayloadOperationCategoryEdgeArgs = {
  orderBy?: Array<OperationCategoryOrderBy>;
};

/** All input for the create `Project` mutation. */
export type CreateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Project` to be created by this mutation. */
  project: ProjectInput;
};

/** The output of our create `Project` mutation. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Project` that was created by this mutation. */
  project: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge: Maybe<ProjectEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our create `Project` mutation. */
export type CreateProjectPayloadProjectEdgeArgs = {
  orderBy?: Array<ProjectOrderBy>;
};

/** All input for the create `ShartPerson` mutation. */
export type CreateShartPersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ShartPerson` to be created by this mutation. */
  shartPerson: ShartPersonInput;
};

/** The output of our create `ShartPerson` mutation. */
export type CreateShartPersonPayload = {
  __typename?: 'CreateShartPersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ShartPerson` that was created by this mutation. */
  shartPerson: Maybe<ShartPerson>;
  /** An edge for our `ShartPerson`. May be used by Relay 1. */
  shartPersonEdge: Maybe<ShartPersonEdge>;
};


/** The output of our create `ShartPerson` mutation. */
export type CreateShartPersonPayloadShartPersonEdgeArgs = {
  orderBy?: Array<ShartPersonOrderBy>;
};

/**
 * GRANTED: credit given to the member (+). USED: deducted from a bill (−).
 * RELEASED: part of a USED credit given back because the bill was corrected (+).
 * RETURNED: credit of a deleted bill given back (+).
 */
export type CreditKind =
  | 'GRANTED'
  | 'RELEASED'
  | 'RETURNED'
  | 'USED';

/** A filter to be used against CreditKind fields. All fields are combined with a logical ‘and.’ */
export type CreditKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CreditKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CreditKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CreditKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CreditKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CreditKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CreditKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CreditKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CreditKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CreditKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CreditKind>>;
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** Loans received (borrowed) or given (lent). The money received or paid, and each repayment, are operations with debtId; they are not income or spending. */
export type Debt = {
  __typename?: 'Debt';
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Counterparty` that is related to this `Debt`. */
  counterparty: Maybe<Counterparty>;
  counterpartyId: Maybe<Scalars['UUID']['output']>;
  date: Scalars['Date']['output'];
  direction: DebtDirection;
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperations: FinancialOperationConnection;
  id: Scalars['UUID']['output'];
  /** What is left to repay (or to be repaid). */
  outstanding: Scalars['BigFloat']['output'];
  /** Reads a single `Project` that is related to this `Debt`. */
  project: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  purpose: Maybe<Scalars['String']['output']>;
};


/** Loans received (borrowed) or given (lent). The money received or paid, and each repayment, are operations with debtId; they are not income or spending. */
export type DebtFinancialOperationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};

/** A condition to be used against `Debt` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DebtCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `direction` field. */
  direction?: InputMaybe<DebtDirection>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `purpose` field. */
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Debt` values. */
export type DebtConnection = {
  __typename?: 'DebtConnection';
  /** A list of edges which contains the `Debt` and cursor to aid in pagination. */
  edges: Array<Maybe<DebtEdge>>;
  /** A list of `Debt` objects. */
  nodes: Array<Maybe<Debt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Debt` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type DebtDirection =
  | 'borrowed'
  | 'lent';

/** A filter to be used against DebtDirection fields. All fields are combined with a logical ‘and.’ */
export type DebtDirectionFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DebtDirection>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DebtDirection>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DebtDirection>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DebtDirection>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DebtDirection>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DebtDirection>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DebtDirection>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DebtDirection>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DebtDirection>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DebtDirection>>;
};

/** A `Debt` edge in the connection. */
export type DebtEdge = {
  __typename?: 'DebtEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Debt` at the end of the edge. */
  node: Maybe<Debt>;
};

/** A filter to be used against `Debt` object types. All fields are combined with a logical ‘and.’ */
export type DebtFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DebtFilter>>;
  /** Filter by the object’s `counterparty` relation. */
  counterparty?: InputMaybe<CounterpartyFilter>;
  /** A related `counterparty` exists. */
  counterpartyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `direction` field. */
  direction?: InputMaybe<DebtDirectionFilter>;
  /** Filter by the object’s `financialOperations` relation. */
  financialOperations?: InputMaybe<DebtToManyFinancialOperationFilter>;
  /** Some related `financialOperations` exist. */
  financialOperationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DebtFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DebtFilter>>;
  /** Filter by the object’s `outstanding` field. */
  outstanding?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `purpose` field. */
  purpose?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Debt` */
export type DebtInput = {
  amount: Scalars['BigFloat']['input'];
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  date: Scalars['Date']['input'];
  direction?: InputMaybe<DebtDirection>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** Methods to use when ordering `Debt`. */
export type DebtOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'COUNTERPARTY_ID_ASC'
  | 'COUNTERPARTY_ID_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'PURPOSE_ASC'
  | 'PURPOSE_DESC';

/** Represents an update to a `Debt`. Fields that are set will be updated. */
export type DebtPatch = {
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<DebtDirection>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type DebtToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

/** All input for the `deleteAccountTransfer` mutation. */
export type DeleteAccountTransferInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `AccountTransfer` mutation. */
export type DeleteAccountTransferPayload = {
  __typename?: 'DeleteAccountTransferPayload';
  /** The `AccountTransfer` that was deleted by this mutation. */
  accountTransfer: Maybe<AccountTransfer>;
  /** An edge for our `AccountTransfer`. May be used by Relay 1. */
  accountTransferEdge: Maybe<AccountTransferEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `AccountTransfer` mutation. */
export type DeleteAccountTransferPayloadAccountTransferEdgeArgs = {
  orderBy?: Array<AccountTransferOrderBy>;
};

/** All input for the `deleteAssociationDocumentFileByDocumentIdAndPhotoId` mutation. */
export type DeleteAssociationDocumentFileByDocumentIdAndPhotoIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['UUID']['input'];
  photoId: Scalars['UUID']['input'];
};

/** All input for the `deleteAssociationDocumentFile` mutation. */
export type DeleteAssociationDocumentFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `AssociationDocumentFile` mutation. */
export type DeleteAssociationDocumentFilePayload = {
  __typename?: 'DeleteAssociationDocumentFilePayload';
  /** The `AssociationDocumentFile` that was deleted by this mutation. */
  associationDocumentFile: Maybe<AssociationDocumentFile>;
  /** An edge for our `AssociationDocumentFile`. May be used by Relay 1. */
  associationDocumentFileEdge: Maybe<AssociationDocumentFileEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `AssociationDocumentFile` mutation. */
export type DeleteAssociationDocumentFilePayloadAssociationDocumentFileEdgeArgs = {
  orderBy?: Array<AssociationDocumentFileOrderBy>;
};

/** All input for the `deleteAssociationDocument` mutation. */
export type DeleteAssociationDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `AssociationDocument` mutation. */
export type DeleteAssociationDocumentPayload = {
  __typename?: 'DeleteAssociationDocumentPayload';
  /** The `AssociationDocument` that was deleted by this mutation. */
  associationDocument: Maybe<AssociationDocument>;
  /** An edge for our `AssociationDocument`. May be used by Relay 1. */
  associationDocumentEdge: Maybe<AssociationDocumentEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `AssociationDocument` mutation. */
export type DeleteAssociationDocumentPayloadAssociationDocumentEdgeArgs = {
  orderBy?: Array<AssociationDocumentOrderBy>;
};

/** All input for the `deleteBankStatement` mutation. */
export type DeleteBankStatementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `BankStatement` mutation. */
export type DeleteBankStatementPayload = {
  __typename?: 'DeleteBankStatementPayload';
  /** The `BankStatement` that was deleted by this mutation. */
  bankStatement: Maybe<BankStatement>;
  /** An edge for our `BankStatement`. May be used by Relay 1. */
  bankStatementEdge: Maybe<BankStatementEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `BankStatement` mutation. */
export type DeleteBankStatementPayloadBankStatementEdgeArgs = {
  orderBy?: Array<BankStatementOrderBy>;
};

/** All input for the `deleteBill` mutation. */
export type DeleteBillInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Bill` mutation. */
export type DeleteBillPayload = {
  __typename?: 'DeleteBillPayload';
  /** The `Bill` that was deleted by this mutation. */
  bill: Maybe<Bill>;
  /** An edge for our `Bill`. May be used by Relay 1. */
  billEdge: Maybe<BillEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Bill` mutation. */
export type DeleteBillPayloadBillEdgeArgs = {
  orderBy?: Array<BillOrderBy>;
};

/** All input for the `deleteCounterpartyByName` mutation. */
export type DeleteCounterpartyByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** All input for the `deleteCounterparty` mutation. */
export type DeleteCounterpartyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Counterparty` mutation. */
export type DeleteCounterpartyPayload = {
  __typename?: 'DeleteCounterpartyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Counterparty` that was deleted by this mutation. */
  counterparty: Maybe<Counterparty>;
  /** An edge for our `Counterparty`. May be used by Relay 1. */
  counterpartyEdge: Maybe<CounterpartyEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Counterparty` mutation. */
export type DeleteCounterpartyPayloadCounterpartyEdgeArgs = {
  orderBy?: Array<CounterpartyOrderBy>;
};

/** All input for the `deleteDebt` mutation. */
export type DeleteDebtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Debt` mutation. */
export type DeleteDebtPayload = {
  __typename?: 'DeleteDebtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Debt` that was deleted by this mutation. */
  debt: Maybe<Debt>;
  /** An edge for our `Debt`. May be used by Relay 1. */
  debtEdge: Maybe<DebtEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Debt` mutation. */
export type DeleteDebtPayloadDebtEdgeArgs = {
  orderBy?: Array<DebtOrderBy>;
};

/** All input for the `deleteFinancialAccount` mutation. */
export type DeleteFinancialAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `FinancialAccount` mutation. */
export type DeleteFinancialAccountPayload = {
  __typename?: 'DeleteFinancialAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `FinancialAccount` that was deleted by this mutation. */
  financialAccount: Maybe<FinancialAccount>;
  /** An edge for our `FinancialAccount`. May be used by Relay 1. */
  financialAccountEdge: Maybe<FinancialAccountEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `FinancialAccount` mutation. */
export type DeleteFinancialAccountPayloadFinancialAccountEdgeArgs = {
  orderBy?: Array<FinancialAccountOrderBy>;
};

/** All input for the `deleteFinancialOperation` mutation. */
export type DeleteFinancialOperationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `FinancialOperation` mutation. */
export type DeleteFinancialOperationPayload = {
  __typename?: 'DeleteFinancialOperationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `FinancialOperation` that was deleted by this mutation. */
  financialOperation: Maybe<FinancialOperation>;
  /** An edge for our `FinancialOperation`. May be used by Relay 1. */
  financialOperationEdge: Maybe<FinancialOperationEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `FinancialOperation` mutation. */
export type DeleteFinancialOperationPayloadFinancialOperationEdgeArgs = {
  orderBy?: Array<FinancialOperationOrderBy>;
};

/** All input for the `deleteInKindContribution` mutation. */
export type DeleteInKindContributionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `InKindContribution` mutation. */
export type DeleteInKindContributionPayload = {
  __typename?: 'DeleteInKindContributionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `InKindContribution` that was deleted by this mutation. */
  inKindContribution: Maybe<InKindContribution>;
  /** An edge for our `InKindContribution`. May be used by Relay 1. */
  inKindContributionEdge: Maybe<InKindContributionEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `InKindContribution` mutation. */
export type DeleteInKindContributionPayloadInKindContributionEdgeArgs = {
  orderBy?: Array<InKindContributionOrderBy>;
};

/** All input for the `deleteMember` mutation. */
export type DeleteMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Member` mutation. */
export type DeleteMemberPayload = {
  __typename?: 'DeleteMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Member` that was deleted by this mutation. */
  member: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge: Maybe<MemberEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Member` mutation. */
export type DeleteMemberPayloadMemberEdgeArgs = {
  orderBy?: Array<MemberOrderBy>;
};

/** All input for the `deleteMeterByMeterNo` mutation. */
export type DeleteMeterByMeterNoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  meterNo: Scalars['String']['input'];
};

/** All input for the `deleteMeter` mutation. */
export type DeleteMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Meter` mutation. */
export type DeleteMeterPayload = {
  __typename?: 'DeleteMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Meter` that was deleted by this mutation. */
  meter: Maybe<Meter>;
  /** An edge for our `Meter`. May be used by Relay 1. */
  meterEdge: Maybe<MeterEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Meter` mutation. */
export type DeleteMeterPayloadMeterEdgeArgs = {
  orderBy?: Array<MeterOrderBy>;
};

/** All input for the `deleteNotification` mutation. */
export type DeleteNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Notification` mutation. */
export type DeleteNotificationPayload = {
  __typename?: 'DeleteNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Notification` that was deleted by this mutation. */
  notification: Maybe<Notification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<NotificationEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Notification` mutation. */
export type DeleteNotificationPayloadNotificationEdgeArgs = {
  orderBy?: Array<NotificationOrderBy>;
};

/** All input for the `deleteOperationCategoryByName` mutation. */
export type DeleteOperationCategoryByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** All input for the `deleteOperationCategory` mutation. */
export type DeleteOperationCategoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `OperationCategory` mutation. */
export type DeleteOperationCategoryPayload = {
  __typename?: 'DeleteOperationCategoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `OperationCategory` that was deleted by this mutation. */
  operationCategory: Maybe<OperationCategory>;
  /** An edge for our `OperationCategory`. May be used by Relay 1. */
  operationCategoryEdge: Maybe<OperationCategoryEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `OperationCategory` mutation. */
export type DeleteOperationCategoryPayloadOperationCategoryEdgeArgs = {
  orderBy?: Array<OperationCategoryOrderBy>;
};

/** All input for the `deletePaymentByReceiptNo` mutation. */
export type DeletePaymentByReceiptNoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Receipt number, sequential per year of payment_date (e.g. 2026-00042). Assigned automatically. */
  receiptNo: Scalars['String']['input'];
};

/** All input for the `deletePayment` mutation. */
export type DeletePaymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Payment` mutation. */
export type DeletePaymentPayload = {
  __typename?: 'DeletePaymentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Payment` that was deleted by this mutation. */
  payment: Maybe<Payment>;
  /** An edge for our `Payment`. May be used by Relay 1. */
  paymentEdge: Maybe<PaymentEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Payment` mutation. */
export type DeletePaymentPayloadPaymentEdgeArgs = {
  orderBy?: Array<PaymentOrderBy>;
};

/** All input for the `deleteProject` mutation. */
export type DeleteProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `Project` mutation. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Project` that was deleted by this mutation. */
  project: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge: Maybe<ProjectEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our delete `Project` mutation. */
export type DeleteProjectPayloadProjectEdgeArgs = {
  orderBy?: Array<ProjectOrderBy>;
};

/** All input for the `deleteShartPerson` mutation. */
export type DeleteShartPersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ShartPerson` mutation. */
export type DeleteShartPersonPayload = {
  __typename?: 'DeleteShartPersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ShartPerson` that was deleted by this mutation. */
  shartPerson: Maybe<ShartPerson>;
  /** An edge for our `ShartPerson`. May be used by Relay 1. */
  shartPersonEdge: Maybe<ShartPersonEdge>;
};


/** The output of our delete `ShartPerson` mutation. */
export type DeleteShartPersonPayloadShartPersonEdgeArgs = {
  orderBy?: Array<ShartPersonOrderBy>;
};

/** Fees of a configuration. Written by appSaveBillingConfiguration only. */
export type FeeConfiguration = {
  __typename?: 'FeeConfiguration';
  /** Dirhams (FIXED) or percent (PERCENTAGE). */
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `BillingConfiguration` that is related to this `FeeConfiguration`. */
  billingConfiguration: Maybe<BillingConfiguration>;
  /** Configuration it belongs to. */
  billingConfigurationId: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['Datetime']['output']>;
  /** Optional explanation. */
  description: Maybe<Scalars['String']['output']>;
  /** FIXED: amount in dirhams. PERCENTAGE: percent of the consumption price. */
  feeType: FeeType;
  id: Scalars['Int']['output'];
  /** Name shown on invoices. */
  name: Scalars['String']['output'];
  /** Applies only to bills with zero consumption (e.g. a meter freeze fee). Replaces matching «freeze» in the name. */
  onlyWhenNoConsumption: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `FeeConfiguration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FeeConfigurationCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `billingConfigurationId` field. */
  billingConfigurationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `feeType` field. */
  feeType?: InputMaybe<FeeType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `onlyWhenNoConsumption` field. */
  onlyWhenNoConsumption?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `FeeConfiguration` values. */
export type FeeConfigurationConnection = {
  __typename?: 'FeeConfigurationConnection';
  /** A list of edges which contains the `FeeConfiguration` and cursor to aid in pagination. */
  edges: Array<Maybe<FeeConfigurationEdge>>;
  /** A list of `FeeConfiguration` objects. */
  nodes: Array<Maybe<FeeConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FeeConfiguration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FeeConfiguration` edge in the connection. */
export type FeeConfigurationEdge = {
  __typename?: 'FeeConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FeeConfiguration` at the end of the edge. */
  node: Maybe<FeeConfiguration>;
};

/** A filter to be used against `FeeConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type FeeConfigurationFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FeeConfigurationFilter>>;
  /** Filter by the object’s `billingConfiguration` relation. */
  billingConfiguration?: InputMaybe<BillingConfigurationFilter>;
  /** A related `billingConfiguration` exists. */
  billingConfigurationExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `billingConfigurationId` field. */
  billingConfigurationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `feeType` field. */
  feeType?: InputMaybe<FeeTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FeeConfigurationFilter>;
  /** Filter by the object’s `onlyWhenNoConsumption` field. */
  onlyWhenNoConsumption?: InputMaybe<BooleanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FeeConfigurationFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Methods to use when ordering `FeeConfiguration`. */
export type FeeConfigurationOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'BILLING_CONFIGURATION_ID_ASC'
  | 'BILLING_CONFIGURATION_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'ONLY_WHEN_NO_CONSUMPTION_ASC'
  | 'ONLY_WHEN_NO_CONSUMPTION_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type FeeType =
  | 'FIXED'
  | 'PERCENTAGE';

/** A filter to be used against FeeType fields. All fields are combined with a logical ‘and.’ */
export type FeeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FeeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FeeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FeeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FeeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FeeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FeeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FeeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FeeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FeeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FeeType>>;
};

/** Who changed what in the finances: changes = { column: [before, after] } (only the changed columns; ids for references). Newest first with orderBy CHANGED_AT_DESC. */
export type FinanceChange = {
  __typename?: 'FinanceChange';
  action: Scalars['String']['output'];
  changedAt: Scalars['Datetime']['output'];
  changedBy: Maybe<Scalars['String']['output']>;
  changes: Scalars['JSON']['output'];
  /** operation, transfer, debt, in_kind, account, project, counterparty, category. */
  entity: Scalars['String']['output'];
  entityId: Scalars['UUID']['output'];
  id: Scalars['BigInt']['output'];
};

/**
 * A condition to be used against `FinanceChange` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FinanceChangeCondition = {
  /** Checks for equality with the object’s `action` field. */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `changedAt` field. */
  changedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `changedBy` field. */
  changedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `entity` field. */
  entity?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `entityId` field. */
  entityId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
};

/** A connection to a list of `FinanceChange` values. */
export type FinanceChangeConnection = {
  __typename?: 'FinanceChangeConnection';
  /** A list of edges which contains the `FinanceChange` and cursor to aid in pagination. */
  edges: Array<Maybe<FinanceChangeEdge>>;
  /** A list of `FinanceChange` objects. */
  nodes: Array<Maybe<FinanceChange>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FinanceChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FinanceChange` edge in the connection. */
export type FinanceChangeEdge = {
  __typename?: 'FinanceChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FinanceChange` at the end of the edge. */
  node: Maybe<FinanceChange>;
};

/** A filter to be used against `FinanceChange` object types. All fields are combined with a logical ‘and.’ */
export type FinanceChangeFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FinanceChangeFilter>>;
  /** Filter by the object’s `changedAt` field. */
  changedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `changedBy` field. */
  changedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `entity` field. */
  entity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `entityId` field. */
  entityId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FinanceChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FinanceChangeFilter>>;
};

/** Methods to use when ordering `FinanceChange`. */
export type FinanceChangeOrderBy =
  | 'ACTION_ASC'
  | 'ACTION_DESC'
  | 'CHANGED_AT_ASC'
  | 'CHANGED_AT_DESC'
  | 'CHANGED_BY_ASC'
  | 'CHANGED_BY_DESC'
  | 'ENTITY_ASC'
  | 'ENTITY_DESC'
  | 'ENTITY_ID_ASC'
  | 'ENTITY_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** Which operations to export: every field is optional and they combine (and). */
export type FinanceExportFilter = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  includeTransfers?: InputMaybe<Scalars['Boolean']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  source?: InputMaybe<OperationSource>;
  type?: InputMaybe<FinancialOperationType>;
};

export type FinanceExportFormat =
  | 'CSV'
  | 'XLSX';

/** A row waiting for a review: an operation (not a transfer's), a transfer or an in-kind contribution. */
export type FinanceReviewItem = {
  __typename?: 'FinanceReviewItem';
  /** Account name; «from → to» for a transfer; null for in kind. */
  account: Maybe<Scalars['String']['output']>;
  /** The amount, or the estimated value of an in-kind contribution. */
  amount: Scalars['BigFloat']['output'];
  date: Scalars['Date']['output'];
  description: Maybe<Scalars['String']['output']>;
  hasReceipt: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  /** operation, transfer or in_kind. */
  kind: Scalars['String']['output'];
  project: Maybe<Scalars['String']['output']>;
  reviewNote: Maybe<Scalars['String']['output']>;
  reviewRequestedAt: Maybe<Scalars['Datetime']['output']>;
  reviewRequestedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `FinanceReviewItem` values. */
export type FinanceReviewItemConnection = {
  __typename?: 'FinanceReviewItemConnection';
  /** A list of edges which contains the `FinanceReviewItem` and cursor to aid in pagination. */
  edges: Array<Maybe<FinanceReviewItemEdge>>;
  /** A list of `FinanceReviewItem` objects. */
  nodes: Array<Maybe<FinanceReviewItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FinanceReviewItem` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FinanceReviewItem` edge in the connection. */
export type FinanceReviewItemEdge = {
  __typename?: 'FinanceReviewItemEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FinanceReviewItem` at the end of the edge. */
  node: Maybe<FinanceReviewItem>;
};

/** A filter to be used against `FinanceReviewItem` object types. All fields are combined with a logical ‘and.’ */
export type FinanceReviewItemFilter = {
  /** Filter by the object’s `account` field. */
  account?: InputMaybe<StringFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FinanceReviewItemFilter>>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hasReceipt` field. */
  hasReceipt?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FinanceReviewItemFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FinanceReviewItemFilter>>;
  /** Filter by the object’s `project` field. */
  project?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<StringFilter>;
};

/** Income, expenses and result of one group of operations. */
export type FinanceTotal = {
  __typename?: 'FinanceTotal';
  /** Number of operations. */
  count: Scalars['Int']['output'];
  expenses: Scalars['BigFloat']['output'];
  income: Scalars['BigFloat']['output'];
  /** The group: an id, «YYYY-MM» for month, «all» for none; null for operations without a category or counterparty. */
  key: Maybe<Scalars['String']['output']>;
  /** What to show: name, «غشت 2026», «بدون صنف»… */
  label: Scalars['String']['output'];
  /** income − expenses. */
  result: Scalars['BigFloat']['output'];
};

/** A connection to a list of `FinanceTotal` values. */
export type FinanceTotalConnection = {
  __typename?: 'FinanceTotalConnection';
  /** A list of edges which contains the `FinanceTotal` and cursor to aid in pagination. */
  edges: Array<Maybe<FinanceTotalEdge>>;
  /** A list of `FinanceTotal` objects. */
  nodes: Array<Maybe<FinanceTotal>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FinanceTotal` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FinanceTotal` edge in the connection. */
export type FinanceTotalEdge = {
  __typename?: 'FinanceTotalEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FinanceTotal` at the end of the edge. */
  node: Maybe<FinanceTotal>;
};

/** A filter to be used against `FinanceTotal` object types. All fields are combined with a logical ‘and.’ */
export type FinanceTotalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FinanceTotalFilter>>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expenses` field. */
  expenses?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `income` field. */
  income?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FinanceTotalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FinanceTotalFilter>>;
  /** Filter by the object’s `result` field. */
  result?: InputMaybe<BigFloatFilter>;
};

export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `AccountTransfer`. */
  accountTransfersByFromAccountId: AccountTransferConnection;
  /** Reads and enables pagination through a set of `AccountTransfer`. */
  accountTransfersByToAccountId: AccountTransferConnection;
  /** @deprecated Not maintained: use currentBalance. */
  balance: Scalars['BigFloat']['output'];
  /** Opening balance plus the operations after the opening date, up to this date included. */
  balanceAt: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `BankStatement`. */
  bankStatementsByAccountId: BankStatementConnection;
  createdAt: Scalars['Datetime']['output'];
  /** Opening balance plus every operation after the opening date. */
  currentBalance: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperationsByAccountId: FinancialOperationConnection;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  /** Balance on opening_date; the current balance is computed (currentBalance). */
  openingBalance: Scalars['BigFloat']['output'];
  /** Date of the opening balance: operations on or before it are not added again. */
  openingDate: Maybe<Scalars['Date']['output']>;
  type: FinancialAccountType;
  updatedAt: Scalars['Datetime']['output'];
};


export type FinancialAccountAccountTransfersByFromAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountTransferCondition>;
  filter?: InputMaybe<AccountTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTransferOrderBy>>;
};


export type FinancialAccountAccountTransfersByToAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountTransferCondition>;
  filter?: InputMaybe<AccountTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTransferOrderBy>>;
};


export type FinancialAccountBalanceAtArgs = {
  at: Scalars['Date']['input'];
};


export type FinancialAccountBankStatementsByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementCondition>;
  filter?: InputMaybe<BankStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementOrderBy>>;
};


export type FinancialAccountFinancialOperationsByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};

/**
 * A condition to be used against `FinancialAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FinancialAccountCondition = {
  /** Checks for equality with the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `openingBalance` field. */
  openingBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `openingDate` field. */
  openingDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<FinancialAccountType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `FinancialAccount` values. */
export type FinancialAccountConnection = {
  __typename?: 'FinancialAccountConnection';
  /** A list of edges which contains the `FinancialAccount` and cursor to aid in pagination. */
  edges: Array<Maybe<FinancialAccountEdge>>;
  /** A list of `FinancialAccount` objects. */
  nodes: Array<Maybe<FinancialAccount>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FinancialAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FinancialAccount` edge in the connection. */
export type FinancialAccountEdge = {
  __typename?: 'FinancialAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FinancialAccount` at the end of the edge. */
  node: Maybe<FinancialAccount>;
};

/** A filter to be used against `FinancialAccount` object types. All fields are combined with a logical ‘and.’ */
export type FinancialAccountFilter = {
  /** Filter by the object’s `accountNumber` field. */
  accountNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `accountTransfersByFromAccountId` relation. */
  accountTransfersByFromAccountId?: InputMaybe<FinancialAccountToManyAccountTransferFilter>;
  /** Some related `accountTransfersByFromAccountId` exist. */
  accountTransfersByFromAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountTransfersByToAccountId` relation. */
  accountTransfersByToAccountId?: InputMaybe<FinancialAccountToManyAccountTransferFilter>;
  /** Some related `accountTransfersByToAccountId` exist. */
  accountTransfersByToAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FinancialAccountFilter>>;
  /** Filter by the object’s `balance` field. */
  balance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bankStatementsByAccountId` relation. */
  bankStatementsByAccountId?: InputMaybe<FinancialAccountToManyBankStatementFilter>;
  /** Some related `bankStatementsByAccountId` exist. */
  bankStatementsByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `currentBalance` field. */
  currentBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `financialOperationsByAccountId` relation. */
  financialOperationsByAccountId?: InputMaybe<FinancialAccountToManyFinancialOperationFilter>;
  /** Some related `financialOperationsByAccountId` exist. */
  financialOperationsByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FinancialAccountFilter>;
  /** Filter by the object’s `openingBalance` field. */
  openingBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `openingDate` field. */
  openingDate?: InputMaybe<DateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FinancialAccountFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<FinancialAccountTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FinancialAccount` */
export type FinancialAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  /** Balance on opening_date; the current balance is computed (currentBalance). */
  openingBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Date of the opening balance: operations on or before it are not added again. */
  openingDate?: InputMaybe<Scalars['Date']['input']>;
  type: FinancialAccountType;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Methods to use when ordering `FinancialAccount`. */
export type FinancialAccountOrderBy =
  | 'ACCOUNT_NUMBER_ASC'
  | 'ACCOUNT_NUMBER_DESC'
  | 'BALANCE_ASC'
  | 'BALANCE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'OPENING_BALANCE_ASC'
  | 'OPENING_BALANCE_DESC'
  | 'OPENING_DATE_ASC'
  | 'OPENING_DATE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Represents an update to a `FinancialAccount`. Fields that are set will be updated. */
export type FinancialAccountPatch = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Balance on opening_date; the current balance is computed (currentBalance). */
  openingBalance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Date of the opening balance: operations on or before it are not added again. */
  openingDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<FinancialAccountType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `AccountTransfer` object types. All fields are combined with a logical ‘and.’ */
export type FinancialAccountToManyAccountTransferFilter = {
  /** Every related `AccountTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountTransferFilter>;
  /** No related `AccountTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountTransferFilter>;
  /** Some related `AccountTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountTransferFilter>;
};

/** A filter to be used against many `BankStatement` object types. All fields are combined with a logical ‘and.’ */
export type FinancialAccountToManyBankStatementFilter = {
  /** Every related `BankStatement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BankStatementFilter>;
  /** No related `BankStatement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BankStatementFilter>;
  /** Some related `BankStatement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BankStatementFilter>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type FinancialAccountToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

export type FinancialAccountType =
  | 'bank_account'
  | 'cash';

/** A filter to be used against FinancialAccountType fields. All fields are combined with a logical ‘and.’ */
export type FinancialAccountTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FinancialAccountType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FinancialAccountType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FinancialAccountType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FinancialAccountType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FinancialAccountType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FinancialAccountType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FinancialAccountType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FinancialAccountType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FinancialAccountType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FinancialAccountType>>;
};

export type FinancialOperation = {
  __typename?: 'FinancialOperation';
  /** Reads a single `FinancialAccount` that is related to this `FinancialOperation`. */
  account: Maybe<FinancialAccount>;
  accountId: Scalars['UUID']['output'];
  amount: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `BankStatementLine`. */
  bankStatementLinesByMatchedOperationId: BankStatementLineConnection;
  /** Reads a single `OperationCategory` that is related to this `FinancialOperation`. */
  category: Maybe<OperationCategory>;
  categoryId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `Counterparty` that is related to this `FinancialOperation`. */
  counterparty: Maybe<Counterparty>;
  counterpartyId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Datetime']['output'];
  date: Scalars['Date']['output'];
  /** Reads a single `Debt` that is related to this `FinancialOperation`. */
  debt: Maybe<Debt>;
  /** Loan principal received or paid, or a repayment: not counted as income or spending. */
  debtId: Maybe<Scalars['UUID']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  needsReview: Scalars['Boolean']['output'];
  /** Reads a single `Project` that is related to this `FinancialOperation`. */
  project: Maybe<Project>;
  /** Required, except on the two operations of a transfer. */
  projectId: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `Photo` that is related to this `FinancialOperation`. */
  receiptPhoto: Maybe<Photo>;
  /** Photo of the receipt (POST /photos?kind=RECEIPT). Required for expenses from settings.receiptPhotoMinAmount. */
  receiptPhotoId: Maybe<Scalars['UUID']['output']>;
  reviewNote: Maybe<Scalars['String']['output']>;
  /** Set automatically when needsReview changes. */
  reviewRequestedAt: Maybe<Scalars['Datetime']['output']>;
  /** Set automatically when needsReview changes. */
  reviewRequestedBy: Maybe<Scalars['String']['output']>;
  /** Set automatically when needsReview changes. */
  reviewedAt: Maybe<Scalars['Datetime']['output']>;
  /** Set automatically when needsReview changes. */
  reviewedBy: Maybe<Scalars['String']['output']>;
  /** manual, transfer (generated) or ledger_import (history). */
  source: OperationSource;
  /** Reads a single `AccountTransfer` that is related to this `FinancialOperation`. */
  transfer: Maybe<AccountTransfer>;
  /** Set on the two operations generated by a transfer. */
  transferId: Maybe<Scalars['UUID']['output']>;
  type: FinancialOperationType;
  updatedAt: Scalars['Datetime']['output'];
};


export type FinancialOperationBankStatementLinesByMatchedOperationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementLineCondition>;
  filter?: InputMaybe<BankStatementLineFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementLineOrderBy>>;
};

/**
 * A condition to be used against `FinancialOperation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FinancialOperationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `categoryId` field. */
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `debtId` field. */
  debtId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `needsReview` field. */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `receiptPhotoId` field. */
  receiptPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reviewedAt` field. */
  reviewedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<OperationSource>;
  /** Checks for equality with the object’s `transferId` field. */
  transferId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<FinancialOperationType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `FinancialOperation` values. */
export type FinancialOperationConnection = {
  __typename?: 'FinancialOperationConnection';
  /** A list of edges which contains the `FinancialOperation` and cursor to aid in pagination. */
  edges: Array<Maybe<FinancialOperationEdge>>;
  /** A list of `FinancialOperation` objects. */
  nodes: Array<Maybe<FinancialOperation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FinancialOperation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `FinancialOperation` edge in the connection. */
export type FinancialOperationEdge = {
  __typename?: 'FinancialOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `FinancialOperation` at the end of the edge. */
  node: Maybe<FinancialOperation>;
};

/** A filter to be used against `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type FinancialOperationFilter = {
  /** Filter by the object’s `account` relation. */
  account?: InputMaybe<FinancialAccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FinancialOperationFilter>>;
  /** Filter by the object’s `bankStatementLinesByMatchedOperationId` relation. */
  bankStatementLinesByMatchedOperationId?: InputMaybe<FinancialOperationToManyBankStatementLineFilter>;
  /** Some related `bankStatementLinesByMatchedOperationId` exist. */
  bankStatementLinesByMatchedOperationIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `category` relation. */
  category?: InputMaybe<OperationCategoryFilter>;
  /** A related `category` exists. */
  categoryExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `categoryId` field. */
  categoryId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `counterparty` relation. */
  counterparty?: InputMaybe<CounterpartyFilter>;
  /** A related `counterparty` exists. */
  counterpartyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `debt` relation. */
  debt?: InputMaybe<DebtFilter>;
  /** A related `debt` exists. */
  debtExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `debtId` field. */
  debtId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `needsReview` field. */
  needsReview?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FinancialOperationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FinancialOperationFilter>>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `receiptPhoto` relation. */
  receiptPhoto?: InputMaybe<PhotoFilter>;
  /** A related `receiptPhoto` exists. */
  receiptPhotoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `receiptPhotoId` field. */
  receiptPhotoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewedAt` field. */
  reviewedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<OperationSourceFilter>;
  /** Filter by the object’s `transfer` relation. */
  transfer?: InputMaybe<AccountTransferFilter>;
  /** A related `transfer` exists. */
  transferExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `transferId` field. */
  transferId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<FinancialOperationTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `FinancialOperation` */
export type FinancialOperationInput = {
  accountId: Scalars['UUID']['input'];
  amount: Scalars['BigFloat']['input'];
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Loan principal received or paid, or a repayment: not counted as income or spending. */
  debtId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required, except on the two operations of a transfer. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Photo of the receipt (POST /photos?kind=RECEIPT). Required for expenses from settings.receiptPhotoMinAmount. */
  receiptPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  type: FinancialOperationType;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Methods to use when ordering `FinancialOperation`. */
export type FinancialOperationOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'CATEGORY_ID_ASC'
  | 'CATEGORY_ID_DESC'
  | 'COUNTERPARTY_ID_ASC'
  | 'COUNTERPARTY_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'DEBT_ID_ASC'
  | 'DEBT_ID_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NEEDS_REVIEW_ASC'
  | 'NEEDS_REVIEW_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'RECEIPT_PHOTO_ID_ASC'
  | 'RECEIPT_PHOTO_ID_DESC'
  | 'REVIEWED_AT_ASC'
  | 'REVIEWED_AT_DESC'
  | 'REVIEWED_BY_ASC'
  | 'REVIEWED_BY_DESC'
  | 'REVIEW_NOTE_ASC'
  | 'REVIEW_NOTE_DESC'
  | 'REVIEW_REQUESTED_AT_ASC'
  | 'REVIEW_REQUESTED_AT_DESC'
  | 'REVIEW_REQUESTED_BY_ASC'
  | 'REVIEW_REQUESTED_BY_DESC'
  | 'TRANSFER_ID_ASC'
  | 'TRANSFER_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Represents an update to a `FinancialOperation`. Fields that are set will be updated. */
export type FinancialOperationPatch = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Loan principal received or paid, or a repayment: not counted as income or spending. */
  debtId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required, except on the two operations of a transfer. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Photo of the receipt (POST /photos?kind=RECEIPT). Required for expenses from settings.receiptPhotoMinAmount. */
  receiptPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FinancialOperationType>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against many `BankStatementLine` object types. All fields are combined with a logical ‘and.’ */
export type FinancialOperationToManyBankStatementLineFilter = {
  /** Every related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BankStatementLineFilter>;
  /** No related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BankStatementLineFilter>;
  /** Some related `BankStatementLine` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BankStatementLineFilter>;
};

export type FinancialOperationType =
  | 'credit'
  | 'debit';

/** A filter to be used against FinancialOperationType fields. All fields are combined with a logical ‘and.’ */
export type FinancialOperationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FinancialOperationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FinancialOperationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FinancialOperationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FinancialOperationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FinancialOperationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FinancialOperationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FinancialOperationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FinancialOperationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FinancialOperationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FinancialOperationType>>;
};

/** Value received without cash (works, materials paid by a donor). Kept outside the accounts. */
export type InKindContribution = {
  __typename?: 'InKindContribution';
  /** Reads a single `Counterparty` that is related to this `InKindContribution`. */
  counterparty: Maybe<Counterparty>;
  counterpartyId: Maybe<Scalars['UUID']['output']>;
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  /** Reads a single `Photo` that is related to this `InKindContribution`. */
  documentPhoto: Maybe<Photo>;
  documentPhotoId: Maybe<Scalars['UUID']['output']>;
  estimatedValue: Scalars['BigFloat']['output'];
  id: Scalars['UUID']['output'];
  needsReview: Scalars['Boolean']['output'];
  /** Reads a single `Project` that is related to this `InKindContribution`. */
  project: Maybe<Project>;
  projectId: Maybe<Scalars['UUID']['output']>;
  reviewNote: Maybe<Scalars['String']['output']>;
  /** Set automatically when needsReview changes. */
  reviewRequestedAt: Maybe<Scalars['Datetime']['output']>;
  /** Set automatically when needsReview changes. */
  reviewRequestedBy: Maybe<Scalars['String']['output']>;
  /** Set automatically when needsReview changes. */
  reviewedAt: Maybe<Scalars['Datetime']['output']>;
  /** Set automatically when needsReview changes. */
  reviewedBy: Maybe<Scalars['String']['output']>;
  /** How the value was estimated: invoice, quote, estimate… */
  valuationBasis: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `InKindContribution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InKindContributionCondition = {
  /** Checks for equality with the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `date` field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `documentPhotoId` field. */
  documentPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `estimatedValue` field. */
  estimatedValue?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `needsReview` field. */
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `projectId` field. */
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reviewedAt` field. */
  reviewedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `valuationBasis` field. */
  valuationBasis?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `InKindContribution` values. */
export type InKindContributionConnection = {
  __typename?: 'InKindContributionConnection';
  /** A list of edges which contains the `InKindContribution` and cursor to aid in pagination. */
  edges: Array<Maybe<InKindContributionEdge>>;
  /** A list of `InKindContribution` objects. */
  nodes: Array<Maybe<InKindContribution>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InKindContribution` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InKindContribution` edge in the connection. */
export type InKindContributionEdge = {
  __typename?: 'InKindContributionEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `InKindContribution` at the end of the edge. */
  node: Maybe<InKindContribution>;
};

/** A filter to be used against `InKindContribution` object types. All fields are combined with a logical ‘and.’ */
export type InKindContributionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InKindContributionFilter>>;
  /** Filter by the object’s `counterparty` relation. */
  counterparty?: InputMaybe<CounterpartyFilter>;
  /** A related `counterparty` exists. */
  counterpartyExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `counterpartyId` field. */
  counterpartyId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `date` field. */
  date?: InputMaybe<DateFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `documentPhoto` relation. */
  documentPhoto?: InputMaybe<PhotoFilter>;
  /** A related `documentPhoto` exists. */
  documentPhotoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `documentPhotoId` field. */
  documentPhotoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `estimatedValue` field. */
  estimatedValue?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `needsReview` field. */
  needsReview?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InKindContributionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InKindContributionFilter>>;
  /** Filter by the object’s `project` relation. */
  project?: InputMaybe<ProjectFilter>;
  /** A related `project` exists. */
  projectExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `projectId` field. */
  projectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `reviewNote` field. */
  reviewNote?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewRequestedAt` field. */
  reviewRequestedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewRequestedBy` field. */
  reviewRequestedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reviewedAt` field. */
  reviewedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `reviewedBy` field. */
  reviewedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `valuationBasis` field. */
  valuationBasis?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `InKindContribution` */
export type InKindContributionInput = {
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  date: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  documentPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  estimatedValue: Scalars['BigFloat']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  /** How the value was estimated: invoice, quote, estimate… */
  valuationBasis?: InputMaybe<Scalars['String']['input']>;
};

/** Methods to use when ordering `InKindContribution`. */
export type InKindContributionOrderBy =
  | 'COUNTERPARTY_ID_ASC'
  | 'COUNTERPARTY_ID_DESC'
  | 'DATE_ASC'
  | 'DATE_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'DOCUMENT_PHOTO_ID_ASC'
  | 'DOCUMENT_PHOTO_ID_DESC'
  | 'ESTIMATED_VALUE_ASC'
  | 'ESTIMATED_VALUE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NEEDS_REVIEW_ASC'
  | 'NEEDS_REVIEW_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECT_ID_ASC'
  | 'PROJECT_ID_DESC'
  | 'REVIEWED_AT_ASC'
  | 'REVIEWED_AT_DESC'
  | 'REVIEWED_BY_ASC'
  | 'REVIEWED_BY_DESC'
  | 'REVIEW_NOTE_ASC'
  | 'REVIEW_NOTE_DESC'
  | 'REVIEW_REQUESTED_AT_ASC'
  | 'REVIEW_REQUESTED_AT_DESC'
  | 'REVIEW_REQUESTED_BY_ASC'
  | 'REVIEW_REQUESTED_BY_DESC'
  | 'VALUATION_BASIS_ASC'
  | 'VALUATION_BASIS_DESC';

/** Represents an update to a `InKindContribution`. Fields that are set will be updated. */
export type InKindContributionPatch = {
  counterpartyId?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentPhotoId?: InputMaybe<Scalars['UUID']['input']>;
  estimatedValue?: InputMaybe<Scalars['BigFloat']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  reviewNote?: InputMaybe<Scalars['String']['input']>;
  /** How the value was estimated: invoice, quote, estimate… */
  valuationBasis?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type LateListAudience =
  | 'COMMITTEE'
  | 'PUBLIC';

export type Member = {
  __typename?: 'Member';
  /** Reads and enables pagination through a set of `Bill`. */
  bills: BillConnection;
  /** Role on the association's committee; null = not on the committee. Committee members with an email receive the weekly report. */
  committeeRole: Maybe<CommitteeRole>;
  /** Whose phone contact_phone is, e.g. «ابنه عبد الله». */
  contactName: Maybe<Scalars['String']['output']>;
  /** Phone to use for reminders instead of the member's own, e.g. a son's or daughter's. */
  contactPhone: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Credit not used yet (dirhams). */
  creditBalance: Scalars['BigFloat']['output'];
  email: Maybe<Scalars['String']['output']>;
  fatherName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  joinedAt: Scalars['Datetime']['output'];
  lastName: Scalars['String']['output'];
  /** LEFT members: the date they left. */
  leftAt: Maybe<Scalars['Date']['output']>;
  /** LEFT members: why. */
  leftReason: Maybe<Scalars['String']['output']>;
  memberAddress: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `MemberCredit`. */
  memberCredits: MemberCreditConnection;
  /** Reads and enables pagination through a set of `MemberStatusChange`. */
  memberStatusChanges: MemberStatusChangeConnection;
  /** Reads and enables pagination through a set of `Meter`. */
  meters: MeterConnection;
  /**
   * Signed link to the member's payment notice: every unpaid bill, what
   * remains on each and how late it is.
   */
  noticeLink: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationConnection;
  /** How to send reminders: WHATSAPP (default), SMS, or NONE (the member asked not to be messaged). */
  notifyChannel: NotifyChannel;
  /** Number reminders are sent to (+212 format): contactPhone if set, else phone. */
  notifyPhone: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  /** Whether reminders can reach this member: OK (mobile), MISSING, INVALID (fix the number) or LANDLINE (no WhatsApp/SMS). */
  phoneStatus: Maybe<PhoneStatus>;
  sex: MemberSex;
  /** Reads and enables pagination through a set of `ShartPerson`. */
  shartPeople: ShartPersonConnection;
  /**
   * Signed link to the member's account statement (كشف الحساب): the last 12
   * months of bills and payments with a running balance, and meter readings.
   */
  statementLink: Scalars['String']['output'];
  /** Change it with appChangeMemberStatus (kept in memberStatusChanges). */
  status: MemberStatus;
  updatedAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `WhatsappMessage`. */
  whatsappMessages: WhatsappMessageConnection;
};


export type MemberBillsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillCondition>;
  filter?: InputMaybe<BillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOrderBy>>;
};


export type MemberMemberCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCreditCondition>;
  filter?: InputMaybe<MemberCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberCreditOrderBy>>;
};


export type MemberMemberStatusChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberStatusChangeCondition>;
  filter?: InputMaybe<MemberStatusChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberStatusChangeOrderBy>>;
};


export type MemberMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterCondition>;
  filter?: InputMaybe<MeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterOrderBy>>;
};


export type MemberNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderBy>>;
};


export type MemberShartPeopleArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShartPersonCondition>;
  filter?: InputMaybe<ShartPersonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShartPersonOrderBy>>;
};


export type MemberWhatsappMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WhatsappMessageCondition>;
  filter?: InputMaybe<WhatsappMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhatsappMessageOrderBy>>;
};

/** A condition to be used against `Member` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MemberCondition = {
  /** Checks for equality with the object’s `committeeRole` field. */
  committeeRole?: InputMaybe<CommitteeRole>;
  /** Checks for equality with the object’s `contactName` field. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fatherName` field. */
  fatherName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `joinedAt` field. */
  joinedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `leftAt` field. */
  leftAt?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `leftReason` field. */
  leftReason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberAddress` field. */
  memberAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `notifyChannel` field. */
  notifyChannel?: InputMaybe<NotifyChannel>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sex` field. */
  sex?: InputMaybe<MemberSex>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MemberStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `Member` values. */
export type MemberConnection = {
  __typename?: 'MemberConnection';
  /** A list of edges which contains the `Member` and cursor to aid in pagination. */
  edges: Array<Maybe<MemberEdge>>;
  /** A list of `Member` objects. */
  nodes: Array<Maybe<Member>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Member` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Member credit ledger (kind: GRANTED, USED, RELEASED, RETURNED). Balance = sum of amounts. A bill's creditApplied = −(USED + RELEASED lines on it). Granted with appGrantMemberCredit. */
export type MemberCredit = {
  __typename?: 'MemberCredit';
  /** Dirhams: negative for USED, positive otherwise. */
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Bill` that is related to this `MemberCredit`. */
  bill: Maybe<Bill>;
  /** GRANTED: the bill the credit comes from (optional). USED / RELEASED: the bill it was deducted from / given back from. */
  billId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  kind: CreditKind;
  /** Reads a single `Member` that is related to this `MemberCredit`. */
  member: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  /** Why (shown to the committee and on documents). */
  reason: Scalars['String']['output'];
};

/**
 * A condition to be used against `MemberCredit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MemberCreditCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `billId` field. */
  billId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<CreditKind>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `MemberCredit` values. */
export type MemberCreditConnection = {
  __typename?: 'MemberCreditConnection';
  /** A list of edges which contains the `MemberCredit` and cursor to aid in pagination. */
  edges: Array<Maybe<MemberCreditEdge>>;
  /** A list of `MemberCredit` objects. */
  nodes: Array<Maybe<MemberCredit>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberCredit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberCredit` edge in the connection. */
export type MemberCreditEdge = {
  __typename?: 'MemberCreditEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberCredit` at the end of the edge. */
  node: Maybe<MemberCredit>;
};

/** A filter to be used against `MemberCredit` object types. All fields are combined with a logical ‘and.’ */
export type MemberCreditFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MemberCreditFilter>>;
  /** Filter by the object’s `bill` relation. */
  bill?: InputMaybe<BillFilter>;
  /** A related `bill` exists. */
  billExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `billId` field. */
  billId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<CreditKindFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MemberCreditFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MemberCreditFilter>>;
  /** Filter by the object’s `reason` field. */
  reason?: InputMaybe<StringFilter>;
};

/** Methods to use when ordering `MemberCredit`. */
export type MemberCreditOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'BILL_ID_ASC'
  | 'BILL_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ASC'
  | 'CREATED_BY_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REASON_ASC'
  | 'REASON_DESC';

/** A `Member` edge in the connection. */
export type MemberEdge = {
  __typename?: 'MemberEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Member` at the end of the edge. */
  node: Maybe<Member>;
};

/** A filter to be used against `Member` object types. All fields are combined with a logical ‘and.’ */
export type MemberFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MemberFilter>>;
  /** Filter by the object’s `bills` relation. */
  bills?: InputMaybe<MemberToManyBillFilter>;
  /** Some related `bills` exist. */
  billsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `committeeRole` field. */
  committeeRole?: InputMaybe<CommitteeRoleFilter>;
  /** Filter by the object’s `contactName` field. */
  contactName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creditBalance` field. */
  creditBalance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fatherName` field. */
  fatherName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `joinedAt` field. */
  joinedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `leftAt` field. */
  leftAt?: InputMaybe<DateFilter>;
  /** Filter by the object’s `leftReason` field. */
  leftReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `memberAddress` field. */
  memberAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `memberCredits` relation. */
  memberCredits?: InputMaybe<MemberToManyMemberCreditFilter>;
  /** Some related `memberCredits` exist. */
  memberCreditsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `memberStatusChanges` relation. */
  memberStatusChanges?: InputMaybe<MemberToManyMemberStatusChangeFilter>;
  /** Some related `memberStatusChanges` exist. */
  memberStatusChangesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `meters` relation. */
  meters?: InputMaybe<MemberToManyMeterFilter>;
  /** Some related `meters` exist. */
  metersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `notifications` relation. */
  notifications?: InputMaybe<MemberToManyNotificationFilter>;
  /** Some related `notifications` exist. */
  notificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `notifyChannel` field. */
  notifyChannel?: InputMaybe<NotifyChannelFilter>;
  /** Filter by the object’s `notifyPhone` field. */
  notifyPhone?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MemberFilter>>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `phoneStatus` field. */
  phoneStatus?: InputMaybe<PhoneStatusFilter>;
  /** Filter by the object’s `sex` field. */
  sex?: InputMaybe<MemberSexFilter>;
  /** Filter by the object’s `shartPeople` relation. */
  shartPeople?: InputMaybe<MemberToManyShartPersonFilter>;
  /** Some related `shartPeople` exist. */
  shartPeopleExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<MemberStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `whatsappMessages` relation. */
  whatsappMessages?: InputMaybe<MemberToManyWhatsappMessageFilter>;
  /** Some related `whatsappMessages` exist. */
  whatsappMessagesExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `Member` */
export type MemberInput = {
  /** Role on the association's committee; null = not on the committee. Committee members with an email receive the weekly report. */
  committeeRole?: InputMaybe<CommitteeRole>;
  /** Whose phone contact_phone is, e.g. «ابنه عبد الله». */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Phone to use for reminders instead of the member's own, e.g. a son's or daughter's. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fatherName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  joinedAt?: InputMaybe<Scalars['Datetime']['input']>;
  lastName: Scalars['String']['input'];
  /** LEFT members: the date they left. */
  leftAt?: InputMaybe<Scalars['Date']['input']>;
  /** LEFT members: why. */
  leftReason?: InputMaybe<Scalars['String']['input']>;
  memberAddress: Scalars['String']['input'];
  /** How to send reminders: WHATSAPP (default), SMS, or NONE (the member asked not to be messaged). */
  notifyChannel?: InputMaybe<NotifyChannel>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex: MemberSex;
  /** Change it with appChangeMemberStatus (kept in memberStatusChanges). */
  status?: InputMaybe<MemberStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Methods to use when ordering `Member`. */
export type MemberOrderBy =
  | 'CONTACT_NAME_ASC'
  | 'CONTACT_NAME_DESC'
  | 'CONTACT_PHONE_ASC'
  | 'CONTACT_PHONE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'FATHER_NAME_ASC'
  | 'FATHER_NAME_DESC'
  | 'FIRST_NAME_ASC'
  | 'FIRST_NAME_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'JOINED_AT_ASC'
  | 'JOINED_AT_DESC'
  | 'LAST_NAME_ASC'
  | 'LAST_NAME_DESC'
  | 'LEFT_AT_ASC'
  | 'LEFT_AT_DESC'
  | 'LEFT_REASON_ASC'
  | 'LEFT_REASON_DESC'
  | 'MEMBER_ADDRESS_ASC'
  | 'MEMBER_ADDRESS_DESC'
  | 'NATURAL'
  | 'PHONE_ASC'
  | 'PHONE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Represents an update to a `Member`. Fields that are set will be updated. */
export type MemberPatch = {
  /** Role on the association's committee; null = not on the committee. Committee members with an email receive the weekly report. */
  committeeRole?: InputMaybe<CommitteeRole>;
  /** Whose phone contact_phone is, e.g. «ابنه عبد الله». */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Phone to use for reminders instead of the member's own, e.g. a son's or daughter's. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fatherName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  joinedAt?: InputMaybe<Scalars['Datetime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** LEFT members: the date they left. */
  leftAt?: InputMaybe<Scalars['Date']['input']>;
  /** LEFT members: why. */
  leftReason?: InputMaybe<Scalars['String']['input']>;
  memberAddress?: InputMaybe<Scalars['String']['input']>;
  /** How to send reminders: WHATSAPP (default), SMS, or NONE (the member asked not to be messaged). */
  notifyChannel?: InputMaybe<NotifyChannel>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<MemberSex>;
  /** Change it with appChangeMemberStatus (kept in memberStatusChanges). */
  status?: InputMaybe<MemberStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type MemberReminder = {
  __typename?: 'MemberReminder';
  /** Total still owed on unpaid bills. */
  amountDue: Scalars['BigFloat']['output'];
  associationName: Scalars['String']['output'];
  billsCount: Scalars['Int']['output'];
  contactPhone: Maybe<Scalars['String']['output']>;
  /** Days since the oldest unpaid bill's due date (0 if none is past due). */
  daysOverdue: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  /** REMINDER while no bill is past due; LATE_NOTICE once one is. */
  kind: NotificationKind;
  lastRemindedAt: Maybe<Scalars['Datetime']['output']>;
  memberId: Scalars['UUID']['output'];
  /** Signed link to the member's payment notice (included in the messages). */
  noticeLink: Scalars['String']['output'];
  notifyChannel: NotifyChannel;
  notifyPhone: Maybe<Scalars['String']['output']>;
  oldestBillMonth: Maybe<Scalars['Date']['output']>;
  oldestDueDate: Maybe<Scalars['Date']['output']>;
  phoneStatus: PhoneStatus;
  /** Overdue longer than settings.public_arrears_after_days. */
  publiclyListed: Scalars['Boolean']['output'];
  remindersSent: Scalars['Int']['output'];
  /** Short reminder text for SMS (Arabic SMS segments hold 70 characters). */
  smsMessage: Scalars['String']['output'];
  /** Opens the SMS app with the message pre-filled. Null when the member has no usable mobile number. */
  smsUrl: Maybe<Scalars['String']['output']>;
  /** Full reminder text for WhatsApp, in standard Arabic. */
  whatsappMessage: Scalars['String']['output'];
  /** Opens WhatsApp on the treasurer's phone with the message pre-filled. Null when the member has no usable mobile number. */
  whatsappUrl: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `MemberReminder` values. */
export type MemberReminderConnection = {
  __typename?: 'MemberReminderConnection';
  /** A list of edges which contains the `MemberReminder` and cursor to aid in pagination. */
  edges: Array<Maybe<MemberReminderEdge>>;
  /** A list of `MemberReminder` objects. */
  nodes: Array<Maybe<MemberReminder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberReminder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberReminder` edge in the connection. */
export type MemberReminderEdge = {
  __typename?: 'MemberReminderEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberReminder` at the end of the edge. */
  node: Maybe<MemberReminder>;
};

/** A filter to be used against `MemberReminder` object types. All fields are combined with a logical ‘and.’ */
export type MemberReminderFilter = {
  /** Filter by the object’s `amountDue` field. */
  amountDue?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MemberReminderFilter>>;
  /** Filter by the object’s `associationName` field. */
  associationName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `billsCount` field. */
  billsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `daysOverdue` field. */
  daysOverdue?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fullName` field. */
  fullName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<NotificationKindFilter>;
  /** Filter by the object’s `lastRemindedAt` field. */
  lastRemindedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MemberReminderFilter>;
  /** Filter by the object’s `notifyChannel` field. */
  notifyChannel?: InputMaybe<NotifyChannelFilter>;
  /** Filter by the object’s `notifyPhone` field. */
  notifyPhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `oldestBillMonth` field. */
  oldestBillMonth?: InputMaybe<DateFilter>;
  /** Filter by the object’s `oldestDueDate` field. */
  oldestDueDate?: InputMaybe<DateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MemberReminderFilter>>;
  /** Filter by the object’s `phoneStatus` field. */
  phoneStatus?: InputMaybe<PhoneStatusFilter>;
  /** Filter by the object’s `publiclyListed` field. */
  publiclyListed?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `remindersSent` field. */
  remindersSent?: InputMaybe<IntFilter>;
};

export type MemberSex =
  | 'FEMALE'
  | 'MALE';

/** A filter to be used against MemberSex fields. All fields are combined with a logical ‘and.’ */
export type MemberSexFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MemberSex>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MemberSex>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MemberSex>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MemberSex>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MemberSex>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MemberSex>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MemberSex>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MemberSex>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MemberSex>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MemberSex>>;
};

/**
 * ACTIVE: member of the association. LEFT: left (date and reason); their unpaid
 * bills stay visible, including on the public late-payers list, until paid.
 */
export type MemberStatus =
  | 'ACTIVE'
  | 'LEFT';

/** History of member status changes (appChangeMemberStatus). */
export type MemberStatusChange = {
  __typename?: 'MemberStatusChange';
  changedAt: Scalars['Datetime']['output'];
  changedBy: Maybe<Scalars['String']['output']>;
  changedOn: Scalars['Date']['output'];
  fromStatus: Maybe<MemberStatus>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Member` that is related to this `MemberStatusChange`. */
  member: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  reason: Scalars['String']['output'];
  toStatus: MemberStatus;
};

/**
 * A condition to be used against `MemberStatusChange` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MemberStatusChangeCondition = {
  /** Checks for equality with the object’s `changedAt` field. */
  changedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `changedBy` field. */
  changedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `changedOn` field. */
  changedOn?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `fromStatus` field. */
  fromStatus?: InputMaybe<MemberStatus>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `toStatus` field. */
  toStatus?: InputMaybe<MemberStatus>;
};

/** A connection to a list of `MemberStatusChange` values. */
export type MemberStatusChangeConnection = {
  __typename?: 'MemberStatusChangeConnection';
  /** A list of edges which contains the `MemberStatusChange` and cursor to aid in pagination. */
  edges: Array<Maybe<MemberStatusChangeEdge>>;
  /** A list of `MemberStatusChange` objects. */
  nodes: Array<Maybe<MemberStatusChange>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MemberStatusChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MemberStatusChange` edge in the connection. */
export type MemberStatusChangeEdge = {
  __typename?: 'MemberStatusChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `MemberStatusChange` at the end of the edge. */
  node: Maybe<MemberStatusChange>;
};

/** A filter to be used against `MemberStatusChange` object types. All fields are combined with a logical ‘and.’ */
export type MemberStatusChangeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MemberStatusChangeFilter>>;
  /** Filter by the object’s `changedAt` field. */
  changedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `changedBy` field. */
  changedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `changedOn` field. */
  changedOn?: InputMaybe<DateFilter>;
  /** Filter by the object’s `fromStatus` field. */
  fromStatus?: InputMaybe<MemberStatusFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MemberStatusChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MemberStatusChangeFilter>>;
  /** Filter by the object’s `reason` field. */
  reason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toStatus` field. */
  toStatus?: InputMaybe<MemberStatusFilter>;
};

/** Methods to use when ordering `MemberStatusChange`. */
export type MemberStatusChangeOrderBy =
  | 'CHANGED_AT_ASC'
  | 'CHANGED_AT_DESC'
  | 'CHANGED_BY_ASC'
  | 'CHANGED_BY_DESC'
  | 'CHANGED_ON_ASC'
  | 'CHANGED_ON_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REASON_ASC'
  | 'REASON_DESC';

/** A filter to be used against MemberStatus fields. All fields are combined with a logical ‘and.’ */
export type MemberStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MemberStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MemberStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MemberStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MemberStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MemberStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MemberStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MemberStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MemberStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MemberStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MemberStatus>>;
};

/** A filter to be used against many `Bill` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyBillFilter = {
  /** Every related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BillFilter>;
  /** No related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BillFilter>;
  /** Some related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BillFilter>;
};

/** A filter to be used against many `MemberCredit` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMemberCreditFilter = {
  /** Every related `MemberCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberCreditFilter>;
  /** No related `MemberCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberCreditFilter>;
  /** Some related `MemberCredit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberCreditFilter>;
};

/** A filter to be used against many `MemberStatusChange` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMemberStatusChangeFilter = {
  /** Every related `MemberStatusChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MemberStatusChangeFilter>;
  /** No related `MemberStatusChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MemberStatusChangeFilter>;
  /** Some related `MemberStatusChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MemberStatusChangeFilter>;
};

/** A filter to be used against many `Meter` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyMeterFilter = {
  /** Every related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MeterFilter>;
  /** No related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MeterFilter>;
  /** Some related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MeterFilter>;
};

/** A filter to be used against many `Notification` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyNotificationFilter = {
  /** Every related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NotificationFilter>;
  /** No related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NotificationFilter>;
  /** Some related `Notification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NotificationFilter>;
};

/** A filter to be used against many `ShartPerson` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyShartPersonFilter = {
  /** Every related `ShartPerson` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ShartPersonFilter>;
  /** No related `ShartPerson` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ShartPersonFilter>;
  /** Some related `ShartPerson` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ShartPersonFilter>;
};

/** A filter to be used against many `WhatsappMessage` object types. All fields are combined with a logical ‘and.’ */
export type MemberToManyWhatsappMessageFilter = {
  /** Every related `WhatsappMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<WhatsappMessageFilter>;
  /** No related `WhatsappMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<WhatsappMessageFilter>;
  /** Some related `WhatsappMessage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<WhatsappMessageFilter>;
};

export type Meter = {
  __typename?: 'Meter';
  /** Reads and enables pagination through a set of `Bill`. */
  bills: BillConnection;
  connectedAt: Scalars['Datetime']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  /** How to name this meter to a member: its number when it has a real one, otherwise its address. */
  label: Maybe<Scalars['String']['output']>;
  /** Reads a single `Member` that is related to this `Meter`. */
  member: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  meterAddress: Scalars['String']['output'];
  /** Reads a single `Meter` that is related to this `Meter`. */
  meterByReplacedBy: Maybe<Meter>;
  meterNo: Scalars['String']['output'];
  /** Current status. Change it with appChangeMeterStatus (kept in meterStatusChanges). */
  meterStatus: MeterStatus;
  /** Reads and enables pagination through a set of `MeterStatusChange`. */
  meterStatusChanges: MeterStatusChangeConnection;
  /** Reads and enables pagination through a set of `MeterStatusChange`. */
  meterStatusChangesByReplacedBy: MeterStatusChangeConnection;
  /** Reads and enables pagination through a set of `Meter`. */
  metersByReplacedBy: MeterConnection;
  /** Reads a single `Photo` that is related to this `Meter`. */
  photo: Maybe<Photo>;
  /** Photo of the meter at installation (POST /photos?kind=METER_READING): required for new meters. */
  photoId: Maybe<Scalars['UUID']['output']>;
  /** REPLACED meters: the meter that replaced it. */
  replacedBy: Maybe<Scalars['UUID']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  /** Since when (date of the last status change). */
  statusChangedAt: Maybe<Scalars['Date']['output']>;
  /** Why the meter has its current status. */
  statusReason: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};


export type MeterBillsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillCondition>;
  filter?: InputMaybe<BillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOrderBy>>;
};


export type MeterMeterStatusChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatusChangeCondition>;
  filter?: InputMaybe<MeterStatusChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatusChangeOrderBy>>;
};


export type MeterMeterStatusChangesByReplacedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatusChangeCondition>;
  filter?: InputMaybe<MeterStatusChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatusChangeOrderBy>>;
};


export type MeterMetersByReplacedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterCondition>;
  filter?: InputMaybe<MeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterOrderBy>>;
};

/** A condition to be used against `Meter` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MeterCondition = {
  /** Checks for equality with the object’s `connectedAt` field. */
  connectedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `meterAddress` field. */
  meterAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `meterNo` field. */
  meterNo?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `meterStatus` field. */
  meterStatus?: InputMaybe<MeterStatus>;
  /** Checks for equality with the object’s `photoId` field. */
  photoId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `replacedBy` field. */
  replacedBy?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `statusChangedAt` field. */
  statusChangedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `statusReason` field. */
  statusReason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `Meter` values. */
export type MeterConnection = {
  __typename?: 'MeterConnection';
  /** A list of edges which contains the `Meter` and cursor to aid in pagination. */
  edges: Array<Maybe<MeterEdge>>;
  /** A list of `Meter` objects. */
  nodes: Array<Maybe<Meter>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Meter` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Meter` edge in the connection. */
export type MeterEdge = {
  __typename?: 'MeterEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Meter` at the end of the edge. */
  node: Maybe<Meter>;
};

/** A filter to be used against `Meter` object types. All fields are combined with a logical ‘and.’ */
export type MeterFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterFilter>>;
  /** Filter by the object’s `bills` relation. */
  bills?: InputMaybe<MeterToManyBillFilter>;
  /** Some related `bills` exist. */
  billsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `connectedAt` field. */
  connectedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `meterAddress` field. */
  meterAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterByReplacedBy` relation. */
  meterByReplacedBy?: InputMaybe<MeterFilter>;
  /** A related `meterByReplacedBy` exists. */
  meterByReplacedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `meterNo` field. */
  meterNo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `meterStatus` field. */
  meterStatus?: InputMaybe<MeterStatusFilter>;
  /** Filter by the object’s `meterStatusChanges` relation. */
  meterStatusChanges?: InputMaybe<MeterToManyMeterStatusChangeFilter>;
  /** Filter by the object’s `meterStatusChangesByReplacedBy` relation. */
  meterStatusChangesByReplacedBy?: InputMaybe<MeterToManyMeterStatusChangeFilter>;
  /** Some related `meterStatusChangesByReplacedBy` exist. */
  meterStatusChangesByReplacedByExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Some related `meterStatusChanges` exist. */
  meterStatusChangesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `metersByReplacedBy` relation. */
  metersByReplacedBy?: InputMaybe<MeterToManyMeterFilter>;
  /** Some related `metersByReplacedBy` exist. */
  metersByReplacedByExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<MeterFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterFilter>>;
  /** Filter by the object’s `photo` relation. */
  photo?: InputMaybe<PhotoFilter>;
  /** A related `photo` exists. */
  photoExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `photoId` field. */
  photoId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `replacedBy` field. */
  replacedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `sortOrder` field. */
  sortOrder?: InputMaybe<IntFilter>;
  /** Filter by the object’s `statusChangedAt` field. */
  statusChangedAt?: InputMaybe<DateFilter>;
  /** Filter by the object’s `statusReason` field. */
  statusReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Meter` */
export type MeterInput = {
  connectedAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  memberId: Scalars['UUID']['input'];
  meterAddress: Scalars['String']['input'];
  meterNo: Scalars['String']['input'];
  /** Current status. Change it with appChangeMeterStatus (kept in meterStatusChanges). */
  meterStatus?: InputMaybe<MeterStatus>;
  /** Photo of the meter at installation (POST /photos?kind=METER_READING): required for new meters. */
  photoId?: InputMaybe<Scalars['UUID']['input']>;
  /** REPLACED meters: the meter that replaced it. */
  replacedBy?: InputMaybe<Scalars['UUID']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Since when (date of the last status change). */
  statusChangedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Why the meter has its current status. */
  statusReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Methods to use when ordering `Meter`. */
export type MeterOrderBy =
  | 'CONNECTED_AT_ASC'
  | 'CONNECTED_AT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'METER_ADDRESS_ASC'
  | 'METER_ADDRESS_DESC'
  | 'METER_NO_ASC'
  | 'METER_NO_DESC'
  | 'NATURAL'
  | 'PHOTO_ID_ASC'
  | 'PHOTO_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REPLACED_BY_ASC'
  | 'REPLACED_BY_DESC'
  | 'SORT_ORDER_ASC'
  | 'SORT_ORDER_DESC'
  | 'STATUS_CHANGED_AT_ASC'
  | 'STATUS_CHANGED_AT_DESC'
  | 'STATUS_REASON_ASC'
  | 'STATUS_REASON_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Represents an update to a `Meter`. Fields that are set will be updated. */
export type MeterPatch = {
  connectedAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  meterAddress?: InputMaybe<Scalars['String']['input']>;
  meterNo?: InputMaybe<Scalars['String']['input']>;
  /** Current status. Change it with appChangeMeterStatus (kept in meterStatusChanges). */
  meterStatus?: InputMaybe<MeterStatus>;
  /** Photo of the meter at installation (POST /photos?kind=METER_READING): required for new meters. */
  photoId?: InputMaybe<Scalars['UUID']['input']>;
  /** REPLACED meters: the meter that replaced it. */
  replacedBy?: InputMaybe<Scalars['UUID']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  /** Since when (date of the last status change). */
  statusChangedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Why the meter has its current status. */
  statusReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/**
 * CONNECTED: billed every month. SUSPENDED: cut for late payment, no bill,
 * reconnected once paid. DAMAGED: broken, no bill until repaired. REPLACED:
 * swapped for another meter (final). REMOVED: taken back by the association
 * (final). CLOSED: closed at the member's request or because the member left (final).
 */
export type MeterStatus =
  | 'CLOSED'
  | 'CONNECTED'
  | 'DAMAGED'
  | 'REMOVED'
  | 'REPLACED'
  | 'SUSPENDED';

/** History of meter status changes (appChangeMeterStatus). */
export type MeterStatusChange = {
  __typename?: 'MeterStatusChange';
  changedAt: Scalars['Datetime']['output'];
  changedBy: Maybe<Scalars['String']['output']>;
  /** Date the change happened (may be earlier than when it was recorded). */
  changedOn: Scalars['Date']['output'];
  fromStatus: Maybe<MeterStatus>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Meter` that is related to this `MeterStatusChange`. */
  meter: Maybe<Meter>;
  /** Reads a single `Meter` that is related to this `MeterStatusChange`. */
  meterByReplacedBy: Maybe<Meter>;
  meterId: Scalars['UUID']['output'];
  /** Meter reading at the time of the change, if noted. */
  reading: Maybe<Scalars['Int']['output']>;
  reason: Scalars['String']['output'];
  replacedBy: Maybe<Scalars['UUID']['output']>;
  toStatus: MeterStatus;
};

/**
 * A condition to be used against `MeterStatusChange` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MeterStatusChangeCondition = {
  /** Checks for equality with the object’s `changedAt` field. */
  changedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `changedBy` field. */
  changedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `changedOn` field. */
  changedOn?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `fromStatus` field. */
  fromStatus?: InputMaybe<MeterStatus>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `meterId` field. */
  meterId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `reading` field. */
  reading?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `replacedBy` field. */
  replacedBy?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `toStatus` field. */
  toStatus?: InputMaybe<MeterStatus>;
};

/** A connection to a list of `MeterStatusChange` values. */
export type MeterStatusChangeConnection = {
  __typename?: 'MeterStatusChangeConnection';
  /** A list of edges which contains the `MeterStatusChange` and cursor to aid in pagination. */
  edges: Array<Maybe<MeterStatusChangeEdge>>;
  /** A list of `MeterStatusChange` objects. */
  nodes: Array<Maybe<MeterStatusChange>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MeterStatusChange` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MeterStatusChange` edge in the connection. */
export type MeterStatusChangeEdge = {
  __typename?: 'MeterStatusChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `MeterStatusChange` at the end of the edge. */
  node: Maybe<MeterStatusChange>;
};

/** A filter to be used against `MeterStatusChange` object types. All fields are combined with a logical ‘and.’ */
export type MeterStatusChangeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MeterStatusChangeFilter>>;
  /** Filter by the object’s `changedAt` field. */
  changedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `changedBy` field. */
  changedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `changedOn` field. */
  changedOn?: InputMaybe<DateFilter>;
  /** Filter by the object’s `fromStatus` field. */
  fromStatus?: InputMaybe<MeterStatusFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `meter` relation. */
  meter?: InputMaybe<MeterFilter>;
  /** Filter by the object’s `meterByReplacedBy` relation. */
  meterByReplacedBy?: InputMaybe<MeterFilter>;
  /** A related `meterByReplacedBy` exists. */
  meterByReplacedByExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `meterId` field. */
  meterId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MeterStatusChangeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MeterStatusChangeFilter>>;
  /** Filter by the object’s `reading` field. */
  reading?: InputMaybe<IntFilter>;
  /** Filter by the object’s `reason` field. */
  reason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `replacedBy` field. */
  replacedBy?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `toStatus` field. */
  toStatus?: InputMaybe<MeterStatusFilter>;
};

/** Methods to use when ordering `MeterStatusChange`. */
export type MeterStatusChangeOrderBy =
  | 'CHANGED_AT_ASC'
  | 'CHANGED_AT_DESC'
  | 'CHANGED_BY_ASC'
  | 'CHANGED_BY_DESC'
  | 'CHANGED_ON_ASC'
  | 'CHANGED_ON_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'METER_ID_ASC'
  | 'METER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'READING_ASC'
  | 'READING_DESC'
  | 'REASON_ASC'
  | 'REASON_DESC'
  | 'REPLACED_BY_ASC'
  | 'REPLACED_BY_DESC';

/** A filter to be used against MeterStatus fields. All fields are combined with a logical ‘and.’ */
export type MeterStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MeterStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MeterStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MeterStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MeterStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MeterStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MeterStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MeterStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MeterStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MeterStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MeterStatus>>;
};

/** A filter to be used against many `Bill` object types. All fields are combined with a logical ‘and.’ */
export type MeterToManyBillFilter = {
  /** Every related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BillFilter>;
  /** No related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BillFilter>;
  /** Some related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BillFilter>;
};

/** A filter to be used against many `Meter` object types. All fields are combined with a logical ‘and.’ */
export type MeterToManyMeterFilter = {
  /** Every related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MeterFilter>;
  /** No related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MeterFilter>;
  /** Some related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MeterFilter>;
};

/** A filter to be used against many `MeterStatusChange` object types. All fields are combined with a logical ‘and.’ */
export type MeterToManyMeterStatusChangeFilter = {
  /** Every related `MeterStatusChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MeterStatusChangeFilter>;
  /** No related `MeterStatusChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MeterStatusChangeFilter>;
  /** Some related `MeterStatusChange` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MeterStatusChangeFilter>;
};

export type MonthSummary = {
  __typename?: 'MonthSummary';
  /** Consumption charges invoiced this month. */
  billedConsumption: Scalars['BigFloat']['output'];
  /** Fees invoiced this month. */
  billedFees: Scalars['BigFloat']['output'];
  /** Shart invoiced this month. */
  billedShart: Scalars['BigFloat']['output'];
  /** Sum of the stored totals of this month's bills (what members owe). */
  billedTotal: Scalars['BigFloat']['output'];
  billsCount: Scalars['Int']['output'];
  /** Water consumed (m³) by the bills of this month. */
  consumption: Scalars['Int']['output'];
  /** Member credit deducted from the month's bills (not cash): billedTotal = billed parts − creditsApplied. */
  creditsApplied: Scalars['BigFloat']['output'];
  month: Scalars['Date']['output'];
  /** Share of this month's payments that paid consumption. */
  paidConsumption: Scalars['BigFloat']['output'];
  /** Share of this month's payments that paid fees. */
  paidFees: Scalars['BigFloat']['output'];
  /** Share of this month's payments that paid shart. */
  paidShart: Scalars['BigFloat']['output'];
  paymentsCount: Scalars['Int']['output'];
  /** Money received this month. */
  paymentsTotal: Scalars['BigFloat']['output'];
};

/** A connection to a list of `MonthSummary` values. */
export type MonthSummaryConnection = {
  __typename?: 'MonthSummaryConnection';
  /** A list of edges which contains the `MonthSummary` and cursor to aid in pagination. */
  edges: Array<Maybe<MonthSummaryEdge>>;
  /** A list of `MonthSummary` objects. */
  nodes: Array<Maybe<MonthSummary>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MonthSummary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MonthSummary` edge in the connection. */
export type MonthSummaryEdge = {
  __typename?: 'MonthSummaryEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `MonthSummary` at the end of the edge. */
  node: Maybe<MonthSummary>;
};

/** A filter to be used against `MonthSummary` object types. All fields are combined with a logical ‘and.’ */
export type MonthSummaryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonthSummaryFilter>>;
  /** Filter by the object’s `billedConsumption` field. */
  billedConsumption?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `billedFees` field. */
  billedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `billedShart` field. */
  billedShart?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `billedTotal` field. */
  billedTotal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `billsCount` field. */
  billsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `consumption` field. */
  consumption?: InputMaybe<IntFilter>;
  /** Filter by the object’s `creditsApplied` field. */
  creditsApplied?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `month` field. */
  month?: InputMaybe<DateFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MonthSummaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonthSummaryFilter>>;
  /** Filter by the object’s `paidConsumption` field. */
  paidConsumption?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `paidFees` field. */
  paidFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `paidShart` field. */
  paidShart?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `paymentsCount` field. */
  paymentsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `paymentsTotal` field. */
  paymentsTotal?: InputMaybe<BigFloatFilter>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  appBulkSavePayments: Maybe<AppBulkSavePaymentsPayload>;
  /** Marks a member as LEFT (or ACTIVE again), with reason and date; kept in memberStatusChanges. LEFT needs all their meters closed, removed or replaced first. Their unpaid bills stay visible. */
  appChangeMemberStatus: Maybe<AppChangeMemberStatusPayload>;
  /** Changes a meter's status (with reason, date, optional reading; REPLACED needs the new meter). Kept in meterStatusChanges. Only CONNECTED meters get new bills; REPLACED, REMOVED and CLOSED are final. */
  appChangeMeterStatus: Maybe<AppChangeMeterStatusPayload>;
  appCloseBankStatement: Maybe<AppCloseBankStatementPayload>;
  /** Creates the operation of a statement line (date, amount, direction and account from the line; description defaults to the line's label) and matches it. The statement is its proof: no receipt photo required. */
  appCreateOperationFromLine: Maybe<AppCreateOperationFromLinePayload>;
  /** Creates the transfer of a statement line with another account (+ on the statement: from the other account into this one) and matches it. */
  appCreateTransferFromLine: Maybe<AppCreateTransferFromLinePayload>;
  /** Deletes the latest configuration if no bill uses it yet (e.g. a scheduled one saved by mistake); the previous one applies again. A used configuration can't be deleted (CONFIG_IN_USE). */
  appDeleteBillingConfiguration: Maybe<AppDeleteBillingConfigurationPayload>;
  /** Flags an operation, transfer or in-kind contribution for review, with a note (added to the existing one). Open to the committee, which otherwise only reads the finances. An operation of a transfer flags the transfer. */
  appFlagForReview: Maybe<AppFlagForReviewPayload>;
  /** Grants a credit to a member (e.g. an overpayment to give back). It is deducted at once from their unpaid bills, oldest first, or from their next bill. Cash records are not changed. */
  appGrantMemberCredit: Maybe<AppGrantMemberCreditPayload>;
  /** Ignores a line that needs no record (with a reason), or un-ignores it. */
  appIgnoreStatementLine: Maybe<AppIgnoreStatementLinePayload>;
  /** Imports a bank statement: lines = [{ date, label, amount (signed: + into the bank), balance?, reference? }]. Checks every line is in the period and that opening + lines = closing; with dryRun nothing is saved and lines already imported are reported (a real import refuses them). documentPhotoId: the statement PDF (kind RECEIPT). */
  appImportBankStatement: Maybe<AppImportBankStatementPayload>;
  /** Matches a statement line to an operation or a transfer of the same account and the same signed amount (a transfer: its leg on this account). */
  appMatchStatementLine: Maybe<AppMatchStatementLinePayload>;
  appRecordReminder: Maybe<AppRecordReminderPayload>;
  /** Changes the name and description only (allowed even when the configuration is in use: prices and dates never change). */
  appRenameBillingConfiguration: Maybe<AppRenameBillingConfigurationPayload>;
  appReopenBankStatement: Maybe<AppReopenBankStatementPayload>;
  /**
   * Creates a price configuration from effectiveFrom (1st of a month, after the last billed month and after the latest configuration). The previous configuration ends the day before. Saving never edits an existing configuration: to change prices, save a new one. Preview it first with billingPreview.
   *
   * shartUnitPrice: shart price per person and month; default the latest configuration's.
   *
   * Example (PROGRESSIVE): tiers [{tierStart: 1, tierEnd: 30, rate: "4"}, {tierStart: 31, tierEnd: null, rate: "7"}], fees [{name: "ربط العداد بالشبكة", feeType: FIXED, amount: "5"}], shartUnitPrice: "18".
   * Example (FIXED): tiers [{tierStart: 1, tierEnd: null, rate: "4"}], fees [{name: "واجب التجميد", feeType: FIXED, amount: "10", onlyWhenNoConsumption: true}].
   */
  appSaveBillingConfiguration: Maybe<AppSaveBillingConfigurationPayload>;
  /** Creates the bill of a reading, or corrects one (billId). Shart comes from the member's shart people and the billing configuration (new bills only). Unusual consumption needs photoId (see readingCheck). */
  appSaveConsumptionBill: Maybe<AppSaveConsumptionBillPayload>;
  appSavePayment: Maybe<AppSavePaymentPayload>;
  appSendInvoiceWhatsapp: Maybe<AppSendInvoiceWhatsappPayload>;
  /** Committee: send the month's unpaid invoices by WhatsApp, after checking the readings. Skips bills already sent, paid bills, and members without WhatsApp. */
  appSendMonthInvoices: Maybe<AppSendMonthInvoicesPayload>;
  /** Sets (needsReview true) or clears (false) the review flag of up to 500 rows of one kind (operation, transfer, in_kind); note replaces the review note when given. All or nothing. Returns the number of rows. */
  appSetReview: Maybe<AppSetReviewPayload>;
  appUnmatchStatementLine: Maybe<AppUnmatchStatementLinePayload>;
  /** Changes up to 500 operations at once, all or nothing. patch: any of categoryId, counterpartyId, projectId, needsReview, reviewNote, description (null empties a field). Every rule still applies; a refused row's error carries operationId, date and amount. Returns the number of operations changed. */
  appUpdateFinancialOperations: Maybe<AppUpdateFinancialOperationsPayload>;
  /** Creates a single `AccountTransfer`. */
  createAccountTransfer: Maybe<CreateAccountTransferPayload>;
  /** Creates a single `AssociationDocument`. */
  createAssociationDocument: Maybe<CreateAssociationDocumentPayload>;
  /** Creates a single `AssociationDocumentFile`. */
  createAssociationDocumentFile: Maybe<CreateAssociationDocumentFilePayload>;
  /** Creates a single `Counterparty`. */
  createCounterparty: Maybe<CreateCounterpartyPayload>;
  /** Creates a single `Debt`. */
  createDebt: Maybe<CreateDebtPayload>;
  /** Creates a single `FinancialAccount`. */
  createFinancialAccount: Maybe<CreateFinancialAccountPayload>;
  /** Creates a single `FinancialOperation`. */
  createFinancialOperation: Maybe<CreateFinancialOperationPayload>;
  /** Creates a single `InKindContribution`. */
  createInKindContribution: Maybe<CreateInKindContributionPayload>;
  /** Creates a single `Member`. */
  createMember: Maybe<CreateMemberPayload>;
  /** Creates a single `Meter`. */
  createMeter: Maybe<CreateMeterPayload>;
  /** Creates a single `OperationCategory`. */
  createOperationCategory: Maybe<CreateOperationCategoryPayload>;
  /** Creates a single `Project`. */
  createProject: Maybe<CreateProjectPayload>;
  /** Creates a single `ShartPerson`. */
  createShartPerson: Maybe<CreateShartPersonPayload>;
  /** Deletes a single `AccountTransfer` using a unique key. */
  deleteAccountTransfer: Maybe<DeleteAccountTransferPayload>;
  /** Deletes a single `AssociationDocument` using a unique key. */
  deleteAssociationDocument: Maybe<DeleteAssociationDocumentPayload>;
  /** Deletes a single `AssociationDocumentFile` using a unique key. */
  deleteAssociationDocumentFile: Maybe<DeleteAssociationDocumentFilePayload>;
  /** Deletes a single `AssociationDocumentFile` using a unique key. */
  deleteAssociationDocumentFileByDocumentIdAndPhotoId: Maybe<DeleteAssociationDocumentFilePayload>;
  /** Deletes a single `BankStatement` using a unique key. */
  deleteBankStatement: Maybe<DeleteBankStatementPayload>;
  /** Deletes a single `Bill` using a unique key. */
  deleteBill: Maybe<DeleteBillPayload>;
  /** Deletes a single `Counterparty` using a unique key. */
  deleteCounterparty: Maybe<DeleteCounterpartyPayload>;
  /** Deletes a single `Counterparty` using a unique key. */
  deleteCounterpartyByName: Maybe<DeleteCounterpartyPayload>;
  /** Deletes a single `Debt` using a unique key. */
  deleteDebt: Maybe<DeleteDebtPayload>;
  /** Deletes a single `FinancialAccount` using a unique key. */
  deleteFinancialAccount: Maybe<DeleteFinancialAccountPayload>;
  /** Deletes a single `FinancialOperation` using a unique key. */
  deleteFinancialOperation: Maybe<DeleteFinancialOperationPayload>;
  /** Deletes a single `InKindContribution` using a unique key. */
  deleteInKindContribution: Maybe<DeleteInKindContributionPayload>;
  /** Deletes a single `Member` using a unique key. */
  deleteMember: Maybe<DeleteMemberPayload>;
  /** Deletes a single `Meter` using a unique key. */
  deleteMeter: Maybe<DeleteMeterPayload>;
  /** Deletes a single `Meter` using a unique key. */
  deleteMeterByMeterNo: Maybe<DeleteMeterPayload>;
  /** Deletes a single `Notification` using a unique key. */
  deleteNotification: Maybe<DeleteNotificationPayload>;
  /** Deletes a single `OperationCategory` using a unique key. */
  deleteOperationCategory: Maybe<DeleteOperationCategoryPayload>;
  /** Deletes a single `OperationCategory` using a unique key. */
  deleteOperationCategoryByName: Maybe<DeleteOperationCategoryPayload>;
  /** Deletes a single `Payment` using a unique key. */
  deletePayment: Maybe<DeletePaymentPayload>;
  /** Deletes a single `Payment` using a unique key. */
  deletePaymentByReceiptNo: Maybe<DeletePaymentPayload>;
  /** Deletes a single `Project` using a unique key. */
  deleteProject: Maybe<DeleteProjectPayload>;
  /** Deletes a single `ShartPerson` using a unique key. */
  deleteShartPerson: Maybe<DeleteShartPersonPayload>;
  /** Updates a single `AccountTransfer` using a unique key and a patch. */
  updateAccountTransfer: Maybe<UpdateAccountTransferPayload>;
  /** Updates a single `AssociationDocument` using a unique key and a patch. */
  updateAssociationDocument: Maybe<UpdateAssociationDocumentPayload>;
  /** Updates a single `AssociationDocumentFile` using a unique key and a patch. */
  updateAssociationDocumentFile: Maybe<UpdateAssociationDocumentFilePayload>;
  /** Updates a single `AssociationDocumentFile` using a unique key and a patch. */
  updateAssociationDocumentFileByDocumentIdAndPhotoId: Maybe<UpdateAssociationDocumentFilePayload>;
  /** Updates a single `Counterparty` using a unique key and a patch. */
  updateCounterparty: Maybe<UpdateCounterpartyPayload>;
  /** Updates a single `Counterparty` using a unique key and a patch. */
  updateCounterpartyByName: Maybe<UpdateCounterpartyPayload>;
  /** Updates a single `Debt` using a unique key and a patch. */
  updateDebt: Maybe<UpdateDebtPayload>;
  /** Updates a single `FinancialAccount` using a unique key and a patch. */
  updateFinancialAccount: Maybe<UpdateFinancialAccountPayload>;
  /** Updates a single `FinancialOperation` using a unique key and a patch. */
  updateFinancialOperation: Maybe<UpdateFinancialOperationPayload>;
  /** Updates a single `InKindContribution` using a unique key and a patch. */
  updateInKindContribution: Maybe<UpdateInKindContributionPayload>;
  /** Updates a single `Member` using a unique key and a patch. */
  updateMember: Maybe<UpdateMemberPayload>;
  /** Updates a single `Meter` using a unique key and a patch. */
  updateMeter: Maybe<UpdateMeterPayload>;
  /** Updates a single `Meter` using a unique key and a patch. */
  updateMeterByMeterNo: Maybe<UpdateMeterPayload>;
  /** Updates a single `OperationCategory` using a unique key and a patch. */
  updateOperationCategory: Maybe<UpdateOperationCategoryPayload>;
  /** Updates a single `OperationCategory` using a unique key and a patch. */
  updateOperationCategoryByName: Maybe<UpdateOperationCategoryPayload>;
  /** Updates a single `Project` using a unique key and a patch. */
  updateProject: Maybe<UpdateProjectPayload>;
  /** Updates a single `Setting` using a unique key and a patch. */
  updateSetting: Maybe<UpdateSettingPayload>;
  /** Updates a single `ShartPerson` using a unique key and a patch. */
  updateShartPerson: Maybe<UpdateShartPersonPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppBulkSavePaymentsArgs = {
  input: AppBulkSavePaymentsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppChangeMemberStatusArgs = {
  input: AppChangeMemberStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppChangeMeterStatusArgs = {
  input: AppChangeMeterStatusInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppCloseBankStatementArgs = {
  input: AppCloseBankStatementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppCreateOperationFromLineArgs = {
  input: AppCreateOperationFromLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppCreateTransferFromLineArgs = {
  input: AppCreateTransferFromLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppDeleteBillingConfigurationArgs = {
  input: AppDeleteBillingConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppFlagForReviewArgs = {
  input: AppFlagForReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppGrantMemberCreditArgs = {
  input: AppGrantMemberCreditInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppIgnoreStatementLineArgs = {
  input: AppIgnoreStatementLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppImportBankStatementArgs = {
  input: AppImportBankStatementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppMatchStatementLineArgs = {
  input: AppMatchStatementLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppRecordReminderArgs = {
  input: AppRecordReminderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppRenameBillingConfigurationArgs = {
  input: AppRenameBillingConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppReopenBankStatementArgs = {
  input: AppReopenBankStatementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppSaveBillingConfigurationArgs = {
  input: AppSaveBillingConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppSaveConsumptionBillArgs = {
  input: AppSaveConsumptionBillInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppSavePaymentArgs = {
  input: AppSavePaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppSendInvoiceWhatsappArgs = {
  input: AppSendInvoiceWhatsappInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppSendMonthInvoicesArgs = {
  input: AppSendMonthInvoicesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppSetReviewArgs = {
  input: AppSetReviewInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppUnmatchStatementLineArgs = {
  input: AppUnmatchStatementLineInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAppUpdateFinancialOperationsArgs = {
  input: AppUpdateFinancialOperationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountTransferArgs = {
  input: CreateAccountTransferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssociationDocumentArgs = {
  input: CreateAssociationDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssociationDocumentFileArgs = {
  input: CreateAssociationDocumentFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCounterpartyArgs = {
  input: CreateCounterpartyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDebtArgs = {
  input: CreateDebtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFinancialAccountArgs = {
  input: CreateFinancialAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFinancialOperationArgs = {
  input: CreateFinancialOperationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInKindContributionArgs = {
  input: CreateInKindContributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMemberArgs = {
  input: CreateMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMeterArgs = {
  input: CreateMeterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOperationCategoryArgs = {
  input: CreateOperationCategoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateShartPersonArgs = {
  input: CreateShartPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAccountTransferArgs = {
  input: DeleteAccountTransferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssociationDocumentArgs = {
  input: DeleteAssociationDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssociationDocumentFileArgs = {
  input: DeleteAssociationDocumentFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssociationDocumentFileByDocumentIdAndPhotoIdArgs = {
  input: DeleteAssociationDocumentFileByDocumentIdAndPhotoIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBankStatementArgs = {
  input: DeleteBankStatementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBillArgs = {
  input: DeleteBillInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCounterpartyArgs = {
  input: DeleteCounterpartyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCounterpartyByNameArgs = {
  input: DeleteCounterpartyByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDebtArgs = {
  input: DeleteDebtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFinancialAccountArgs = {
  input: DeleteFinancialAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFinancialOperationArgs = {
  input: DeleteFinancialOperationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInKindContributionArgs = {
  input: DeleteInKindContributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMemberArgs = {
  input: DeleteMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterArgs = {
  input: DeleteMeterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMeterByMeterNoArgs = {
  input: DeleteMeterByMeterNoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteNotificationArgs = {
  input: DeleteNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOperationCategoryArgs = {
  input: DeleteOperationCategoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOperationCategoryByNameArgs = {
  input: DeleteOperationCategoryByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePaymentArgs = {
  input: DeletePaymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePaymentByReceiptNoArgs = {
  input: DeletePaymentByReceiptNoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteShartPersonArgs = {
  input: DeleteShartPersonInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountTransferArgs = {
  input: UpdateAccountTransferInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssociationDocumentArgs = {
  input: UpdateAssociationDocumentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssociationDocumentFileArgs = {
  input: UpdateAssociationDocumentFileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssociationDocumentFileByDocumentIdAndPhotoIdArgs = {
  input: UpdateAssociationDocumentFileByDocumentIdAndPhotoIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCounterpartyArgs = {
  input: UpdateCounterpartyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCounterpartyByNameArgs = {
  input: UpdateCounterpartyByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDebtArgs = {
  input: UpdateDebtInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFinancialAccountArgs = {
  input: UpdateFinancialAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFinancialOperationArgs = {
  input: UpdateFinancialOperationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInKindContributionArgs = {
  input: UpdateInKindContributionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMemberArgs = {
  input: UpdateMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterArgs = {
  input: UpdateMeterInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMeterByMeterNoArgs = {
  input: UpdateMeterByMeterNoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOperationCategoryArgs = {
  input: UpdateOperationCategoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOperationCategoryByNameArgs = {
  input: UpdateOperationCategoryByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSettingArgs = {
  input: UpdateSettingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateShartPersonArgs = {
  input: UpdateShartPersonInput;
};

/** Reminders sent to members. Recorded with appRecordReminder. */
export type Notification = {
  __typename?: 'Notification';
  amountDue: Scalars['BigFloat']['output'];
  billIds: Array<Maybe<Scalars['UUID']['output']>>;
  channel: NotifyChannel;
  id: Scalars['UUID']['output'];
  kind: NotificationKind;
  /** Reads a single `Member` that is related to this `Notification`. */
  member: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  message: Maybe<Scalars['String']['output']>;
  phone: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['Datetime']['output'];
  sentBy: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `amountDue` field. */
  amountDue?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `channel` field. */
  channel?: InputMaybe<NotifyChannel>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<NotificationKind>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sentAt` field. */
  sentAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sentBy` field. */
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Notification` values. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<Maybe<NotificationEdge>>;
  /** A list of `Notification` objects. */
  nodes: Array<Maybe<Notification>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Notification` edge in the connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Notification` at the end of the edge. */
  node: Maybe<Notification>;
};

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type NotificationFilter = {
  /** Filter by the object’s `amountDue` field. */
  amountDue?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `billIds` field. */
  billIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `channel` field. */
  channel?: InputMaybe<NotifyChannelFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<NotificationKindFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NotificationFilter>>;
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sentAt` field. */
  sentAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sentBy` field. */
  sentBy?: InputMaybe<StringFilter>;
};

export type NotificationKind =
  | 'LATE_NOTICE'
  | 'REMINDER';

/** A filter to be used against NotificationKind fields. All fields are combined with a logical ‘and.’ */
export type NotificationKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NotificationKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NotificationKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NotificationKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NotificationKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NotificationKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NotificationKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NotificationKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NotificationKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NotificationKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NotificationKind>>;
};

/** Methods to use when ordering `Notification`. */
export type NotificationOrderBy =
  | 'AMOUNT_DUE_ASC'
  | 'AMOUNT_DUE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'MESSAGE_ASC'
  | 'MESSAGE_DESC'
  | 'NATURAL'
  | 'PHONE_ASC'
  | 'PHONE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SENT_AT_ASC'
  | 'SENT_AT_DESC'
  | 'SENT_BY_ASC'
  | 'SENT_BY_DESC';

export type NotifyChannel =
  | 'NONE'
  | 'SMS'
  | 'WHATSAPP';

/** A filter to be used against NotifyChannel fields. All fields are combined with a logical ‘and.’ */
export type NotifyChannelFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NotifyChannel>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NotifyChannel>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NotifyChannel>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NotifyChannel>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NotifyChannel>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NotifyChannel>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NotifyChannel>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NotifyChannel>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NotifyChannel>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NotifyChannel>>;
};

/** What the money is (electricity, wages, materials…). applies_to: income, expenses or both. */
export type OperationCategory = {
  __typename?: 'OperationCategory';
  appliesTo: CategoryAppliesTo;
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperationsByCategoryId: FinancialOperationConnection;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};


/** What the money is (electricity, wages, materials…). applies_to: income, expenses or both. */
export type OperationCategoryFinancialOperationsByCategoryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};

/**
 * A condition to be used against `OperationCategory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OperationCategoryCondition = {
  /** Checks for equality with the object’s `appliesTo` field. */
  appliesTo?: InputMaybe<CategoryAppliesTo>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `OperationCategory` values. */
export type OperationCategoryConnection = {
  __typename?: 'OperationCategoryConnection';
  /** A list of edges which contains the `OperationCategory` and cursor to aid in pagination. */
  edges: Array<Maybe<OperationCategoryEdge>>;
  /** A list of `OperationCategory` objects. */
  nodes: Array<Maybe<OperationCategory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperationCategory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `OperationCategory` edge in the connection. */
export type OperationCategoryEdge = {
  __typename?: 'OperationCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `OperationCategory` at the end of the edge. */
  node: Maybe<OperationCategory>;
};

/** A filter to be used against `OperationCategory` object types. All fields are combined with a logical ‘and.’ */
export type OperationCategoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperationCategoryFilter>>;
  /** Filter by the object’s `appliesTo` field. */
  appliesTo?: InputMaybe<CategoryAppliesToFilter>;
  /** Filter by the object’s `financialOperationsByCategoryId` relation. */
  financialOperationsByCategoryId?: InputMaybe<OperationCategoryToManyFinancialOperationFilter>;
  /** Some related `financialOperationsByCategoryId` exist. */
  financialOperationsByCategoryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperationCategoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperationCategoryFilter>>;
};

/** An input for mutations affecting `OperationCategory` */
export type OperationCategoryInput = {
  appliesTo?: InputMaybe<CategoryAppliesTo>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

/** Methods to use when ordering `OperationCategory`. */
export type OperationCategoryOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** Represents an update to a `OperationCategory`. Fields that are set will be updated. */
export type OperationCategoryPatch = {
  appliesTo?: InputMaybe<CategoryAppliesTo>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type OperationCategoryToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

export type OperationSource =
  | 'bank_statement'
  | 'ledger_import'
  | 'manual'
  | 'transfer';

/** A filter to be used against OperationSource fields. All fields are combined with a logical ‘and.’ */
export type OperationSourceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OperationSource>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OperationSource>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OperationSource>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OperationSource>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OperationSource>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OperationSource>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OperationSource>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OperationSource>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OperationSource>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OperationSource>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['Cursor']['output']>;
};

/** Write through appSavePayment / appBulkSavePayments. */
export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Bill` that is related to this `Payment`. */
  bill: Maybe<Bill>;
  billId: Scalars['UUID']['output'];
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  paymentDate: Scalars['Datetime']['output'];
  /**
   * Signed link to this payment's numbered receipt (إيصال الأداء), A5, with a
   * QR code to the full invoice.
   */
  receiptLink: Scalars['String']['output'];
  /** Receipt number, sequential per year of payment_date (e.g. 2026-00042). Assigned automatically. */
  receiptNo: Scalars['String']['output'];
  /** Username of the committee member who recorded the payment. */
  receivedBy: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

/** A condition to be used against `Payment` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PaymentCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `billId` field. */
  billId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `paymentDate` field. */
  paymentDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `receiptNo` field. */
  receiptNo?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `receivedBy` field. */
  receivedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `Payment` values. */
export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** A list of edges which contains the `Payment` and cursor to aid in pagination. */
  edges: Array<Maybe<PaymentEdge>>;
  /** A list of `Payment` objects. */
  nodes: Array<Maybe<Payment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Payment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Payment` edge in the connection. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Payment` at the end of the edge. */
  node: Maybe<Payment>;
};

/** A filter to be used against `Payment` object types. All fields are combined with a logical ‘and.’ */
export type PaymentFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PaymentFilter>>;
  /** Filter by the object’s `bill` relation. */
  bill?: InputMaybe<BillFilter>;
  /** Filter by the object’s `billId` field. */
  billId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PaymentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PaymentFilter>>;
  /** Filter by the object’s `paymentDate` field. */
  paymentDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `receiptNo` field. */
  receiptNo?: InputMaybe<StringFilter>;
  /** Filter by the object’s `receivedBy` field. */
  receivedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Methods to use when ordering `Payment`. */
export type PaymentOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'BILL_ID_ASC'
  | 'BILL_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PAYMENT_DATE_ASC'
  | 'PAYMENT_DATE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECEIPT_NO_ASC'
  | 'RECEIPT_NO_DESC'
  | 'RECEIVED_BY_ASC'
  | 'RECEIVED_BY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type PhoneStatus =
  | 'INVALID'
  | 'LANDLINE'
  | 'MISSING'
  | 'OK';

/** A filter to be used against PhoneStatus fields. All fields are combined with a logical ‘and.’ */
export type PhoneStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PhoneStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PhoneStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PhoneStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PhoneStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PhoneStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PhoneStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PhoneStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PhoneStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PhoneStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PhoneStatus>>;
};

/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type Photo = {
  __typename?: 'Photo';
  /** Reads and enables pagination through a set of `AccountTransfer`. */
  accountTransfersByReceiptPhotoId: AccountTransferConnection;
  /** Reads and enables pagination through a set of `AssociationDocumentFile`. */
  associationDocumentFiles: AssociationDocumentFileConnection;
  /** Reads and enables pagination through a set of `BankStatement`. */
  bankStatementsByDocumentPhotoId: BankStatementConnection;
  /** Reads and enables pagination through a set of `Bill`. */
  billsByReadingPhotoId: BillConnection;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperationsByReceiptPhotoId: FinancialOperationConnection;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `InKindContribution`. */
  inKindContributionsByDocumentPhotoId: InKindContributionConnection;
  kind: PhotoKind;
  /** Reads and enables pagination through a set of `Meter`. */
  meters: MeterConnection;
  sizeBytes: Scalars['Int']['output'];
  uploadedBy: Maybe<Scalars['String']['output']>;
  /**
   * Signed link to the image (receipt or meter), valid until the end of the
   * next day: use it as an <img> src.
   */
  url: Scalars['String']['output'];
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoAccountTransfersByReceiptPhotoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountTransferCondition>;
  filter?: InputMaybe<AccountTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTransferOrderBy>>;
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoAssociationDocumentFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentFileCondition>;
  filter?: InputMaybe<AssociationDocumentFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentFileOrderBy>>;
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoBankStatementsByDocumentPhotoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementCondition>;
  filter?: InputMaybe<BankStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementOrderBy>>;
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoBillsByReadingPhotoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillCondition>;
  filter?: InputMaybe<BillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOrderBy>>;
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoFinancialOperationsByReceiptPhotoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoInKindContributionsByDocumentPhotoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InKindContributionCondition>;
  filter?: InputMaybe<InKindContributionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InKindContributionOrderBy>>;
};


/** Files sent with POST /photos: receipts of financial operations (image or PDF), meters (image). Open one with url. */
export type PhotoMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterCondition>;
  filter?: InputMaybe<MeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterOrderBy>>;
};

/** A condition to be used against `Photo` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PhotoCondition = {
  /** Checks for equality with the object’s `contentType` field. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<PhotoKind>;
  /** Checks for equality with the object’s `sizeBytes` field. */
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `uploadedBy` field. */
  uploadedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Photo` values. */
export type PhotoConnection = {
  __typename?: 'PhotoConnection';
  /** A list of edges which contains the `Photo` and cursor to aid in pagination. */
  edges: Array<Maybe<PhotoEdge>>;
  /** A list of `Photo` objects. */
  nodes: Array<Maybe<Photo>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Photo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Photo` edge in the connection. */
export type PhotoEdge = {
  __typename?: 'PhotoEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Photo` at the end of the edge. */
  node: Maybe<Photo>;
};

/** A filter to be used against `Photo` object types. All fields are combined with a logical ‘and.’ */
export type PhotoFilter = {
  /** Filter by the object’s `accountTransfersByReceiptPhotoId` relation. */
  accountTransfersByReceiptPhotoId?: InputMaybe<PhotoToManyAccountTransferFilter>;
  /** Some related `accountTransfersByReceiptPhotoId` exist. */
  accountTransfersByReceiptPhotoIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PhotoFilter>>;
  /** Filter by the object’s `associationDocumentFiles` relation. */
  associationDocumentFiles?: InputMaybe<PhotoToManyAssociationDocumentFileFilter>;
  /** Some related `associationDocumentFiles` exist. */
  associationDocumentFilesExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `bankStatementsByDocumentPhotoId` relation. */
  bankStatementsByDocumentPhotoId?: InputMaybe<PhotoToManyBankStatementFilter>;
  /** Some related `bankStatementsByDocumentPhotoId` exist. */
  bankStatementsByDocumentPhotoIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `billsByReadingPhotoId` relation. */
  billsByReadingPhotoId?: InputMaybe<PhotoToManyBillFilter>;
  /** Some related `billsByReadingPhotoId` exist. */
  billsByReadingPhotoIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `contentType` field. */
  contentType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `financialOperationsByReceiptPhotoId` relation. */
  financialOperationsByReceiptPhotoId?: InputMaybe<PhotoToManyFinancialOperationFilter>;
  /** Some related `financialOperationsByReceiptPhotoId` exist. */
  financialOperationsByReceiptPhotoIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inKindContributionsByDocumentPhotoId` relation. */
  inKindContributionsByDocumentPhotoId?: InputMaybe<PhotoToManyInKindContributionFilter>;
  /** Some related `inKindContributionsByDocumentPhotoId` exist. */
  inKindContributionsByDocumentPhotoIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<PhotoKindFilter>;
  /** Filter by the object’s `meters` relation. */
  meters?: InputMaybe<PhotoToManyMeterFilter>;
  /** Some related `meters` exist. */
  metersExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<PhotoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PhotoFilter>>;
  /** Filter by the object’s `sizeBytes` field. */
  sizeBytes?: InputMaybe<IntFilter>;
  /** Filter by the object’s `uploadedBy` field. */
  uploadedBy?: InputMaybe<StringFilter>;
};

export type PhotoKind =
  | 'DOCUMENT'
  | 'METER_READING'
  | 'RECEIPT';

/** A filter to be used against PhotoKind fields. All fields are combined with a logical ‘and.’ */
export type PhotoKindFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PhotoKind>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PhotoKind>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PhotoKind>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PhotoKind>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PhotoKind>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PhotoKind>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PhotoKind>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PhotoKind>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PhotoKind>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PhotoKind>>;
};

/** Methods to use when ordering `Photo`. */
export type PhotoOrderBy =
  | 'CONTENT_TYPE_ASC'
  | 'CONTENT_TYPE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SIZE_BYTES_ASC'
  | 'SIZE_BYTES_DESC'
  | 'UPLOADED_BY_ASC'
  | 'UPLOADED_BY_DESC';

/** A filter to be used against many `AccountTransfer` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyAccountTransferFilter = {
  /** Every related `AccountTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountTransferFilter>;
  /** No related `AccountTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountTransferFilter>;
  /** Some related `AccountTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountTransferFilter>;
};

/** A filter to be used against many `AssociationDocumentFile` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyAssociationDocumentFileFilter = {
  /** Every related `AssociationDocumentFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssociationDocumentFileFilter>;
  /** No related `AssociationDocumentFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssociationDocumentFileFilter>;
  /** Some related `AssociationDocumentFile` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssociationDocumentFileFilter>;
};

/** A filter to be used against many `BankStatement` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyBankStatementFilter = {
  /** Every related `BankStatement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BankStatementFilter>;
  /** No related `BankStatement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BankStatementFilter>;
  /** Some related `BankStatement` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BankStatementFilter>;
};

/** A filter to be used against many `Bill` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyBillFilter = {
  /** Every related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BillFilter>;
  /** No related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BillFilter>;
  /** Some related `Bill` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BillFilter>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

/** A filter to be used against many `InKindContribution` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyInKindContributionFilter = {
  /** Every related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InKindContributionFilter>;
  /** No related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InKindContributionFilter>;
  /** Some related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InKindContributionFilter>;
};

/** A filter to be used against many `Meter` object types. All fields are combined with a logical ‘and.’ */
export type PhotoToManyMeterFilter = {
  /** Every related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MeterFilter>;
  /** No related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MeterFilter>;
  /** Some related `Meter` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MeterFilter>;
};

export type Project = {
  __typename?: 'Project';
  /** Reads and enables pagination through a set of `AssociationDocument`. */
  associationDocuments: AssociationDocumentConnection;
  /** CLOSED projects: the closing date (default today). */
  closedOn: Maybe<Scalars['Date']['output']>;
  /** CLOSED projects: why (e.g. «انتهت الأشغال»). */
  closedReason: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `Debt`. */
  debts: DebtConnection;
  description: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperations: FinancialOperationConnection;
  id: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `InKindContribution`. */
  inKindContributions: InKindContributionConnection;
  name: Scalars['String']['output'];
  /**
   * Signed link to the project's spending report: every operation since the
   * project started, by year and in detail with a running balance.
   */
  reportLink: Scalars['String']['output'];
  /** OPEN, or CLOSED: no more operations (reopen by setting OPEN). */
  status: ProjectStatus;
  /** The project's income, expenses and result (without loans), and its loan money apart. */
  totals: ProjectTotal;
  updatedAt: Scalars['Datetime']['output'];
};


export type ProjectAssociationDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentCondition>;
  filter?: InputMaybe<AssociationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentOrderBy>>;
};


export type ProjectDebtsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DebtCondition>;
  filter?: InputMaybe<DebtFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DebtOrderBy>>;
};


export type ProjectFinancialOperationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};


export type ProjectInKindContributionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InKindContributionCondition>;
  filter?: InputMaybe<InKindContributionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InKindContributionOrderBy>>;
};

/** A condition to be used against `Project` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ProjectCondition = {
  /** Checks for equality with the object’s `closedOn` field. */
  closedOn?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `closedReason` field. */
  closedReason?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ProjectStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `Project` values. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges which contains the `Project` and cursor to aid in pagination. */
  edges: Array<Maybe<ProjectEdge>>;
  /** A list of `Project` objects. */
  nodes: Array<Maybe<Project>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Project` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Project` edge in the connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Project` at the end of the edge. */
  node: Maybe<Project>;
};

/** A filter to be used against `Project` object types. All fields are combined with a logical ‘and.’ */
export type ProjectFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `associationDocuments` relation. */
  associationDocuments?: InputMaybe<ProjectToManyAssociationDocumentFilter>;
  /** Some related `associationDocuments` exist. */
  associationDocumentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `closedOn` field. */
  closedOn?: InputMaybe<DateFilter>;
  /** Filter by the object’s `closedReason` field. */
  closedReason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `debts` relation. */
  debts?: InputMaybe<ProjectToManyDebtFilter>;
  /** Some related `debts` exist. */
  debtsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `financialOperations` relation. */
  financialOperations?: InputMaybe<ProjectToManyFinancialOperationFilter>;
  /** Some related `financialOperations` exist. */
  financialOperationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inKindContributions` relation. */
  inKindContributions?: InputMaybe<ProjectToManyInKindContributionFilter>;
  /** Some related `inKindContributions` exist. */
  inKindContributionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ProjectFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ProjectFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ProjectStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Project` */
export type ProjectInput = {
  /** CLOSED projects: the closing date (default today). */
  closedOn?: InputMaybe<Scalars['Date']['input']>;
  /** CLOSED projects: why (e.g. «انتهت الأشغال»). */
  closedReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  /** OPEN, or CLOSED: no more operations (reopen by setting OPEN). */
  status?: InputMaybe<ProjectStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Methods to use when ordering `Project`. */
export type ProjectOrderBy =
  | 'CLOSED_ON_ASC'
  | 'CLOSED_ON_DESC'
  | 'CLOSED_REASON_ASC'
  | 'CLOSED_REASON_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DESCRIPTION_ASC'
  | 'DESCRIPTION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** Represents an update to a `Project`. Fields that are set will be updated. */
export type ProjectPatch = {
  /** CLOSED projects: the closing date (default today). */
  closedOn?: InputMaybe<Scalars['Date']['input']>;
  /** CLOSED projects: why (e.g. «انتهت الأشغال»). */
  closedReason?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** OPEN, or CLOSED: no more operations (reopen by setting OPEN). */
  status?: InputMaybe<ProjectStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ProjectStatus =
  | 'CLOSED'
  | 'OPEN';

/** A filter to be used against ProjectStatus fields. All fields are combined with a logical ‘and.’ */
export type ProjectStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProjectStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProjectStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProjectStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProjectStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProjectStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProjectStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProjectStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProjectStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProjectStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProjectStatus>>;
};

/** A filter to be used against many `AssociationDocument` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyAssociationDocumentFilter = {
  /** Every related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AssociationDocumentFilter>;
  /** No related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AssociationDocumentFilter>;
  /** Some related `AssociationDocument` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AssociationDocumentFilter>;
};

/** A filter to be used against many `Debt` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyDebtFilter = {
  /** Every related `Debt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DebtFilter>;
  /** No related `Debt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DebtFilter>;
  /** Some related `Debt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DebtFilter>;
};

/** A filter to be used against many `FinancialOperation` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyFinancialOperationFilter = {
  /** Every related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FinancialOperationFilter>;
  /** No related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FinancialOperationFilter>;
  /** Some related `FinancialOperation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FinancialOperationFilter>;
};

/** A filter to be used against many `InKindContribution` object types. All fields are combined with a logical ‘and.’ */
export type ProjectToManyInKindContributionFilter = {
  /** Every related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<InKindContributionFilter>;
  /** No related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<InKindContributionFilter>;
  /** Some related `InKindContribution` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<InKindContributionFilter>;
};

export type ProjectTotal = {
  __typename?: 'ProjectTotal';
  /** Without loan repayments. */
  expenses: Scalars['BigFloat']['output'];
  /** Without loan money. */
  income: Scalars['BigFloat']['output'];
  loanOperations: Scalars['Int']['output'];
  /** Loan money received for the project (credit operations with a debt). */
  loansReceived: Scalars['BigFloat']['output'];
  /** Loan repayments (debit operations with a debt). */
  loansRepaid: Scalars['BigFloat']['output'];
  result: Scalars['BigFloat']['output'];
};

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  /** Get a single `AccountTransfer`. */
  accountTransfer: Maybe<AccountTransfer>;
  /** Reads and enables pagination through a set of `AccountTransfer`. */
  accountTransfers: Maybe<AccountTransferConnection>;
  /**
   * Signed link to the annual financial report (التقرير المالي السنوي) for the
   * general assembly: water service, cash book by project, account balances
   * at year end, comparison with the previous year.
   */
  annualReportLink: Scalars['String']['output'];
  /** Committee only: every member with unpaid bills, most overdue first. */
  arrearsList: Maybe<MemberReminderConnection>;
  /** Get a single `AssociationDocument`. */
  associationDocument: Maybe<AssociationDocument>;
  /** Get a single `AssociationDocumentFile`. */
  associationDocumentFile: Maybe<AssociationDocumentFile>;
  /** Get a single `AssociationDocumentFile`. */
  associationDocumentFileByDocumentIdAndPhotoId: Maybe<AssociationDocumentFile>;
  /** Reads and enables pagination through a set of `AssociationDocumentFile`. */
  associationDocumentFiles: Maybe<AssociationDocumentFileConnection>;
  /** Reads and enables pagination through a set of `AssociationDocument`. */
  associationDocuments: Maybe<AssociationDocumentConnection>;
  /** Get a single `BankStatement`. */
  bankStatement: Maybe<BankStatement>;
  /** Get a single `BankStatementLine`. */
  bankStatementLine: Maybe<BankStatementLine>;
  /** Reads and enables pagination through a set of `BankStatementLine`. */
  bankStatementLines: Maybe<BankStatementLineConnection>;
  /** Reads and enables pagination through a set of `BankStatement`. */
  bankStatements: Maybe<BankStatementConnection>;
  /** Get a single `Bill`. */
  bill: Maybe<Bill>;
  /** Get a single `BillingConfiguration`. */
  billingConfiguration: Maybe<BillingConfiguration>;
  /** Reads and enables pagination through a set of `BillingConfiguration`. */
  billingConfigurations: Maybe<BillingConfigurationConnection>;
  /** What bills would cost under a configuration that isn't saved yet, one line per consumption (in the order given, max 100), with the same rules and errors as appSaveBillingConfiguration. Shart excluded (it depends on each bill). */
  billingPreview: Array<BillingPreviewLine>;
  /** Reads and enables pagination through a set of `Bill`. */
  bills: Maybe<BillConnection>;
  /**
   * Signed link to the monthly bulletin (النشرة الشهرية) for a month
   * ("YYYY-MM"), to share with all members, e.g. in the village WhatsApp group.
   * It names members late beyond settings.publicArrearsAfterDays.
   */
  bulletinLink: Scalars['String']['output'];
  /** Get a single `ConsumptionTier`. */
  consumptionTier: Maybe<ConsumptionTier>;
  /** Reads and enables pagination through a set of `ConsumptionTier`. */
  consumptionTiers: Maybe<ConsumptionTierConnection>;
  /** Reads and enables pagination through a set of `Counterparty`. */
  counterparties: Maybe<CounterpartyConnection>;
  /** Get a single `Counterparty`. */
  counterparty: Maybe<Counterparty>;
  /** Get a single `Counterparty`. */
  counterpartyByName: Maybe<Counterparty>;
  currentSettings: Maybe<Setting>;
  /** Get a single `Debt`. */
  debt: Maybe<Debt>;
  /** Reads and enables pagination through a set of `Debt`. */
  debts: Maybe<DebtConnection>;
  /** Get a single `FeeConfiguration`. */
  feeConfiguration: Maybe<FeeConfiguration>;
  /** Reads and enables pagination through a set of `FeeConfiguration`. */
  feeConfigurations: Maybe<FeeConfigurationConnection>;
  /** Get a single `FinanceChange`. */
  financeChange: Maybe<FinanceChange>;
  /** Reads and enables pagination through a set of `FinanceChange`. */
  financeChanges: Maybe<FinanceChangeConnection>;
  /**
   * Signed link (valid until the end of the next day) to an export of the
   * financial operations matching the filter, as .xlsx (default) or .csv.
   * Committee and treasurer only. Transfers are left out unless
   * includeTransfers is true. docs/changes/58.
   */
  financeExportLink: Scalars['String']['output'];
  /** Everything waiting for a review, oldest request first (imported rows, without a request date, come first). Filter by kind (operation, transfer, in_kind) and by who asked. */
  financeReviewQueue: Maybe<FinanceReviewItemConnection>;
  /** Income, expenses and result of the operations, grouped by project, category, counterparty, account, month or none, optionally limited to dates, an account or a project. Transfers never count; loan money only with includeLoans. Months in order, other groups by size. */
  financeTotals: Maybe<FinanceTotalConnection>;
  /** Get a single `FinancialAccount`. */
  financialAccount: Maybe<FinancialAccount>;
  /** Reads and enables pagination through a set of `FinancialAccount`. */
  financialAccounts: Maybe<FinancialAccountConnection>;
  /** Get a single `FinancialOperation`. */
  financialOperation: Maybe<FinancialOperation>;
  /** Reads and enables pagination through a set of `FinancialOperation`. */
  financialOperations: Maybe<FinancialOperationConnection>;
  /** Get a single `InKindContribution`. */
  inKindContribution: Maybe<InKindContribution>;
  /** Reads and enables pagination through a set of `InKindContribution`. */
  inKindContributions: Maybe<InKindContributionConnection>;
  /**
   * Late-payers list as images (PNG, large print) to share in the WhatsApp
   * groups, one link per image (up to 15 names each). COMMITTEE: every member
   * who owes, for the committee's private group. PUBLIC: only members late
   * beyond settings.publicArrearsAfterDays, for the village group. Images are
   * generated when opened, so they are always current. Links expire after
   * 7 days.
   */
  latePayersImages: Array<Scalars['String']['output']>;
  /** Get a single `Member`. */
  member: Maybe<Member>;
  /** Get a single `MemberCredit`. */
  memberCredit: Maybe<MemberCredit>;
  /** Reads and enables pagination through a set of `MemberCredit`. */
  memberCredits: Maybe<MemberCreditConnection>;
  /** Get a single `MemberStatusChange`. */
  memberStatusChange: Maybe<MemberStatusChange>;
  /** Reads and enables pagination through a set of `MemberStatusChange`. */
  memberStatusChanges: Maybe<MemberStatusChangeConnection>;
  /** Reads and enables pagination through a set of `Member`. */
  members: Maybe<MemberConnection>;
  /** Get a single `Meter`. */
  meter: Maybe<Meter>;
  /** Get a single `Meter`. */
  meterByMeterNo: Maybe<Meter>;
  /** Get a single `MeterStatusChange`. */
  meterStatusChange: Maybe<MeterStatusChange>;
  /** Reads and enables pagination through a set of `MeterStatusChange`. */
  meterStatusChanges: Maybe<MeterStatusChangeConnection>;
  /** Reads and enables pagination through a set of `Meter`. */
  meters: Maybe<MeterConnection>;
  /**
   * Committee: signed link to every bill of a month ("YYYY-MM") for printing,
   * one A5 page per bill, in delivery order. Contains every member's
   * data, so the link expires after 7 days.
   */
  monthlyBillsLink: Scalars['String']['output'];
  /**
   * Committee: signed link to the receipts of every bill of a month, one A5
   * page each, in delivery order, to print ahead of payment
   * (valid only once paid and stamped). Expires after 7 days.
   */
  monthlyReceiptsLink: Scalars['String']['output'];
  /** One row per month (newest first): what was billed and what was received. */
  monthlyReport: Maybe<MonthSummaryConnection>;
  /**
   * Committee: signed link to payment notices for printing, one member per
   * page, in delivery order. With onlyUnreachable, only members that can't
   * get a WhatsApp/SMS reminder (phoneStatus ≠ OK). Expires after 7 days.
   */
  noticesLink: Scalars['String']['output'];
  /** Get a single `Notification`. */
  notification: Maybe<Notification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Maybe<NotificationConnection>;
  /** Reads and enables pagination through a set of `OperationCategory`. */
  operationCategories: Maybe<OperationCategoryConnection>;
  /** Get a single `OperationCategory`. */
  operationCategory: Maybe<OperationCategory>;
  /** Get a single `OperationCategory`. */
  operationCategoryByName: Maybe<OperationCategory>;
  /** Get a single `Payment`. */
  payment: Maybe<Payment>;
  /** Get a single `Payment`. */
  paymentByReceiptNo: Maybe<Payment>;
  /** Reads and enables pagination through a set of `Payment`. */
  payments: Maybe<PaymentConnection>;
  /** Get a single `Photo`. */
  photo: Maybe<Photo>;
  /** Get a single `Photo`. */
  photoByStorageKey: Maybe<Photo>;
  /** Reads and enables pagination through a set of `Photo`. */
  photos: Maybe<PhotoConnection>;
  /** Get a single `Project`. */
  project: Maybe<Project>;
  /** Reads and enables pagination through a set of `Project`. */
  projects: Maybe<ProjectConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Before saving a reading: is a photo of the meter required? Always when settings.readingPhotoAlways; otherwise when the consumption is unusual: more than 30 m³ and more than 3 times the meter's average (last 6 bills), or more than 60 m³ for a meter with fewer than 3 bills. Same arguments as appSaveConsumptionBill. */
  readingCheck: ReadingCheck;
  /** Members who should get a payment reminder today (settings: firstReminderAfterDays, reminderEveryDays). Includes members without a usable phone; check phoneStatus. */
  remindersDue: Maybe<MemberReminderConnection>;
  /** Get a single `Setting`. */
  setting: Maybe<Setting>;
  /** Reads and enables pagination through a set of `Setting`. */
  settings: Maybe<SettingConnection>;
  /** Reads and enables pagination through a set of `ShartPerson`. */
  shartPeople: Maybe<ShartPersonConnection>;
  /** Get a single `ShartPerson`. */
  shartPerson: Maybe<ShartPerson>;
  /** Get a single `WhatsappMessage`. */
  whatsappMessage: Maybe<WhatsappMessage>;
  /** Get a single `WhatsappMessage`. */
  whatsappMessageByWaMessageId: Maybe<WhatsappMessage>;
  /** Reads and enables pagination through a set of `WhatsappMessage`. */
  whatsappMessages: Maybe<WhatsappMessageConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountTransferArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountTransfersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountTransferCondition>;
  filter?: InputMaybe<AccountTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountTransferOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnnualReportLinkArgs = {
  year: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryArrearsListArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberReminderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssociationDocumentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssociationDocumentFileArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssociationDocumentFileByDocumentIdAndPhotoIdArgs = {
  documentId: Scalars['UUID']['input'];
  photoId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssociationDocumentFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentFileCondition>;
  filter?: InputMaybe<AssociationDocumentFileFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentFileOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssociationDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AssociationDocumentCondition>;
  filter?: InputMaybe<AssociationDocumentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AssociationDocumentOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBankStatementArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBankStatementLineArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBankStatementLinesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementLineCondition>;
  filter?: InputMaybe<BankStatementLineFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementLineOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBankStatementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BankStatementCondition>;
  filter?: InputMaybe<BankStatementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BankStatementOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingConfigurationArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillingConfigurationCondition>;
  filter?: InputMaybe<BillingConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillingConfigurationOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillingPreviewArgs = {
  billingMethod: BillingMethodType;
  consumptions: Array<InputMaybe<Scalars['Int']['input']>>;
  fees?: InputMaybe<Array<InputMaybe<BillingFeeInput>>>;
  tiers: Array<InputMaybe<BillingTierInput>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBillsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BillCondition>;
  filter?: InputMaybe<BillFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BillOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBulletinLinkArgs = {
  month: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumptionTierArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConsumptionTiersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConsumptionTierCondition>;
  filter?: InputMaybe<ConsumptionTierFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConsumptionTierOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCounterpartiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CounterpartyCondition>;
  filter?: InputMaybe<CounterpartyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CounterpartyOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCounterpartyArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCounterpartyByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDebtArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDebtsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DebtCondition>;
  filter?: InputMaybe<DebtFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DebtOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeeConfigurationArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFeeConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FeeConfigurationCondition>;
  filter?: InputMaybe<FeeConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FeeConfigurationOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceChangeArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinanceChangeCondition>;
  filter?: InputMaybe<FinanceChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinanceChangeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceExportLinkArgs = {
  filter?: InputMaybe<FinanceExportFilter>;
  format?: InputMaybe<FinanceExportFormat>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceReviewQueueArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<FinanceReviewItemFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  requestedBy?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinanceTotalsArgs = {
  accountId?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<FinanceTotalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  includeLoans?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinancialAccountArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFinancialAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialAccountCondition>;
  filter?: InputMaybe<FinancialAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialAccountOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFinancialOperationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFinancialOperationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FinancialOperationCondition>;
  filter?: InputMaybe<FinancialOperationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInKindContributionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInKindContributionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InKindContributionCondition>;
  filter?: InputMaybe<InKindContributionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InKindContributionOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLatePayersImagesArgs = {
  audience: LateListAudience;
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberCreditArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberCreditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCreditCondition>;
  filter?: InputMaybe<MemberCreditFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberCreditOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberStatusChangeArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMemberStatusChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberStatusChangeCondition>;
  filter?: InputMaybe<MemberStatusChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberStatusChangeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MemberCondition>;
  filter?: InputMaybe<MemberFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MemberOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMeterArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMeterByMeterNoArgs = {
  meterNo: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMeterStatusChangeArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMeterStatusChangesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterStatusChangeCondition>;
  filter?: InputMaybe<MeterStatusChangeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterStatusChangeOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMetersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MeterCondition>;
  filter?: InputMaybe<MeterFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MeterOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMonthlyBillsLinkArgs = {
  month: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMonthlyReceiptsLinkArgs = {
  month: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMonthlyReportArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MonthSummaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNoticesLinkArgs = {
  onlyUnreachable?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NotificationCondition>;
  filter?: InputMaybe<NotificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOperationCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperationCategoryCondition>;
  filter?: InputMaybe<OperationCategoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperationCategoryOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryOperationCategoryArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperationCategoryByNameArgs = {
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentByReceiptNoArgs = {
  receiptNo: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PaymentCondition>;
  filter?: InputMaybe<PaymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PaymentOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPhotoArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhotoByStorageKeyArgs = {
  storageKey: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPhotosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PhotoCondition>;
  filter?: InputMaybe<PhotoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PhotoOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryProjectsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ProjectCondition>;
  filter?: InputMaybe<ProjectFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProjectOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryReadingCheckArgs = {
  billId?: InputMaybe<Scalars['UUID']['input']>;
  meterId: Scalars['UUID']['input'];
  period: Scalars['Date']['input'];
  reading: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRemindersDueArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<MemberReminderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySettingArgs = {
  id: Scalars['Boolean']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySettingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SettingCondition>;
  filter?: InputMaybe<SettingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SettingOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShartPeopleArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ShartPersonCondition>;
  filter?: InputMaybe<ShartPersonFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ShartPersonOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryShartPersonArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWhatsappMessageArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWhatsappMessageByWaMessageIdArgs = {
  waMessageId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWhatsappMessagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WhatsappMessageCondition>;
  filter?: InputMaybe<WhatsappMessageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WhatsappMessageOrderBy>>;
};

/** Whether a reading needs a photo of the meter before it is saved. */
export type ReadingCheck = {
  __typename?: 'ReadingCheck';
  /** m³ since the previous bill. */
  consumption: Scalars['Int']['output'];
  photoRequired: Scalars['Boolean']['output'];
  /** Why a photo is required: ALWAYS (committee setting) or UNUSUAL (consumption); null when it isn't. */
  reason: Maybe<Scalars['String']['output']>;
  /** Average m³ of the meter's last 6 bills (null: fewer than 3 bills). */
  usualConsumption: Maybe<Scalars['BigFloat']['output']>;
};

/** Association settings (a single row). Read with currentSettings, change with updateSetting(input: { id: true, patch: {...} }). */
export type Setting = {
  __typename?: 'Setting';
  /** Postal address of the association, printed on invoices and receipts. */
  address: Maybe<Scalars['String']['output']>;
  associationName: Scalars['String']['output'];
  /** Bank account (RIB) for transfers to the association. */
  bankRib: Maybe<Scalars['String']['output']>;
  contactPhone: Maybe<Scalars['String']['output']>;
  /** Address given to a member or meter saved without a real one («غير متوفر», empty…). */
  defaultAddress: Scalars['String']['output'];
  dueDays: Scalars['Int']['output'];
  email: Maybe<Scalars['String']['output']>;
  firstReminderAfterDays: Scalars['Int']['output'];
  foundedOn: Maybe<Scalars['Date']['output']>;
  id: Scalars['Boolean']['output'];
  /** End of the current committee's term: the weekly report warns 90 days before. */
  mandateEnd: Maybe<Scalars['Date']['output']>;
  /** Start of the current committee's term. */
  mandateStart: Maybe<Scalars['Date']['output']>;
  /** What the association exists for (رسالة الجمعية). */
  mission: Maybe<Scalars['String']['output']>;
  publicArrearsAfterDays: Scalars['Int']['output'];
  /** Optional: name a late payer only when the amount late beyond the threshold reaches this. 0 = any amount. */
  publicArrearsMinAmount: Scalars['BigFloat']['output'];
  /** Public late-payers image: names are shown in red after this many days on the public list, black before. */
  publicArrearsRedAfterDays: Scalars['Int']['output'];
  /** Optional: only bills from this billing month onwards count for naming. Empty = all bills. */
  publicArrearsSince: Maybe<Scalars['Date']['output']>;
  /** true: every reading needs a photo of the meter; false: only unusual ones (readingCheck). */
  readingPhotoAlways: Scalars['Boolean']['output'];
  /** Expenses of this amount or more need a receipt photo (dirhams). */
  receiptPhotoMinAmount: Scalars['BigFloat']['output'];
  /** Authority that issued it (e.g. «قيادة …»). */
  registrationAuthority: Maybe<Scalars['String']['output']>;
  /** Date of the declaration receipt. */
  registrationDate: Maybe<Scalars['Date']['output']>;
  /** Number of the declaration receipt (وصل الإيداع). */
  registrationNumber: Maybe<Scalars['String']['output']>;
  reminderEveryDays: Scalars['Int']['output'];
  /** Short name used in messages (e.g. «جمعية بن عزوز»). */
  shortName: Maybe<Scalars['String']['output']>;
  /** Tax identifier (IF), if any. */
  taxId: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
  /** What it wants to achieve (رؤية الجمعية). */
  vision: Maybe<Scalars['String']['output']>;
};

/** A condition to be used against `Setting` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SettingCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `associationName` field. */
  associationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bankRib` field. */
  bankRib?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultAddress` field. */
  defaultAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `dueDays` field. */
  dueDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `firstReminderAfterDays` field. */
  firstReminderAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `foundedOn` field. */
  foundedOn?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `mandateEnd` field. */
  mandateEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `mandateStart` field. */
  mandateStart?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `mission` field. */
  mission?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `publicArrearsAfterDays` field. */
  publicArrearsAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `publicArrearsMinAmount` field. */
  publicArrearsMinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `publicArrearsRedAfterDays` field. */
  publicArrearsRedAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `publicArrearsSince` field. */
  publicArrearsSince?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `readingPhotoAlways` field. */
  readingPhotoAlways?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `receiptPhotoMinAmount` field. */
  receiptPhotoMinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `registrationAuthority` field. */
  registrationAuthority?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `registrationDate` field. */
  registrationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `registrationNumber` field. */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reminderEveryDays` field. */
  reminderEveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `shortName` field. */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `taxId` field. */
  taxId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `vision` field. */
  vision?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Setting` values. */
export type SettingConnection = {
  __typename?: 'SettingConnection';
  /** A list of edges which contains the `Setting` and cursor to aid in pagination. */
  edges: Array<Maybe<SettingEdge>>;
  /** A list of `Setting` objects. */
  nodes: Array<Maybe<Setting>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Setting` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Setting` edge in the connection. */
export type SettingEdge = {
  __typename?: 'SettingEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `Setting` at the end of the edge. */
  node: Maybe<Setting>;
};

/** A filter to be used against `Setting` object types. All fields are combined with a logical ‘and.’ */
export type SettingFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SettingFilter>>;
  /** Filter by the object’s `associationName` field. */
  associationName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bankRib` field. */
  bankRib?: InputMaybe<StringFilter>;
  /** Filter by the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultAddress` field. */
  defaultAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `dueDays` field. */
  dueDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstReminderAfterDays` field. */
  firstReminderAfterDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `foundedOn` field. */
  foundedOn?: InputMaybe<DateFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mandateEnd` field. */
  mandateEnd?: InputMaybe<DateFilter>;
  /** Filter by the object’s `mandateStart` field. */
  mandateStart?: InputMaybe<DateFilter>;
  /** Filter by the object’s `mission` field. */
  mission?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SettingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SettingFilter>>;
  /** Filter by the object’s `publicArrearsAfterDays` field. */
  publicArrearsAfterDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `publicArrearsMinAmount` field. */
  publicArrearsMinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `publicArrearsRedAfterDays` field. */
  publicArrearsRedAfterDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `publicArrearsSince` field. */
  publicArrearsSince?: InputMaybe<DateFilter>;
  /** Filter by the object’s `readingPhotoAlways` field. */
  readingPhotoAlways?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `receiptPhotoMinAmount` field. */
  receiptPhotoMinAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `registrationAuthority` field. */
  registrationAuthority?: InputMaybe<StringFilter>;
  /** Filter by the object’s `registrationDate` field. */
  registrationDate?: InputMaybe<DateFilter>;
  /** Filter by the object’s `registrationNumber` field. */
  registrationNumber?: InputMaybe<StringFilter>;
  /** Filter by the object’s `reminderEveryDays` field. */
  reminderEveryDays?: InputMaybe<IntFilter>;
  /** Filter by the object’s `shortName` field. */
  shortName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `taxId` field. */
  taxId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `vision` field. */
  vision?: InputMaybe<StringFilter>;
};

/** Methods to use when ordering `Setting`. */
export type SettingOrderBy =
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'ASSOCIATION_NAME_ASC'
  | 'ASSOCIATION_NAME_DESC'
  | 'BANK_RIB_ASC'
  | 'BANK_RIB_DESC'
  | 'CONTACT_PHONE_ASC'
  | 'CONTACT_PHONE_DESC'
  | 'DEFAULT_ADDRESS_ASC'
  | 'DEFAULT_ADDRESS_DESC'
  | 'DUE_DAYS_ASC'
  | 'DUE_DAYS_DESC'
  | 'EMAIL_ASC'
  | 'EMAIL_DESC'
  | 'FIRST_REMINDER_AFTER_DAYS_ASC'
  | 'FIRST_REMINDER_AFTER_DAYS_DESC'
  | 'FOUNDED_ON_ASC'
  | 'FOUNDED_ON_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MANDATE_END_ASC'
  | 'MANDATE_END_DESC'
  | 'MANDATE_START_ASC'
  | 'MANDATE_START_DESC'
  | 'MISSION_ASC'
  | 'MISSION_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PUBLIC_ARREARS_AFTER_DAYS_ASC'
  | 'PUBLIC_ARREARS_AFTER_DAYS_DESC'
  | 'PUBLIC_ARREARS_MIN_AMOUNT_ASC'
  | 'PUBLIC_ARREARS_MIN_AMOUNT_DESC'
  | 'PUBLIC_ARREARS_RED_AFTER_DAYS_ASC'
  | 'PUBLIC_ARREARS_RED_AFTER_DAYS_DESC'
  | 'PUBLIC_ARREARS_SINCE_ASC'
  | 'PUBLIC_ARREARS_SINCE_DESC'
  | 'READING_PHOTO_ALWAYS_ASC'
  | 'READING_PHOTO_ALWAYS_DESC'
  | 'RECEIPT_PHOTO_MIN_AMOUNT_ASC'
  | 'RECEIPT_PHOTO_MIN_AMOUNT_DESC'
  | 'REGISTRATION_AUTHORITY_ASC'
  | 'REGISTRATION_AUTHORITY_DESC'
  | 'REGISTRATION_DATE_ASC'
  | 'REGISTRATION_DATE_DESC'
  | 'REGISTRATION_NUMBER_ASC'
  | 'REGISTRATION_NUMBER_DESC'
  | 'REMINDER_EVERY_DAYS_ASC'
  | 'REMINDER_EVERY_DAYS_DESC'
  | 'SHORT_NAME_ASC'
  | 'SHORT_NAME_DESC'
  | 'TAX_ID_ASC'
  | 'TAX_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'VISION_ASC'
  | 'VISION_DESC';

/** Represents an update to a `Setting`. Fields that are set will be updated. */
export type SettingPatch = {
  /** Postal address of the association, printed on invoices and receipts. */
  address?: InputMaybe<Scalars['String']['input']>;
  associationName?: InputMaybe<Scalars['String']['input']>;
  /** Bank account (RIB) for transfers to the association. */
  bankRib?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Address given to a member or meter saved without a real one («غير متوفر», empty…). */
  defaultAddress?: InputMaybe<Scalars['String']['input']>;
  dueDays?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstReminderAfterDays?: InputMaybe<Scalars['Int']['input']>;
  foundedOn?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  /** End of the current committee's term: the weekly report warns 90 days before. */
  mandateEnd?: InputMaybe<Scalars['Date']['input']>;
  /** Start of the current committee's term. */
  mandateStart?: InputMaybe<Scalars['Date']['input']>;
  /** What the association exists for (رسالة الجمعية). */
  mission?: InputMaybe<Scalars['String']['input']>;
  publicArrearsAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** Optional: name a late payer only when the amount late beyond the threshold reaches this. 0 = any amount. */
  publicArrearsMinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Public late-payers image: names are shown in red after this many days on the public list, black before. */
  publicArrearsRedAfterDays?: InputMaybe<Scalars['Int']['input']>;
  /** Optional: only bills from this billing month onwards count for naming. Empty = all bills. */
  publicArrearsSince?: InputMaybe<Scalars['Date']['input']>;
  /** true: every reading needs a photo of the meter; false: only unusual ones (readingCheck). */
  readingPhotoAlways?: InputMaybe<Scalars['Boolean']['input']>;
  /** Expenses of this amount or more need a receipt photo (dirhams). */
  receiptPhotoMinAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Authority that issued it (e.g. «قيادة …»). */
  registrationAuthority?: InputMaybe<Scalars['String']['input']>;
  /** Date of the declaration receipt. */
  registrationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Number of the declaration receipt (وصل الإيداع). */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  reminderEveryDays?: InputMaybe<Scalars['Int']['input']>;
  /** Short name used in messages (e.g. «جمعية بن عزوز»). */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Tax identifier (IF), if any. */
  taxId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** What it wants to achieve (رؤية الجمعية). */
  vision?: InputMaybe<Scalars['String']['input']>;
};

/** People a member pays shart for (imam services), one row each. New bills of the member's main meter copy the names; issued bills keep theirs. */
export type ShartPerson = {
  __typename?: 'ShartPerson';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** Reads a single `Member` that is related to this `ShartPerson`. */
  member: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  /** Name, or «شخص غير مسمى» for people billed without a name. */
  name: Scalars['String']['output'];
};

/**
 * A condition to be used against `ShartPerson` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ShartPersonCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ShartPerson` values. */
export type ShartPersonConnection = {
  __typename?: 'ShartPersonConnection';
  /** A list of edges which contains the `ShartPerson` and cursor to aid in pagination. */
  edges: Array<Maybe<ShartPersonEdge>>;
  /** A list of `ShartPerson` objects. */
  nodes: Array<Maybe<ShartPerson>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ShartPerson` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ShartPerson` edge in the connection. */
export type ShartPersonEdge = {
  __typename?: 'ShartPersonEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `ShartPerson` at the end of the edge. */
  node: Maybe<ShartPerson>;
};

/** A filter to be used against `ShartPerson` object types. All fields are combined with a logical ‘and.’ */
export type ShartPersonFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ShartPersonFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ShartPersonFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ShartPersonFilter>>;
};

/** An input for mutations affecting `ShartPerson` */
export type ShartPersonInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  memberId: Scalars['UUID']['input'];
  /** Name, or «شخص غير مسمى» for people billed without a name. */
  name: Scalars['String']['input'];
};

/** Methods to use when ordering `ShartPerson`. */
export type ShartPersonOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ASC'
  | 'CREATED_BY_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** Represents an update to a `ShartPerson`. Fields that are set will be updated. */
export type ShartPersonPatch = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Name, or «شخص غير مسمى» for people billed without a name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A filter to be used against UUID List fields. All fields are combined with a logical ‘and.’ */
export type UuidListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

/** All input for the `updateAccountTransfer` mutation. */
export type UpdateAccountTransferInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `AccountTransfer` being updated. */
  patch: AccountTransferPatch;
};

/** The output of our update `AccountTransfer` mutation. */
export type UpdateAccountTransferPayload = {
  __typename?: 'UpdateAccountTransferPayload';
  /** The `AccountTransfer` that was updated by this mutation. */
  accountTransfer: Maybe<AccountTransfer>;
  /** An edge for our `AccountTransfer`. May be used by Relay 1. */
  accountTransferEdge: Maybe<AccountTransferEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `AccountTransfer` mutation. */
export type UpdateAccountTransferPayloadAccountTransferEdgeArgs = {
  orderBy?: Array<AccountTransferOrderBy>;
};

/** All input for the `updateAssociationDocumentFileByDocumentIdAndPhotoId` mutation. */
export type UpdateAssociationDocumentFileByDocumentIdAndPhotoIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `AssociationDocumentFile` being updated. */
  patch: AssociationDocumentFilePatch;
  photoId: Scalars['UUID']['input'];
};

/** All input for the `updateAssociationDocumentFile` mutation. */
export type UpdateAssociationDocumentFileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `AssociationDocumentFile` being updated. */
  patch: AssociationDocumentFilePatch;
};

/** The output of our update `AssociationDocumentFile` mutation. */
export type UpdateAssociationDocumentFilePayload = {
  __typename?: 'UpdateAssociationDocumentFilePayload';
  /** The `AssociationDocumentFile` that was updated by this mutation. */
  associationDocumentFile: Maybe<AssociationDocumentFile>;
  /** An edge for our `AssociationDocumentFile`. May be used by Relay 1. */
  associationDocumentFileEdge: Maybe<AssociationDocumentFileEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `AssociationDocumentFile` mutation. */
export type UpdateAssociationDocumentFilePayloadAssociationDocumentFileEdgeArgs = {
  orderBy?: Array<AssociationDocumentFileOrderBy>;
};

/** All input for the `updateAssociationDocument` mutation. */
export type UpdateAssociationDocumentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `AssociationDocument` being updated. */
  patch: AssociationDocumentPatch;
};

/** The output of our update `AssociationDocument` mutation. */
export type UpdateAssociationDocumentPayload = {
  __typename?: 'UpdateAssociationDocumentPayload';
  /** The `AssociationDocument` that was updated by this mutation. */
  associationDocument: Maybe<AssociationDocument>;
  /** An edge for our `AssociationDocument`. May be used by Relay 1. */
  associationDocumentEdge: Maybe<AssociationDocumentEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `AssociationDocument` mutation. */
export type UpdateAssociationDocumentPayloadAssociationDocumentEdgeArgs = {
  orderBy?: Array<AssociationDocumentOrderBy>;
};

/** All input for the `updateCounterpartyByName` mutation. */
export type UpdateCounterpartyByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Counterparty` being updated. */
  patch: CounterpartyPatch;
};

/** All input for the `updateCounterparty` mutation. */
export type UpdateCounterpartyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Counterparty` being updated. */
  patch: CounterpartyPatch;
};

/** The output of our update `Counterparty` mutation. */
export type UpdateCounterpartyPayload = {
  __typename?: 'UpdateCounterpartyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Counterparty` that was updated by this mutation. */
  counterparty: Maybe<Counterparty>;
  /** An edge for our `Counterparty`. May be used by Relay 1. */
  counterpartyEdge: Maybe<CounterpartyEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `Counterparty` mutation. */
export type UpdateCounterpartyPayloadCounterpartyEdgeArgs = {
  orderBy?: Array<CounterpartyOrderBy>;
};

/** All input for the `updateDebt` mutation. */
export type UpdateDebtInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Debt` being updated. */
  patch: DebtPatch;
};

/** The output of our update `Debt` mutation. */
export type UpdateDebtPayload = {
  __typename?: 'UpdateDebtPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Debt` that was updated by this mutation. */
  debt: Maybe<Debt>;
  /** An edge for our `Debt`. May be used by Relay 1. */
  debtEdge: Maybe<DebtEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `Debt` mutation. */
export type UpdateDebtPayloadDebtEdgeArgs = {
  orderBy?: Array<DebtOrderBy>;
};

/** All input for the `updateFinancialAccount` mutation. */
export type UpdateFinancialAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `FinancialAccount` being updated. */
  patch: FinancialAccountPatch;
};

/** The output of our update `FinancialAccount` mutation. */
export type UpdateFinancialAccountPayload = {
  __typename?: 'UpdateFinancialAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `FinancialAccount` that was updated by this mutation. */
  financialAccount: Maybe<FinancialAccount>;
  /** An edge for our `FinancialAccount`. May be used by Relay 1. */
  financialAccountEdge: Maybe<FinancialAccountEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `FinancialAccount` mutation. */
export type UpdateFinancialAccountPayloadFinancialAccountEdgeArgs = {
  orderBy?: Array<FinancialAccountOrderBy>;
};

/** All input for the `updateFinancialOperation` mutation. */
export type UpdateFinancialOperationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `FinancialOperation` being updated. */
  patch: FinancialOperationPatch;
};

/** The output of our update `FinancialOperation` mutation. */
export type UpdateFinancialOperationPayload = {
  __typename?: 'UpdateFinancialOperationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `FinancialOperation` that was updated by this mutation. */
  financialOperation: Maybe<FinancialOperation>;
  /** An edge for our `FinancialOperation`. May be used by Relay 1. */
  financialOperationEdge: Maybe<FinancialOperationEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `FinancialOperation` mutation. */
export type UpdateFinancialOperationPayloadFinancialOperationEdgeArgs = {
  orderBy?: Array<FinancialOperationOrderBy>;
};

/** All input for the `updateInKindContribution` mutation. */
export type UpdateInKindContributionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `InKindContribution` being updated. */
  patch: InKindContributionPatch;
};

/** The output of our update `InKindContribution` mutation. */
export type UpdateInKindContributionPayload = {
  __typename?: 'UpdateInKindContributionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `InKindContribution` that was updated by this mutation. */
  inKindContribution: Maybe<InKindContribution>;
  /** An edge for our `InKindContribution`. May be used by Relay 1. */
  inKindContributionEdge: Maybe<InKindContributionEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `InKindContribution` mutation. */
export type UpdateInKindContributionPayloadInKindContributionEdgeArgs = {
  orderBy?: Array<InKindContributionOrderBy>;
};

/** All input for the `updateMember` mutation. */
export type UpdateMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Member` being updated. */
  patch: MemberPatch;
};

/** The output of our update `Member` mutation. */
export type UpdateMemberPayload = {
  __typename?: 'UpdateMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Member` that was updated by this mutation. */
  member: Maybe<Member>;
  /** An edge for our `Member`. May be used by Relay 1. */
  memberEdge: Maybe<MemberEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `Member` mutation. */
export type UpdateMemberPayloadMemberEdgeArgs = {
  orderBy?: Array<MemberOrderBy>;
};

/** All input for the `updateMeterByMeterNo` mutation. */
export type UpdateMeterByMeterNoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  meterNo: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Meter` being updated. */
  patch: MeterPatch;
};

/** All input for the `updateMeter` mutation. */
export type UpdateMeterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Meter` being updated. */
  patch: MeterPatch;
};

/** The output of our update `Meter` mutation. */
export type UpdateMeterPayload = {
  __typename?: 'UpdateMeterPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Meter` that was updated by this mutation. */
  meter: Maybe<Meter>;
  /** An edge for our `Meter`. May be used by Relay 1. */
  meterEdge: Maybe<MeterEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `Meter` mutation. */
export type UpdateMeterPayloadMeterEdgeArgs = {
  orderBy?: Array<MeterOrderBy>;
};

/** All input for the `updateOperationCategoryByName` mutation. */
export type UpdateOperationCategoryByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `OperationCategory` being updated. */
  patch: OperationCategoryPatch;
};

/** All input for the `updateOperationCategory` mutation. */
export type UpdateOperationCategoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `OperationCategory` being updated. */
  patch: OperationCategoryPatch;
};

/** The output of our update `OperationCategory` mutation. */
export type UpdateOperationCategoryPayload = {
  __typename?: 'UpdateOperationCategoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `OperationCategory` that was updated by this mutation. */
  operationCategory: Maybe<OperationCategory>;
  /** An edge for our `OperationCategory`. May be used by Relay 1. */
  operationCategoryEdge: Maybe<OperationCategoryEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `OperationCategory` mutation. */
export type UpdateOperationCategoryPayloadOperationCategoryEdgeArgs = {
  orderBy?: Array<OperationCategoryOrderBy>;
};

/** All input for the `updateProject` mutation. */
export type UpdateProjectInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `Project` being updated. */
  patch: ProjectPatch;
};

/** The output of our update `Project` mutation. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The `Project` that was updated by this mutation. */
  project: Maybe<Project>;
  /** An edge for our `Project`. May be used by Relay 1. */
  projectEdge: Maybe<ProjectEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};


/** The output of our update `Project` mutation. */
export type UpdateProjectPayloadProjectEdgeArgs = {
  orderBy?: Array<ProjectOrderBy>;
};

/** All input for the `updateSetting` mutation. */
export type UpdateSettingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Boolean']['input'];
  /** An object where the defined keys will be set on the `Setting` being updated. */
  patch: SettingPatch;
};

/** The output of our update `Setting` mutation. */
export type UpdateSettingPayload = {
  __typename?: 'UpdateSettingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `Setting` that was updated by this mutation. */
  setting: Maybe<Setting>;
  /** An edge for our `Setting`. May be used by Relay 1. */
  settingEdge: Maybe<SettingEdge>;
};


/** The output of our update `Setting` mutation. */
export type UpdateSettingPayloadSettingEdgeArgs = {
  orderBy?: Array<SettingOrderBy>;
};

/** All input for the `updateShartPerson` mutation. */
export type UpdateShartPersonInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ShartPerson` being updated. */
  patch: ShartPersonPatch;
};

/** The output of our update `ShartPerson` mutation. */
export type UpdateShartPersonPayload = {
  __typename?: 'UpdateShartPersonPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** The `ShartPerson` that was updated by this mutation. */
  shartPerson: Maybe<ShartPerson>;
  /** An edge for our `ShartPerson`. May be used by Relay 1. */
  shartPersonEdge: Maybe<ShartPersonEdge>;
};


/** The output of our update `ShartPerson` mutation. */
export type UpdateShartPersonPayloadShartPersonEdgeArgs = {
  orderBy?: Array<ShartPersonOrderBy>;
};

/** Invoices sent by WhatsApp (Cloud API) and their delivery status. Created by appSendMonthInvoices / appSendInvoiceWhatsapp. */
export type WhatsappMessage = {
  __typename?: 'WhatsappMessage';
  /** Reads a single `Bill` that is related to this `WhatsappMessage`. */
  bill: Maybe<Bill>;
  billId: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deliveredAt: Maybe<Scalars['Datetime']['output']>;
  error: Maybe<Scalars['String']['output']>;
  errorCode: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  kind: Scalars['String']['output'];
  /** Reads a single `Member` that is related to this `WhatsappMessage`. */
  member: Maybe<Member>;
  memberId: Scalars['UUID']['output'];
  queuedBy: Maybe<Scalars['String']['output']>;
  readAt: Maybe<Scalars['Datetime']['output']>;
  sentAt: Maybe<Scalars['Datetime']['output']>;
  status: WhatsappStatus;
  template: Maybe<Scalars['String']['output']>;
  toPhone: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  waMessageId: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `WhatsappMessage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WhatsappMessageCondition = {
  /** Checks for equality with the object’s `billId` field. */
  billId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `deliveredAt` field. */
  deliveredAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `error` field. */
  error?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `errorCode` field. */
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `kind` field. */
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `queuedBy` field. */
  queuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `readAt` field. */
  readAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `sentAt` field. */
  sentAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<WhatsappStatus>;
  /** Checks for equality with the object’s `template` field. */
  template?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `toPhone` field. */
  toPhone?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `waMessageId` field. */
  waMessageId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `WhatsappMessage` values. */
export type WhatsappMessageConnection = {
  __typename?: 'WhatsappMessageConnection';
  /** A list of edges which contains the `WhatsappMessage` and cursor to aid in pagination. */
  edges: Array<Maybe<WhatsappMessageEdge>>;
  /** A list of `WhatsappMessage` objects. */
  nodes: Array<Maybe<WhatsappMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WhatsappMessage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WhatsappMessage` edge in the connection. */
export type WhatsappMessageEdge = {
  __typename?: 'WhatsappMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']['output']>;
  /** The `WhatsappMessage` at the end of the edge. */
  node: Maybe<WhatsappMessage>;
};

/** A filter to be used against `WhatsappMessage` object types. All fields are combined with a logical ‘and.’ */
export type WhatsappMessageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WhatsappMessageFilter>>;
  /** Filter by the object’s `bill` relation. */
  bill?: InputMaybe<BillFilter>;
  /** A related `bill` exists. */
  billExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `billId` field. */
  billId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deliveredAt` field. */
  deliveredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `error` field. */
  error?: InputMaybe<StringFilter>;
  /** Filter by the object’s `errorCode` field. */
  errorCode?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `kind` field. */
  kind?: InputMaybe<StringFilter>;
  /** Filter by the object’s `member` relation. */
  member?: InputMaybe<MemberFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WhatsappMessageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WhatsappMessageFilter>>;
  /** Filter by the object’s `queuedBy` field. */
  queuedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `readAt` field. */
  readAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `sentAt` field. */
  sentAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<WhatsappStatusFilter>;
  /** Filter by the object’s `template` field. */
  template?: InputMaybe<StringFilter>;
  /** Filter by the object’s `toPhone` field. */
  toPhone?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `waMessageId` field. */
  waMessageId?: InputMaybe<StringFilter>;
};

/** Methods to use when ordering `WhatsappMessage`. */
export type WhatsappMessageOrderBy =
  | 'BILL_ID_ASC'
  | 'BILL_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELIVERED_AT_ASC'
  | 'DELIVERED_AT_DESC'
  | 'ERROR_ASC'
  | 'ERROR_CODE_ASC'
  | 'ERROR_CODE_DESC'
  | 'ERROR_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KIND_ASC'
  | 'KIND_DESC'
  | 'MEMBER_ID_ASC'
  | 'MEMBER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUEUED_BY_ASC'
  | 'QUEUED_BY_DESC'
  | 'READ_AT_ASC'
  | 'READ_AT_DESC'
  | 'SENT_AT_ASC'
  | 'SENT_AT_DESC'
  | 'TEMPLATE_ASC'
  | 'TEMPLATE_DESC'
  | 'TO_PHONE_ASC'
  | 'TO_PHONE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'WA_MESSAGE_ID_ASC'
  | 'WA_MESSAGE_ID_DESC';

export type WhatsappSendResult = {
  __typename?: 'WhatsappSendResult';
  /** Skipped: already queued or sent (not failed). */
  alreadySent: Scalars['Int']['output'];
  /** Skipped: no usable mobile number, or the member chose SMS / no messages. */
  noWhatsapp: Scalars['Int']['output'];
  /** Skipped: bill already paid. */
  paid: Scalars['Int']['output'];
  /** Invoices queued for sending. */
  queued: Scalars['Int']['output'];
};

export type WhatsappStatus =
  | 'DELIVERED'
  | 'FAILED'
  | 'QUEUED'
  | 'READ'
  | 'SENT';

/** A filter to be used against WhatsappStatus fields. All fields are combined with a logical ‘and.’ */
export type WhatsappStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WhatsappStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WhatsappStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WhatsappStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WhatsappStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WhatsappStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WhatsappStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WhatsappStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WhatsappStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WhatsappStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WhatsappStatus>>;
};

export type FinanceListsQueryVariables = Exact<{ [key: string]: never; }>;


export type FinanceListsQuery = { __typename?: 'Query', projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, name: string, status: ProjectStatus } | null> } | null, financialAccounts: { __typename?: 'FinancialAccountConnection', nodes: Array<{ __typename?: 'FinancialAccount', id: string, name: string, type: FinancialAccountType, currentBalance: string } | null> } | null, currentSettings: { __typename?: 'Setting', receiptPhotoMinAmount: string } | null };

export type OperationRowFragment = { __typename?: 'FinancialOperation', id: string, date: string, type: FinancialOperationType, amount: string, description: string | null, transferId: string | null, receiptPhoto: { __typename?: 'Photo', id: string, url: string, contentType: string } | null, project: { __typename?: 'Project', id: string, name: string } | null, account: { __typename?: 'FinancialAccount', id: string, name: string } | null, category: { __typename?: 'OperationCategory', id: string, name: string } | null };

export type OperationsQueryVariables = Exact<{
  filter?: InputMaybe<FinancialOperationFilter>;
  orderBy?: InputMaybe<Array<FinancialOperationOrderBy> | FinancialOperationOrderBy>;
  first: Scalars['Int']['input'];
}>;


export type OperationsQuery = { __typename?: 'Query', financialOperations: { __typename?: 'FinancialOperationConnection', totalCount: number, nodes: Array<{ __typename?: 'FinancialOperation', id: string, date: string, type: FinancialOperationType, amount: string, description: string | null, transferId: string | null, receiptPhoto: { __typename?: 'Photo', id: string, url: string, contentType: string } | null, project: { __typename?: 'Project', id: string, name: string } | null, account: { __typename?: 'FinancialAccount', id: string, name: string } | null, category: { __typename?: 'OperationCategory', id: string, name: string } | null } | null> } | null };

export type OperationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OperationQuery = { __typename?: 'Query', financialOperation: { __typename?: 'FinancialOperation', id: string, date: string, type: FinancialOperationType, amount: string, description: string | null, projectId: string | null, accountId: string, categoryId: string | null, counterpartyId: string | null, debtId: string | null, transferId: string | null, source: OperationSource, needsReview: boolean, reviewNote: string | null, receiptPhotoId: string | null, receiptPhoto: { __typename?: 'Photo', id: string, url: string, contentType: string } | null, project: { __typename?: 'Project', id: string, name: string, status: ProjectStatus } | null, category: { __typename?: 'OperationCategory', name: string } | null, counterparty: { __typename?: 'Counterparty', name: string } | null } | null };

export type CreateOperationMutationVariables = Exact<{
  operation: FinancialOperationInput;
}>;


export type CreateOperationMutation = { __typename?: 'Mutation', createFinancialOperation: { __typename?: 'CreateFinancialOperationPayload', financialOperation: { __typename?: 'FinancialOperation', id: string } | null } | null };

export type UpdateOperationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  patch: FinancialOperationPatch;
}>;


export type UpdateOperationMutation = { __typename?: 'Mutation', updateFinancialOperation: { __typename?: 'UpdateFinancialOperationPayload', financialOperation: { __typename?: 'FinancialOperation', id: string, date: string, type: FinancialOperationType, amount: string, description: string | null, projectId: string | null, accountId: string, receiptPhotoId: string | null } | null } | null };

export type DeleteOperationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteOperationMutation = { __typename?: 'Mutation', deleteFinancialOperation: { __typename?: 'DeleteFinancialOperationPayload', financialOperation: { __typename?: 'FinancialOperation', id: string } | null } | null };

export type CreateTransferMutationVariables = Exact<{
  transfer: AccountTransferInput;
}>;


export type CreateTransferMutation = { __typename?: 'Mutation', createAccountTransfer: { __typename?: 'CreateAccountTransferPayload', accountTransfer: { __typename?: 'AccountTransfer', id: string } | null } | null };

export const OperationRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperationRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialOperation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"transferId"}},{"kind":"Field","name":{"kind":"Name","value":"receiptPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OperationRowFragment, unknown>;
export const FinanceListsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FinanceLists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NAME_ASC"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receiptPhotoMinAmount"}}]}}]}}]} as unknown as DocumentNode<FinanceListsQuery, FinanceListsQueryVariables>;
export const OperationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Operations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialOperationFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialOperationOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialOperations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperationRow"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperationRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialOperation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"transferId"}},{"kind":"Field","name":{"kind":"Name","value":"receiptPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OperationsQuery, OperationsQueryVariables>;
export const OperationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Operation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialOperation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyId"}},{"kind":"Field","name":{"kind":"Name","value":"debtId"}},{"kind":"Field","name":{"kind":"Name","value":"transferId"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"needsReview"}},{"kind":"Field","name":{"kind":"Name","value":"reviewNote"}},{"kind":"Field","name":{"kind":"Name","value":"receiptPhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"receiptPhoto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"project"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"counterparty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<OperationQuery, OperationQueryVariables>;
export const CreateOperationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOperation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialOperationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFinancialOperation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"financialOperation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operation"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialOperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOperationMutation, CreateOperationMutationVariables>;
export const UpdateOperationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOperation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinancialOperationPatch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFinancialOperation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"patch"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patch"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialOperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"projectId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"receiptPhotoId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOperationMutation, UpdateOperationMutationVariables>;
export const DeleteOperationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOperation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFinancialOperation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"financialOperation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteOperationMutation, DeleteOperationMutationVariables>;
export const CreateTransferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTransfer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transfer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountTransferInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountTransfer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountTransfer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transfer"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTransferMutation, CreateTransferMutationVariables>;